import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import {
  DEFAULT_CURRENCY_CODE,
  DEMO_VALUE,
  NEW_ENTRY,
} from "../ds/App_Constants";
import { BaseBean, NodeData } from "../ds/client_ds.js";
import { ReportService } from "../services/ReportService.js";
import {
  AddressBean,
  AttributeCacheBean,
  CustomerBean,
  CustomerBillToBean,
  CustomerBillToSearchCriteria,
  CustomerCreditCardBean,
  CustomerCreditCardSearchCriteria,
  CustomerFabricStyleColorReferenceBean,
  CustomerFabricStyleReferenceBean,
  CustomerFabricStyleReferenceResultBean,
  CustomerSalesPersonCommissionBean,
  CustomerSalesPersonCommissionSearchCriteria,
  CustomerSearchCriteria,
  CustomerServiceBean,
  CustomerShipToBean,
  CustomerShipToSearchCriteria,
  CustomerUserBean,
  FabricStyleSearchCriteria,
  PageListBean,
  RestCustomerBillToListRequest,
  RestCustomerCreditCardsListRequest,
  RestCustomerEntityRequest,
  RestCustomerListRequest,
  RestCustomerModuleInitRequest,
  RestCustomerSalesPersonCommissionListRequest,
  RestCustomerShipToListRequest,
  RestEntityUnLockRequest,
  RestFabricStyleListBeanRequest,
  RestReadRequest,
  RestRoleListRequest,
  RoleSearchCriteria,
  UserBean,
  SalesAndPurchaseInquiryCriteriaBean,
  RestPageListBean,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  DataGridColumnDefinition,
  EditableDataGrid,
  InputCheckbox,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ShortCutMenuPopup,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import {
  PopupCustomerCurrentAgingInq,
  PopupCustomerMostRecentFabricsInq,
  PopupCustomerOnOrderInq,
  PopupCustomerSalesHistoryInq,
  PopupCustomerStatisticsInq,
  PopupCustomerTransactionsInq,
} from "../Inquiry/InquiryUtil.js";
import {
  PopupInvoiceModule,
  PopupPurchaseReceiptModule,
  PopupPurchaseOrderModule
} from "../modules/ModuleUtil.js";

import CustomTable from "../gui_components/CustomTable.js";
import { CustomerBillToLookupHandler } from "../lookup/CustomerBillToLookupHandler.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { RoleLookupHandler } from "../lookup/RoleLookupHandler.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { SecurityService } from "../services/SecurityService.js";
import { RestUserListRequest, UserSearchCriteria } from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import { UserService } from "../services/UserService.js";

import {
  BaseNodeBar,
  BaseNotification,
  BaseToolBar,
  ModuleToolBar,
} from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
import {
  MapPin,               // ← ShipTo
  CreditCard,           // ← BillTo
  Wallet,               // ← Credit Card
  Scissors,             // ← FabricStyle Mapping
  UserCog,              // ← Portal User
  UserRound,            // ← User
  Headphones,           // ← Customer Service
  AlignStartVertical,   // ← Header
  ShoppingCart,         // ← Sales Details
  UserCheck,
  UserRoundCog 
  
} from "lucide-react";
class CustomerList extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      customer_list: [],
      isCustomerListFormOpen: true,
      response: {},
      pageTitle: "Customer",
      modeText: "",
      customerData: new CustomerBean(),
      addressData: new AddressBean(),
      pageList: new PageListBean(),
      criteria: new CustomerSearchCriteria(),
      salesPersonPageListForAutoCompleteList: new Array(),
      currentPageNumber: 0,
      totalCount: 0,
      attributeCache: new AttributeCacheBean(),
      companyCode: "",
      warehouses: [],
      customerTypes: [],
      currencies: [],
      paymentMethods: [],
      paymentTerms: [],
      shipViaCodes: [],
      invoiceTemplates: [],
      countries: [],
      cities: [],
      states: [],
      arTypes: [],
      customerDeliveries: [],
      financialTypes: [],
      isCustomerEntryFormOpen: false,
      isShowNodes: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      shipTos: [],
      billTos: [],
      salesPersonList: [],
      salesPersons: [],
      creditCardList: [],
      fabricMappingList: [],
      division: [],
      zones: [],
      invoiceTemplate: [],
      services: [],
      isShipToListOpened: false,
      isShipToEntryOpened: false,
      isBillToListOpened: false,
      isBillToEntryOpened: false,
      isSalesPersonListOpened: false,
      isSalesPersonEntryOpened: false,
      isCreditCardListOpened: false,
      isCreditCardEntryOpened: false,
      isFabricMappingListOpened: false,
      isFabricMappingEntryOpened: false,
      isUserEntryFormOpened: false,
      isCustomerSalesFormOpened: false,
      currentShipTo: new CustomerShipToBean(),
      currentBillTo: new CustomerBillToBean(),
      shipToAddressData: new AddressBean(),
      billToAddressData: new AddressBean(),
      salesPersonData: new CustomerSalesPersonCommissionBean(),
      creditCardData: new CustomerCreditCardBean(),
      creditCardAddressData: new AddressBean(),
      fabricMappingData: new CustomerFabricStyleReferenceBean(),
      fabricMappingColorData: new CustomerFabricStyleColorReferenceBean(),
      selectedNodeKey: "headerView",
      isShowModuleSearchContainer: false,
      customerLookupHandler: null,
      isResetModule: false,
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,
      isResetView: true,
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      disabled: false,
      isfetched: false,
      isFocus: false,
      isFocusLookup: true,
      isDisableNodeFields: false,
      isMaintenanceMode: true,
      isDisabledFields: false,
      shipViaPageListForAutoCompleteList: new Array(),
      showAutoCompleteShipViaList: true,
      currencyCodePageListForAutoCompleteList: new Array(),
      showAutoCompleteCurrencyCodeList: true,
      showAutoCompleteCustomerTypeCodeList: true,
      customerTypeCodePageListForAutoCompleteList: new Array(),
      showAutoCompletePaymentTypeList: true,
      paymentTypePageListForAutoCompleteList: new Array(),
      showAutoCompletePaymentTermList: true,
      paymentTermPageListForAutoCompleteList: new Array(),
      divisionPageListForAutoCompleteList: new Array(),
      showAutoCompleteDivisionCodeList: true,
      showAutoCompleteInvoiceTemplateCodeList: true,
      invoiceTemplateCodePageListForAutoCompleteList: new Array(),
      showAutoCompleteCityList: true,
      cityPageListForAutoCompleteList: new Array(),
      showAutoCompleteCountryList: true,
      countryPageListForAutoCompleteList: new Array(),
      showAutoCompleteStateList: true,
      statePageListForAutoCompleteList: new Array(),
      showAutoCompleteCountryCodeList: true,
      countryCodePageListForAutoCompleteList: new Array(),
      isDisableCustomer: false,
      isDisableCustomerBillTo: false,
      isDisableCustomerSalesPerson: false,
      isDisableCustomerCreditCard: false,
      isDisableCustomerFabricStyle: false,
      isDisableFields: false,
      is3PL: false,
      isShowCustomerOnOrderInq: false,
      isShowCustomerTransactionsInq: false,
      isShowCustomerStatisticsInq: false,
      isShowCustomerSalesHistoryInq: false,
      isShowCustomerMostRecentFabricsInq: false,
      isCustomerCurrentAgingInq: false,
      moduleKeyCode: NEW_ENTRY,
      zones: [],
      showAutoCompleteZoneCodeList: true,
      zoneCodePageListForAutoCompleteList: new Array(),
      showAutoCompleteZoneList: true,
      zonePageListForAutoCompleteList: new Array(),
      userData: new CustomerUserBean(),
      userErrMsg: "",
      order: "asc",
      sortField: "",
      showAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
      serviceData: new CustomerServiceBean(),
      service_List: new Array(),
      isShowAutoCompleteServiceList: false,
      servicePageListForAutoCompleteList: new Array(),
      isReseted: false,
      isViewMode: false,
      isCustomerNotFound: false,
      isShowAutoCompleteRoleList: false,
      rolePageListForAutoCompleteList: new Array(),
      userList: new Array(),
      isShowSpecialUserButton: true,
      isShowSpecialUserPopup: false,
      isShowAlertLvl5: false,
      specialUserData: new CustomerUserBean(),



      showAutoCompleteShipToTypeList: true,
      shipToTypePageListForAutoCompleteList: new Array(),

      //  shipToTypeLookupHandler: null,

      shipToTypeList: [],


    };
    this.exitRef = React.createRef();
  }
  code = NEW_ENTRY;
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.state.criteria.companyCode = this.companyCode;
    this.state.pageList = new PageListBean();
    this.state.pageList.pageSize = 50;
    //set readOnly components using view Modes && disable toolbars
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });
    if (
      this.props.customerCode !== "" &&
      this.props.customerCode !== undefined
    ) {
      this.code = this.props.customerCode;
      this.editcustomer(this.props.customerCode);

      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isDisabledFields: true,
        isDisableNodeFields: true,
        isViewMode: false,
      });
    } else {
      this.addNewEntry();
    }
    this.loadCacheDetails();
    // this.initLookupHandlers();
    // this.loadCustomerList();
  }

  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({
      customerLookupHandler: customerLookupHandler,
    });
    let serviceLookupHandler = new GenericAttributeLookupHandler(
      this.state.services,
      "Service"
    );
    this.setState({ serviceLookupHandler: serviceLookupHandler });
  };
  loadCacheDetails = () => {
    const attribute_cache = { ...this.cache };

    let warehouses = ModuleUtils.isActiveAttribute(attribute_cache.warehouses);

    let division = ModuleUtils.isActiveAttribute(attribute_cache.customerDivisions);

    let zones = ModuleUtils.isActiveAttribute(attribute_cache.zones);


    //  let invoiceTemplate = ModuleUtils.isActiveAttribute(attribute_cache.invoiceTemplate)
    this.state.invoiceTemplate = [];
    let invoiceTemplate_value = attribute_cache.invoiceTemplates;
    let invoiceTemplate_temp = [];
    let invoiceTemplate = [];
    if (!isEmptyArray(invoiceTemplate_value))
      invoiceTemplate_value.map((dv) => {
        invoiceTemplate_temp.push(dv);
        invoiceTemplate = invoiceTemplate_temp.filter(
          (listData) => listData.isActive
        );
      });

    let customerTypes = ModuleUtils.isActiveAttribute(attribute_cache.customerTypes);

    let currencies = ModuleUtils.isActiveAttribute(attribute_cache.currencies);


    let paymentMethods = ModuleUtils.isActiveAttribute(attribute_cache.paymentMethods);


    let paymentTerms = ModuleUtils.isActiveAttribute(attribute_cache.paymentTerms);

    let shipViaCodes = ModuleUtils.isActiveAttribute(attribute_cache.shipVias);

    this.state.invoiceTemplates = [];
    let invoiceTemplates_value = attribute_cache.invoiceTemplates;
    let invoiceTemplates_temp = [];
    let invoiceTemplates = [];
    if (!isEmptyArray(invoiceTemplates_value))
      invoiceTemplates_value.map((shipViaCode) => {
        invoiceTemplates_temp.push(shipViaCode);
        invoiceTemplates = invoiceTemplates_temp.filter(
          (listData) => listData.isActive
        );
      });
    //  let invoiceTemplates = ModuleUtils.isActiveAttribute(attribute_cache.invoiceTemplates);

    let countries = ModuleUtils.isActiveAttribute(attribute_cache.countries)


    let states = ModuleUtils.isActiveAttribute(attribute_cache.states)


    let cities = ModuleUtils.isActiveAttribute(attribute_cache.cities)


    let salesPersons = ModuleUtils.isActiveAttribute(attribute_cache.salesPersons)


    let arTypes = ModuleUtils.isActiveAttribute(attribute_cache.arTypes)


    let customerDeliveries = ModuleUtils.isActiveAttribute(attribute_cache.customerDeliveries)


    let financialTypes = ModuleUtils.isActiveAttribute(attribute_cache.financialTypes)

    let services = ModuleUtils.isActiveAttribute(attribute_cache.serviceInfos)


    let shipToTypeList = ModuleUtils.isActiveAttribute(attribute_cache.shipToTypes);
    // if (!isEmptyArray(attribute_cache.shipToTypes)) {
    //   shipToTypeList.push(...attribute_cache.shipToTypes);
    // }

    this.setState({
      warehouses: warehouses,
      division: division,
      zones: zones,
      invoiceTemplate: invoiceTemplate,
      customerTypes: customerTypes,
      currencies: currencies,
      paymentMethods: paymentMethods,
      paymentTerms: paymentTerms,
      shipViaCodes: shipViaCodes,
      invoiceTemplates: invoiceTemplates,
      countries: countries,
      states: states,
      cities: cities,
      salesPersons: salesPersons,
      arTypes: arTypes,
      customerDeliveries: customerDeliveries,
      financialTypes: financialTypes,
      services: services,
      shipToTypeList: shipToTypeList,
    }, () => { this.initLookupHandlers() });

  };
  moduleCaption = "Customer Maintenance";
  filterCustomers = () => {
    this.loadPage(1);
  };
  resetFilterCustomers = () => {
    let criteria = new CustomerSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
    criteria.criteriakey = "";
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    //totalPages = totalPages.toFixed(1);
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadCustomerList();
  };
  loadCustomerListResponse = (response) => {
    let customerList = [];
    if (!isEmpty(response.data) && !isEmpty(response.data.customerPageList)) {
      customerList = response.data.customerPageList.customers;
      this.state.pageList.totalCount =
        response.data.customerPageList.totalCount;
      this.state.pageList.currentPage =
        response.data.customerPageList.currentPage;
    } else {
      customerList = new Array();
    }
    let loading = this.state.isLoading;
    loading = false;
    this.setState({
      isLoading: loading,
      customer_list: customerList,
    });
  };
  loadCustomerListError = (error) => {
    ShowError("Error : " + error);
  };

  loadCustomerList = () => {
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = this.state.pageList;
    cust_requestInput.searchCriteria = this.state.criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (SecurityAccessManager.CustomerMaintenanceView_IsAccessible()) {
      CustomerService.getCustomerPageList(
        cust_requestInput,
        this.loadCustomerListResponse,
        this.loadCustomerListError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = new Array();
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  addNewEntry = () => {
    let customerData = new CustomerBean();
    let userData = new CustomerUserBean();
    let addressData = new AddressBean();
    let isShowSaveButton = true;
    let pageTitle = this.moduleCaption + " - " + NEW_ENTRY;

    customerData.companyCode = this.companyCode;
    customerData.status = "A";
    customerData.shipViaCode = "01";
    if (this.state.is3PL) customerData.divisionCode = DEMO_VALUE;
    customerData.currencyCode = DEFAULT_CURRENCY_CODE;
    customerData.allocationPriority = 99;
    customerData.departmentCode = "$STD$";
    customerData.classCode = "$STD$";
    customerData.subClassCode = "$STD$";
    customerData.regionCode = "$STD$";
    customerData.districtCode = "$STD$";
    customerData.territoryCode = "$STD$";
    customerData.discountPercentage = (0.0).toFixed(2);
    customerData.markUpDownPercentage = (0.0).toFixed(2);
    customerData.damageAllowancePercentage = (0.0).toFixed(2);
    customerData.address = addressData;
    customerData.masterCustomerName = "";
    // if (this.state.is3PL) customerData.paymentTermsCode = DEMO_VALUE;
    customerData.isActive = true;

    if (!isEmptyString(this.state.moduleKeyCode))
      customerData.code = this.state.moduleKeyCode;
    else customerData.code = NEW_ENTRY;
    this.setState({
      customerData: customerData,
      addressData: addressData,
      userData: userData,
      pageTitle: pageTitle,
      customerListUpdateNeeded: false,
      isShowSaveButton: isShowSaveButton,
      service_List: new Array(),
    });
    this.state.customerData = customerData;
    this.openEntryForm();
  };

  openEntryForm = () => {
    this.clearError();
    this.closeAllNodeViews();
    let customerData = this.state.customerData;
    this.getNodeList();
    this.setState({
      isCustomerListFormOpen: false,
      isCustomerEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShipToEntryOpened: false,
      isShipToListOpened: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: true,
      isBillToEntryOpened: false,
      isBillToListOpened: false,
      isSalesPersonListOpened: false,
      isSalesPersonEntryOpened: false,
      isCreditCardListOpened: false,
      isCreditCardEntryOpened: false,
      isFabricMappingListOpened: false,
      isFabricMappingEntryOpened: false,
      isUserEntryFormOpened: false,
      isShowModuleSearchContainer: true,
      isCustomerSalesFormOpened: false,
      isResetView: false,
      isFocus: true,
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isCustomerListFormOpen: false,
        disabled: false,
        isDisableNodeFields: false,
        isDisabledFields: false,
      });
      if (this.state.isViewMode) {
        let pageTitle = this.moduleCaption + " - VIEW";
        this.setState({
          isDisabledFields: true,
          isDisableNodeFields: true,
          disabled: true,
          pageTitle: pageTitle,
        });
      }
    } else {
      this.setState({
        isDisabledFields: true,
        isDisableNodeFields: true,
        disabled: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
  };
  closeEntryForm = () => {
    this.closeAllNodeViews();
    // this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isCustomerListFormOpen: true,
      isCustomerEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShipToEntryOpened: false,
      isShipToListOpened: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isBillToEntryOpened: false,
      isBillToListOpened: false,
      isSalesPersonListOpened: false,
      isSalesPersonEntryOpened: false,
      isCreditCardListOpened: false,
      isCreditCardEntryOpened: false,
      isFabricMappingListOpened: false,
      isFabricMappingEntryOpened: false,
      isUserEntryFormOpened: false,
      isCustomerSalesFormOpened: false,
      moduleKeyCode: NEW_ENTRY,
      isShowModuleSearchContainer: false,
      isResetView: false,
      fabricMappingList: [],
      isMaintenanceMode: false,
      showAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
      isCustomerServiceOpened: false,
      isViewMode: false,
      isSpecialViewMode: false,
      isDisabledFields: false,
      isDisableNodeFields: false,
      disabled: false,
      isCustomerNotFound: false,
      isShowAutoCompleteRoleList: false,
      rolePageListForAutoCompleteList: new Array(),
    });
    // let customercode = this.state.customerData.code;
  };
  closeCustomerShipToEntryForm = () => {
    this.closeAllNodeViews();
    this.getNodeList();
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isShipToListOpened: true,
      isShipToEntryOpened: false,
      isShowSaveButton: false,
    });
    this.getNodeList();
  };
  closeCustomerBillToEntryForm = () => {
    this.closeAllNodeViews();
    this.getNodeList();
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isBillToListOpened: true,
      isBillToEntryOpened: false,
      isShowSaveButton: false,
    });
    this.getNodeList();
  };
  closeCustomerSalesPersonEntryForm = () => {
    this.closeAllNodeViews();
    this.getNodeList();
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isSalesPersonListOpened: true,
      isSalesPersonEntryOpened: false,
      isShowSaveButton: false,
    });
    this.getNodeList();
  };
  closeCustomerCreditCardEntryForm = () => {
    this.closeAllNodeViews();
    this.getNodeList();
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isCreditCardListOpened: true,
      isCreditCardEntryOpened: false,
      isShowSaveButton: false,
    });
    this.getNodeList();
  };
  closeCustomerFabricMappingEntryForm = () => {
    this.closeAllNodeViews();
    this.getNodeList();
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isFabricMappingListOpened: true,
      isFabricMappingEntryOpened: false,
      isShowSaveButton: false,
    });
    this.getNodeList();
  };
  closeAllNodeViews = () => {
    this.setState({
      isShowSaveButton: false,
      isCustomerEntryFormOpen: false,
      isCustomerListFormOpen: false,
      isShipToListOpened: false,
      isShipToEntryOpened: false,
      isBillToListOpened: false,
      isBillToEntryOpened: false,
      isSalesPersonListOpened: false,
      isSalesPersonEntryOpened: false,
      isCreditCardListOpened: false,
      isCreditCardEntryOpened: false,
      isFabricMappingListOpened: false,
      isFabricMappingEntryOpened: false,
      isUserEntryFormOpened: false,
      isCustomerSalesFormOpened: false,
      isCustomerServiceOpened: false,
    });
  };

  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let customerData = this.state.customerData;
    let headerObject = this.getEmptyView();
    let shipToObject = this.getEmptyView();
    let billToObject = this.getEmptyView();
    let salesPersonObject = this.getEmptyView();
    let creditCardObject = this.getEmptyView();
    let fabricMappingObject = this.getEmptyView();
    let userObject = this.getEmptyView();
    let customerServiceObject = this.getEmptyView();

    let shipToNode = new NodeData("shipToView", "ShipTo", shipToObject,<MapPin size={16} /> );
    let billToNode = new NodeData("billToView", "BillTo", billToObject,  <CreditCard size={16} /> );
    let salesPersonNode = new NodeData(
      "salesPersonView",
      "Sales Person",
      salesPersonObject,
      <UserCheck size={16} /> 
    );
    let creditCardNode = new NodeData(
      "creditCardView",
      "Credit Card",
      creditCardObject,
       <Wallet size={16} />    
    );
    let fabricMappingNode = new NodeData(
      "fabricMappingView",
      "FabricStyle Mapping",
      fabricMappingObject,
       <Scissors size={16} />  
    );
    let custUserNode = new NodeData();
    if (this.state.is3PL) {
      custUserNode = new NodeData("userView", "Portal User", userObject,<UserCog size={16} /> );
    } else {
      custUserNode = new NodeData("userView", "User", userObject,  <UserRound size={16} />);
    }
    let custServiceNode = new NodeData(
      "customerServiceView",
      "Customer Service",
      customerServiceObject,
      <Headphones  size={16} />
    );
    let headerNode = new NodeData("headerView", "Header", headerObject, <AlignStartVertical size={16} /> );
    let customerSalesDetails = new NodeData("cutomerSalesDetails", "Sales Details", headerObject,<ShoppingCart size={16} />);
    nodeList["headerView"] = headerNode;
    if (customerData.fetched) {
      nodeList["shipToView"] = shipToNode;
      nodeList["billToView"] = billToNode;
      nodeList["salesPersonView"] = salesPersonNode;
      nodeList["creditCardView"] = creditCardNode;

      // nodeList["fabricMappingView"] = fabricMappingNode;
      nodeList["userView"] = custUserNode;
      if (this.state.is3PL) {
        nodeList["customerServiceView"] = custServiceNode;
      } else {
        nodeList["fabricMappingView"] = fabricMappingNode;
      }
      if (!this.state.is3PL) {
        nodeList["cutomerSalesDetails"] = customerSalesDetails;
      }
    }
    this.setState({ nodeList: nodeList });
  };
  validateCustomerData = (customerData) => {
    let isValidCustomerData = false;
    let err_list = [];
    let errorMessage = "";
    if (customerData == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(customerData.description)) {
        let errMsg = "Customer Name is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(customerData.divisionCode)) {
        let errMsg = "Division is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(customerData.customerTypeCode)) {
        let errMsg = "Customer TypeCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(customerData.paymentTermsCode) && !this.state.is3PL) {
        let errMsg = "PaymentTermCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(customerData.shipViaCode)) {
        let errMsg = "ShipVia is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(customerData.currencyCode)) {
        let errMsg = "CurrencyCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidCustomerData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidCustomerData = true;
      this.setState({ isShowAlert: false });
    }
    return isValidCustomerData;
  };

  savecustomer = (customerData, addressData) => {
    customerData.address = addressData;
    this.setState({
      isLoading: true,
      loadingText: "Saving ..",
    });
    let isValidLine = false;
    isValidLine = this.validateCustomerData(customerData);
    if (isValidLine) {
      if (customerData.isFetched) {
        if (SecurityAccessManager.CustomerMaintenanceEdit_IsAccessible()) {
          CustomerService.updateCustomer(
            customerData,
            this.updateCustomerResponse,
            this.saveCustomerError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (SecurityAccessManager.CustomerMaintenanceCreate_IsAccessible()) {
          CustomerService.createCustomer(
            customerData,
            this.saveCustomerResponse,
            this.saveCustomerError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    } else {
      this.setState({
        isLoading: false,
        loadingText: "",
      });
    }
  };
  saveCustomerResponse = (response) => {

    this.handleresponse(response.data);
    let customerData = new CustomerBean();
    if (response.data != null) {
      if (response.data.success) {
        if (response.data.customer != null) {
          customerData = response.data.customer;
          let pageTitle = this.moduleCaption + " - EDIT";
          this.setState({
            customerData: customerData,
            pageTitle: pageTitle,
            isLoading: false,
            loadingText: "",
          });
          // this.code = customerData.code;
          // this.unLockCustomer(customerData.code);
          if (this.state.moduleKeyCode == NEW_ENTRY) {
            this.editcustomer(customerData.code);
          } else {
            this.code = response.data.customer.code;
            this.unLockCustomer(response.data.customer.code);
          }
        }
      }
    }
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  updateCustomerResponse = (response) => {

    let customerData = new CustomerBean();
    this.handleresponse(response.data);
    if (response.data != null) {
      if (response.data.success) {
        if (response.data.customer != null) {
          customerData = response.data.customer;
          let pageTitle = this.moduleCaption + " - EDIT";
          this.setState({
            customerData: customerData,
            pageTitle: pageTitle,
            isLoading: false,
            loadingText: "",
          });
          this.code = customerData.code;
          this.unLockCustomer(customerData.code);
          // this.editcustomer(customerData.code);
        }
      }
    }
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };

  saveCustomerError = (error) => {
    ShowError("Error:" + error);
  };

  saveCustomerShipTo = (customerShipToData, shipToAddressData) => {
    customerShipToData.address = shipToAddressData;
    if (customerShipToData.isFetched) {
      if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
        CustomerService.updateCustomerShipTo(
          customerShipToData,
          this.saveCustomerShipToResponse,
          this.saveCustomerShipToError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
        CustomerService.saveCustomerShipTo(
          customerShipToData,
          this.saveCustomerShipToResponse,
          this.saveCustomerShipToError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  saveCustomerShipToResponse = (response) => {
    this.handleresponse(response.data);

    if (response.data.success) {
      this.clearError();
      this.closeCustomerShipToEntryForm();
      this.readandsetShiptoListView();
    }
  };
  saveCustomerShipToError = (error) => {
    ShowError("Error:" + error);
  };

  saveCustomerBillTo = (customerBillToData, billToAddressData) => {
    customerBillToData.address = billToAddressData;
    if (customerBillToData.isFetched) {
      if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
        CustomerService.updateCustomerBillTo(
          customerBillToData,
          this.saveCustomerBillToResponse,
          this.saveCustomerBillToError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
        CustomerService.saveCustomerBillTo(
          customerBillToData,
          this.saveCustomerBillToResponse,
          this.saveCustomerBillToError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  saveCustomerBillToResponse = (response) => {
    this.handleresponse(response.data);

    if (response.data.success) {
      this.clearError();
      this.closeCustomerBillToEntryForm();
      this.readandsetBilltoListView();
    }
  };

  saveCustomerBillToError = (error) => {
    ShowError("Error:" + error);
  };

  saveCustomerSalesPerson = (customerSalesPersonData) => {
    if (
      customerSalesPersonData.salesPersonCode != null &&
      !isEmptyString(customerSalesPersonData.salesPersonCode)
    ) {
      if (customerSalesPersonData.isFetched) {
        if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
          CustomerService.updateCustomerSalesPersonCommission(
            customerSalesPersonData,
            this.saveCustomerSalesPersonResponse,
            this.saveCustomerSalesPersonError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
          CustomerService.saveCustomerSalesPersonCommission(
            customerSalesPersonData,
            this.saveCustomerSalesPersonResponse,
            this.saveCustomerSalesPersonError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    } else {
      let errMsg = "SalesPerson Code is Required";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  saveCustomerSalesPersonResponse = (response) => {
    this.handleresponse(response.data);

    if (response.data.success) {
      //this.componentDidMount();
      this.clearError();
      this.closeCustomerSalesPersonEntryForm();
      this.readandsetSalesPersonListView();
    }
  };

  saveCustomerSalesPersonError = (error) => {
    ShowError("Error:" + error);
  };

  validateCreditCard = (cardData) => {
    let isValidCard = false;
    let err_list = [];
    let errorMessage = "";
    if (cardData == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(cardData.cardNumber)) {
        let errMsg = "CardNumber is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(cardData.cardType)) {
        let errMsg = "CardType is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(cardData.expiryMonth)) {
        let errMsg = "ExpiryMonth is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(cardData.expiryYear)) {
        let errMsg = "ExpiryYear is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidCard = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidCard = true;
      this.setState({ isShowAlert: false });
    }
    return isValidCard;
  };

  saveCustomerCreditCard = (customerCreditCardData, creditCardAddressData) => {
    customerCreditCardData.address = creditCardAddressData;
    let isValid = false;
    isValid = this.validateCreditCard(customerCreditCardData);
    if (isValid) {
      if (customerCreditCardData.isFetched) {
        if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
          CustomerService.updateCustomerCreditCard(
            customerCreditCardData,
            this.saveCustomerCreditCardResponse,
            this.saveCustomerCreditCardError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
          CustomerService.createCustomerCreditCard(
            customerCreditCardData,
            this.saveCustomerCreditCardResponse,
            this.saveCustomerCreditCardError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  saveCustomerCreditCardResponse = (response) => {
    this.handleresponse(response.data);

    if (response.data.success) {
      //this.componentDidMount();
      this.clearError();
      this.closeCustomerCreditCardEntryForm();
      this.readandsetCreditCardListView();
    }
  };

  saveCustomerCreditCardError = (error) => {
    ShowError("Error:" + error);
  };

  saveCustomerFabricMapping = (customerFabricMappingData) => {
    let request = new CustomerFabricStyleReferenceResultBean();
    request.companyCode = this.companyCode;
    request.customerFabricStyleReferences.push(customerFabricMappingData);
    let isLineExist = this.getFabricLinebyfabricStyleCode(
      customerFabricMappingData.fabricStyleCode
    );
    if (customerFabricMappingData.isFetched) {
      if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
        CustomerService.updateCustomerFabricStyleReferenceBean(
          request,
          this.saveCustomerFabricMappingResponse,
          this.saveCustomerSalesPersonError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (!isLineExist) {
        if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
          CustomerService.createCustomerFabricStyleReferenceBean(
            request,
            this.saveCustomerFabricMappingResponse,
            this.saveCustomerFabricMappingError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        let errMsg = "FabricCode is Already Exist";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  saveCustomerFabricMappingResponse = (response) => {
    this.handleresponse(response.data);

    if (response.data.success) {
      this.clearError();
      this.closeCustomerFabricMappingEntryForm();
      this.readandsetFabricMappingListView();
    }
  };

  saveCustomerFabricMappingError = (error) => {
    ShowError("Error:" + error);
  };

  save = () => {
    if (this.state.selectedNodeKey == "headerView") {
      this.savecustomer(this.state.customerData, this.state.addressData);
    } else if (this.state.selectedNodeKey == "shipToView") {
      this.saveCustomerShipTo(
        this.state.currentShipTo,
        this.state.shipToAddressData
      );
    } else if (this.state.selectedNodeKey == "billToView") {
      this.saveCustomerBillTo(
        this.state.currentBillTo,
        this.state.billToAddressData
      );
    } else if (this.state.selectedNodeKey == "salesPersonView") {
      this.saveCustomerSalesPerson(this.state.salesPersonData);
    } else if (this.state.selectedNodeKey == "creditCardView") {
      this.saveCustomerCreditCard(
        this.state.creditCardData,
        this.state.creditCardAddressData
      );
    } else if (this.state.selectedNodeKey == "fabricMappingView") {
      this.saveCustomerFabricMapping(this.state.fabricMappingData);
    } else if (this.state.selectedNodeKey == "userView") {
      this.saveUser();
    } else {
      this.savecustomer(this.state.customerData, this.state.addressData);
    }
  };
  createCustomerUserResponse = (response) => {
    this.handleresponse(response.data);
    if (
      response != null &&
      response.data != null &&
      response.data.isSuccess === true
    ) {
      this.setState({
        selectedNodeKey: "headerView",
        userData: new UserBean(),
        isCustomerEntryFormOpen: true,
        isCustomerListFormOpen: false,
        isShipToListOpened: false,
        isShipToEntryOpened: false,
        isBillToListOpened: false,
        isBillToEntryOpened: false,
        isSalesPersonListOpened: false,
        isSalesPersonEntryOpened: false,
        isCreditCardListOpened: false,
        isCreditCardEntryOpened: false,
        isFabricMappingListOpened: false,
        isFabricMappingEntryOpened: false,
        isUserEntryFormOpened: false,
        isCustomerSalesFormOpened: false,
        isCustomerServiceOpened: false,
      });
    }
  };

  saveUser = () => {
    const customer__data = this.state.customerData;
    const userData = this.state.userData;
    let isValid = false;
    isValid = this.validateUserData(userData);
    if (isValid) {
      if (!isEmpty(userData)) {
        userData.companyCode = this.companyCode;
        userData.customerCode = this.state.moduleKeyCode;

        if (customer__data.isMasterCustomer) {
          userData.loginType =
            LogicConstants.LOGIN_TYPE_SPECIAL_DATA_PORTAL_USER;
        }

        CustomerService.createCustomerUser(
          userData,
          this.createCustomerUserResponse,
          this.errorCallBack
        );
      }
    }
  };
  validateUserData = (userData) => {
    let isValidUser = false;
    let err_list = [];
    let errorMessage = "";

    if (userData == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(userData.firstName)) {
        let errMsg = "FirstName is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(userData.lastName)) {
        let errMsg = "LastName is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(userData.password)) {
        let errMsg = "Password is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(userData.confirmPassword)) {
        let errMsg = "Confirm Password is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (
        userData.password.toLowerCase() !=
        userData.confirmPassword.toLowerCase()
      ) {
        let errMsg = "confirmPassword must be same as Password";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (err_list.length > 0) {
        isValidUser = false;
        this.setState({
          alertMessage: err_list,
          alertType: "danger",
          isShowAlert: true,
          isShowAlertLvl5: true,
        });
      } else {
        isValidUser = true;
        this.setState({ isShowAlert: false });
      }
    }
    return isValidUser;
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  onChange = (e) => {
    let temp_customerdata = this.state.customerData;
    temp_customerdata[e.target.name] = e.target.value;

    let temp_addressData = this.state.addressData;
    if (
      e.target.name == "address1" ||
      e.target.name == "address2" ||
      e.target.name == "city" ||
      e.target.name == "state" ||
      e.target.name == "country" ||
      e.target.name == "zip" ||
      e.target.name == "mobilePhone" ||
      e.target.name == "phone1" ||
      e.target.name == "phone2" ||
      e.target.name == "contactPerson" ||
      e.target.name == "fax" ||
      e.target.name == "email" ||
      e.target.name == "website"
    ) {
      temp_addressData[e.target.name] = e.target.value;
    }
    this.setState({
      customerData: temp_customerdata,
      addressData: temp_addressData,
    });
  };
  onSalesPersonCodeChange = (e) => {
    let salesPersonCode = e.target.value;
    this.state.showAutoCompleteSalesPersonList = true;
    let temp_salesPersonData = this.state.salesPersonData;
    let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
    if (isEmpty(salesPersonCode)) {
      this.state.showAutoCompleteSalesPersonList = false;
      //let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      let temp_salesPersonData = this.state.salesPersonData;
      temp_salesPersonData.salesPersonCode = "";
      temp_salesPersonData.salesPersonName = "";
      temp_salesPersonData.commissionPercentage = 0;
      let suggestion = [];
      this.setState({
        showAutoCompleteSalesPersonList: false,
        salesPersonData: temp_salesPersonData,
        salesPersonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && salesPersonCode !== "") {
      this.readSalesPersonCodeBySearchString(salesPersonCode);
    }
    if (e.target.name == "salesPersonCode") {
      temp_salesPersonData["salesPersonCode"] = e.target.value;
      let salesPersonCode_List = this.state.salesPersons;
      salesPersonCode_List.map((salesPersonCode) => {
        if (salesPersonCode.salesPersonCode == e.target.value) {
          temp_salesPersonData["salesPersonCode"] = salesPersonCode.code;
          temp_salesPersonData["salesPersonName"] = salesPersonCode.description;
          this.setState({
            showAutoCompleteSalesPersonList: false,
          });
        }
      });
      if (this.state.salesPersonList != null) {
        this.state.salesPersonList.map((ln) => {
          if (ln.salesPersonCode == e.target.value) {
            temp_salesPersonData = ln;
          }
        });
      }
    }
    this.setState({ salesPersonData: temp_salesPersonData });
  };
  readSalesPersonCodeBySearchString(searchString) {
    this.state.showAutoCompleteSalesPersonList = true;
    let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
    this.setState({ showAutoCompleteSalesPersonList: showAutoCompleteList });
    let salesPersonData = this.state.salesPersons;
    let simpleAutoCompleteList = new Array();
    if (salesPersonData.length > 0 && salesPersonData != null) {
      salesPersonData.map((salesPersonDatas) => {
        let simpleItemBean = {
          code: salesPersonDatas.code,
          description: salesPersonDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteSalesPersonLists) =>
        simpleAutoCompleteSalesPersonLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      salesPersonPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  salesPersonEnterKeyEvent = (e) => {
    let temp_salesPersonData = this.state.salesPersonData;
    let salesPersonCode = e.target.value;
   // temp_salesPersonData["salesPersonCode"] = e.target.value;
    let salesPersonCode_List = this.state.salesPersons;
    let salesPersonCodeBean = null;
    salesPersonCode_List.map((salesPersonCode) => {
      if (salesPersonCode.code == e.target.value) {
        salesPersonCodeBean = salesPersonCode;
      }
    });

    
    if (!isEmpty(salesPersonCodeBean)) {
      let temp_salesPersonData = this.state.salesPersonData;
      temp_salesPersonData.salesPersonCode = salesPersonCodeBean.code;
      temp_salesPersonData.salesPersonName = salesPersonCodeBean.description;
      temp_salesPersonData.commissionPercentage = salesPersonCodeBean.commissionPercentage;
      if (this.state.salesPersonList != null) {
        this.state.salesPersonList.map((ln) => {
          if (ln.salesPersonCode == e.target.value) {
            temp_salesPersonData = ln;
          }
        });
      }
     
    }  else {
          temp_salesPersonData.salesPersonCode = "";
          temp_salesPersonData.salesPersonName = "";
          temp_salesPersonData.commissionPercentage = "";
      }
   



     this.setState({
        salesPersonData: temp_salesPersonData,
        salesPersonPageListForAutoCompleteList: new Array(),
      });
  };
  displayAutoCompleteSalesPersonList = (showAutoCompleteSalesPersonList) => {
    this.setState({
      showAutoCompleteSalesPersonList: showAutoCompleteSalesPersonList,
    });
  };
  onPaymentTypeBillToChange = (e) => {
    let paymentMethodCode = e.target.value;
    this.state.showAutoCompletePaymentTypeList = true;
    let temp_customerdata = this.state.currentBillTo;
    let showAutoCompleteList = this.state.showAutoCompletePaymentTypeList;
    if (isEmpty(paymentMethodCode)) {
      this.state.showAutoCompletePaymentTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompletePaymentTypeList;
      let temp_customerdata = this.state.currentBillTo;
      temp_customerdata.paymentMethodCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        currentBillTo: temp_customerdata,
        paymentTypePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && paymentMethodCode !== "") {
      this.readPaymentTypeCodeBySearchString(paymentMethodCode);
    }
    if (e.target.name == "paymentMethodCode") {
      temp_customerdata["paymentMethodCode"] = e.target.value;
      let paymentMethodCode_List = this.state.paymentMethods;
      paymentMethodCode_List.map((paymentMethodCode) => {
        if (paymentMethodCode.code == e.target.value) {
          temp_customerdata["paymentMethodCode"] = paymentMethodCode.code;
          this.state.showAutoCompletePaymentTypeList = false;
          let showAutoCompleteList = this.state.showAutoCompletePaymentTypeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ currentBillTo: temp_customerdata });
  };
  paymentTypeBillToEnterKeyEventHandler = (e) => {
    let temp_customerdata = this.state.currentBillTo;
    let paymentMethodCode = e.target.value;
    temp_customerdata["paymentMethodCode"] = e.target.value;
    let paymentMethodCode_List = this.state.paymentMethods;
    let paymentTypeCodeBean = null;
    paymentMethodCode_List.map((paymentMethodCode) => {
      if (paymentMethodCode.code == e.target.value) {
        paymentTypeCodeBean = paymentMethodCode;
      }
    });
    if (!isEmpty(paymentTypeCodeBean)) {
      let temp_customerdata = this.state.currentBillTo;
      temp_customerdata.paymentMethodCode = paymentTypeCodeBean.code;
      this.setState({
        currentBillTo: temp_customerdata,
        paymentTypePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onPaymentTypeChange = (e) => {
    let paymentMethodCode = e.target.value;
    this.state.showAutoCompletePaymentTypeList = true;
    let temp_customerdata = this.state.customerData;
    let showAutoCompleteList = this.state.showAutoCompletePaymentTypeList;
    if (isEmpty(paymentMethodCode)) {
      this.state.showAutoCompletePaymentTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompletePaymentTypeList;
      let temp_customerdata = this.state.customerData;
      temp_customerdata.paymentMethodCode = "";

      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        customerData: temp_customerdata,
        paymentTypePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && paymentMethodCode !== "") {
      this.readPaymentTypeCodeBySearchString(paymentMethodCode);
    }
    if (e.target.name == "paymentMethodCode") {
      temp_customerdata["paymentMethodCode"] = e.target.value;
      let paymentMethodCode_List = this.state.paymentMethods;
      paymentMethodCode_List.map((paymentMethodCode) => {
        if (paymentMethodCode.code == e.target.value) {
          temp_customerdata["paymentMethodCode"] = paymentMethodCode.code;

          this.state.showAutoCompletePaymentTypeList = false;
          let showAutoCompleteList = this.state.showAutoCompletePaymentTypeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ customerData: temp_customerdata });
  };
  readPaymentTypeCodeBySearchString(searchString) {
    let paymentTypeCodeData = this.state.paymentMethods;
    let simpleAutoCompleteList = new Array();
    if (paymentTypeCodeData.length > 0 && paymentTypeCodeData != null) {
      paymentTypeCodeData.map((paymentTypeCodeDatas) => {
        let simpleItemBean = {
          code: paymentTypeCodeDatas.code,
          description: paymentTypeCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletepaymentTypeCodeDataLists) =>
        simpleAutoCompletepaymentTypeCodeDataLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      paymentTypePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  paymentTypeEnterKeyEventHandler = (e) => {
    let temp_customerdata = this.state.customerData;
    let paymentMethodCode = e.target.value;
    temp_customerdata["paymentMethodCode"] = e.target.value;
    let paymentMethodCode_List = this.state.paymentMethods;
    let paymentTypeCodeBean = null;
    paymentMethodCode_List.map((paymentMethodCode) => {
      if (paymentMethodCode.code == e.target.value) {
        paymentTypeCodeBean = paymentMethodCode;
      }
    });
    if (!isEmpty(paymentTypeCodeBean)) {
      let temp_customerdata = this.state.customerData;
      temp_customerdata.paymentMethodCode = paymentTypeCodeBean.code;
      this.setState({
        customerData: temp_customerdata,
        paymentTypePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onPaymentTermBillToChange = (e) => {
    let paymentTermsCode = e.target.value;
    this.state.showAutoCompletePaymentTermList = true;
    let temp_customerdata = this.state.currentBillTo;
    let showAutoCompleteList = this.state.showAutoCompletePaymentTermList;
    if (isEmpty(paymentTermsCode)) {
      this.state.showAutoCompletePaymentTermList = false;
      let showAutoCompleteList = this.state.showAutoCompletePaymentTermList;
      let temp_customerdata = this.state.currentBillTo;
      temp_customerdata.paymentTermsCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        currentBillTo: temp_customerdata,
        paymentTermPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && paymentTermsCode !== "") {
      this.readPaymentTermCodeBySearchString(paymentTermsCode);
    }
    if (e.target.name == "paymentTermsCode") {
      temp_customerdata["paymentTermsCode"] = e.target.value;
      let paymentTermsCode_List = this.state.paymentTerms;
      paymentTermsCode_List.map((paymentTermsCode) => {
        if (paymentTermsCode.code == e.target.value) {
          temp_customerdata["paymentTermsCode"] = paymentTermsCode.code;

          this.state.showAutoCompletePaymentTermList = false;
          let showAutoCompleteList = this.state.showAutoCompletePaymentTermList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ currentBillTo: temp_customerdata });
  };
  paymentTermBillToEnterKeyEventHandler = (e) => {
    let temp_customerdata = this.state.currentBillTo;
    let paymentTermsCode = e.target.value;
    temp_customerdata["paymentTermsCode"] = e.target.value;
    let paymentTermsCode_List = this.state.paymentTerms;
    let paymentTermCodeBean = null;
    paymentTermsCode_List.map((paymentTermsCode) => {
      if (paymentTermsCode.code == e.target.value) {
        paymentTermCodeBean = paymentTermsCode;
      }
    });
    if (!isEmpty(paymentTermCodeBean)) {
      let temp_customerdata = this.state.currentBillTo;
      temp_customerdata.paymentTermsCode = paymentTermCodeBean.code;
      this.setState({
        currentBillTo: temp_customerdata,
        paymentTermPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onPaymentTermChange = (e) => {
    let paymentTermsCode = e.target.value;
    this.state.showAutoCompletePaymentTermList = true;
    let temp_customerdata = this.state.customerData;
    let showAutoCompleteList = this.state.showAutoCompletePaymentTermList;
    if (isEmpty(paymentTermsCode)) {
      this.state.showAutoCompletePaymentTermList = false;
      let showAutoCompleteList = this.state.showAutoCompletePaymentTermList;
      let temp_customerdata = this.state.customerData;
      temp_customerdata.paymentTermsCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        customerData: temp_customerdata,
        paymentTermPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && paymentTermsCode !== "") {
      this.readPaymentTermCodeBySearchString(paymentTermsCode);
    }
    if (e.target.name == "paymentTermsCode") {
      temp_customerdata["paymentTermsCode"] = e.target.value;
      let paymentTermsCode_List = this.state.paymentTerms;
      paymentTermsCode_List.map((paymentTermsCode) => {
        if (paymentTermsCode.code == e.target.value) {
          temp_customerdata["paymentTermsCode"] = paymentTermsCode.code;

          this.state.showAutoCompletePaymentTermList = false;
          let showAutoCompleteList = this.state.showAutoCompletePaymentTermList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ customerData: temp_customerdata });
  };
  readPaymentTermCodeBySearchString(searchString) {
    let paymentTermCodeData = this.state.paymentTerms;
    let simpleAutoCompleteList = new Array();
    if (paymentTermCodeData.length > 0 && paymentTermCodeData != null) {
      paymentTermCodeData.map((paymentTermCodeDatas) => {
        let simpleItemBean = {
          code: paymentTermCodeDatas.code,
          description: paymentTermCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletepaymentTypeCodeDataLists) =>
        simpleAutoCompletepaymentTypeCodeDataLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      paymentTermPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  paymentTermEnterKeyEventHandler = (e) => {
    let temp_customerdata = this.state.customerData;
    let paymentTermsCode = e.target.value;
    temp_customerdata["paymentTermsCode"] = e.target.value;
    let paymentTermsCode_List = this.state.paymentTerms;
    let paymentTermCodeBean = null;
    paymentTermsCode_List.map((paymentTermsCode) => {
      if (paymentTermsCode.code == e.target.value) {
        paymentTermCodeBean = paymentTermsCode;
      }
    });
    if (!isEmpty(paymentTermCodeBean)) {
      let temp_customerdata = this.state.customerData;
      temp_customerdata.paymentTermsCode = paymentTermCodeBean.code;
      this.setState({
        customerData: temp_customerdata,
        paymentTermPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onDivisionCodeChange = (e) => {
    let divisionCode = e.target.value;
    this.state.showAutoCompleteDivisionCodeList = true;
    let temp_customerdata = this.state.customerData;
    let showAutoCompleteList = this.state.showAutoCompleteDivisionCodeList;
    if (isEmpty(divisionCode)) {
      this.state.showAutoCompleteDivisionCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteDivisionCodeList;
      let temp_customerdata = this.state.customerData;
      temp_customerdata.divisionCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        customerData: temp_customerdata,
        divisionPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && divisionCode !== "") {
      this.readDivisionCodeBySearchString(divisionCode);
    }
    if (e.target.name == "divisionCode") {
      temp_customerdata["divisionCode"] = e.target.value;
      let divisionCode_List = this.state.division;
      divisionCode_List.map((divisionCode) => {
        if (divisionCode.code == e.target.value) {
          temp_customerdata["divisionCode"] = divisionCode.code;
          this.state.showAutoCompleteDivisionCodeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteDivisionCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ customerData: temp_customerdata });
  };
  readDivisionCodeBySearchString(searchString) {
    let divisionCodeData = this.state.division;
    let simpleAutoCompleteList = new Array();
    if (divisionCodeData.length > 0 && divisionCodeData != null) {
      divisionCodeData.map((divisionCodeDatas) => {
        let simpleItemBean = {
          code: divisionCodeDatas.code,
          description: divisionCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteDivisionCodeLists) =>
        simpleAutoCompleteDivisionCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ divisionPageListForAutoCompleteList: filteredSuggestions });
  }
  divisionEnterKeyEvent = (e) => {
    let temp_customerdata = this.state.customerData;
    let divisionCode = e.target.value;
    temp_customerdata["divisionCode"] = e.target.value;
    let divisionCode_List = this.state.division;
    let divisionCodeBean = null;
    divisionCode_List.map((divisionCode) => {
      if (divisionCode.code == e.target.value) {
        divisionCodeBean = divisionCode;
      }
    });
    if (!isEmpty(divisionCodeBean)) {
      let temp_customerdata = this.state.customerData;
      temp_customerdata.divisionCode = divisionCodeBean.code;
      this.setState({
        customerData: temp_customerdata,
        divisionPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onInvoiceTemplateBillToCodeChange = (e) => {
    let invoiceTemplateCode = e.target.value;
    this.state.showAutoCompleteInvoiceTemplateCodeList = true;
    let temp_customerdata = this.state.currentBillTo;
    let showAutoCompleteList =
      this.state.showAutoCompleteInvoiceTemplateCodeList;
    if (isEmpty(invoiceTemplateCode)) {
      this.state.showAutoCompleteInvoiceTemplateCodeList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteInvoiceTemplateCodeList;
      let temp_customerdata = this.state.currentBillTo;
      temp_customerdata.invoiceTemplateCode = "";

      let suggestion = [];
      this.setState({
        showAutoCompleteInvoiceTemplateCodeList: showAutoCompleteList,
        currentBillTo: temp_customerdata,
        invoiceTemplateCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && invoiceTemplateCode !== "") {
      this.readinvoiceTemplateCodeBySearchString(invoiceTemplateCode);
    }
    if (e.target.name == "invoiceTemplateCode") {
      temp_customerdata["invoiceTemplateCode"] = e.target.value;
      let invoiceTemplateCode_List = this.state.invoiceTemplates;
      invoiceTemplateCode_List.map((invoiceTemplateCode) => {
        if (invoiceTemplateCode.code == e.target.value) {
          temp_customerdata["invoiceTemplateCode"] = invoiceTemplateCode.code;

          this.state.showAutoCompleteInvoiceTemplateCodeList = false;
          let showAutoCompleteInvoiceTemplateCodeList =
            this.state.showAutoCompleteInvoiceTemplateCodeList;
          this.setState({
            showAutoCompleteInvoiceTemplateCodeList:
              showAutoCompleteInvoiceTemplateCodeList,
          });
        }
      });
    }
    this.setState({ currentBillTo: temp_customerdata });
  };
  invoiceTemplateBillToCodeEnterKeyEvent = (e) => {
    let temp_customerdata = this.state.currentBillTo;
    let invoiceTemplateCode = e.target.value;
    temp_customerdata["invoiceTemplateCode"] = e.target.value;
    let invoiceTemplateCode_List = this.state.invoiceTemplates;
    let invoiceTemplateCodeBean = null;
    invoiceTemplateCode_List.map((invoiceTemplateCode) => {
      if (invoiceTemplateCode.code == e.target.value) {
        invoiceTemplateCodeBean = invoiceTemplateCode;
      }
    });
    if (!isEmpty(invoiceTemplateCodeBean)) {
      let temp_customerdata = this.state.currentBillTo;
      temp_customerdata.invoiceTemplateCode = invoiceTemplateCodeBean.code;

      this.setState({
        currentBillTo: temp_customerdata,
        invoiceTemplateCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onInvoiceTemplateCodeChange = (e) => {
    let invoiceTemplateCode = e.target.value;
    this.state.showAutoCompleteInvoiceTemplateCodeList = true;
    let temp_customerdata = this.state.customerData;
    let showAutoCompleteList =
      this.state.showAutoCompleteInvoiceTemplateCodeList;
    if (isEmpty(invoiceTemplateCode)) {
      this.state.showAutoCompleteInvoiceTemplateCodeList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteInvoiceTemplateCodeList;
      let temp_customerdata = this.state.customerData;
      temp_customerdata.invoiceTemplateCode = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        customerData: temp_customerdata,
        invoiceTemplateCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && invoiceTemplateCode !== "") {
      this.readinvoiceTemplateCodeBySearchString(invoiceTemplateCode);
    }
    if (e.target.name == "invoiceTemplateCode") {
      temp_customerdata["invoiceTemplateCode"] = e.target.value;
      let invoiceTemplateCode_List = this.state.invoiceTemplates;
      invoiceTemplateCode_List.map((invoiceTemplateCode) => {
        if (invoiceTemplateCode.code == e.target.value) {
          temp_customerdata["invoiceTemplateCode"] = invoiceTemplateCode.code;

          this.state.showAutoCompleteInvoiceTemplateCodeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteInvoiceTemplateCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ customerData: temp_customerdata });
  };
  readinvoiceTemplateCodeBySearchString(searchString) {
    let invoiceTemplateCodeData = this.state.invoiceTemplates;
    let simpleAutoCompleteList = new Array();
    if (invoiceTemplateCodeData.length > 0 && invoiceTemplateCodeData != null) {
      invoiceTemplateCodeData.map((invoiceTemplateCodeDatas) => {
        let simpleItemBean = {
          code: invoiceTemplateCodeDatas.code,
          description: invoiceTemplateCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteinvoiceTemplateCodeLists) =>
        simpleAutoCompleteinvoiceTemplateCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      invoiceTemplateCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  invoiceTemplateCodeEnterKeyEvent = (e) => {
    let temp_customerdata = this.state.customerData;
    let invoiceTemplateCode = e.target.value;
    temp_customerdata["invoiceTemplateCode"] = e.target.value;
    let invoiceTemplateCode_List = this.state.invoiceTemplates;
    let invoiceTemplateCodeBean = null;
    invoiceTemplateCode_List.map((invoiceTemplateCode) => {
      if (invoiceTemplateCode.code == e.target.value) {
        invoiceTemplateCodeBean = invoiceTemplateCode;
      }
    });
    if (!isEmpty(invoiceTemplateCodeBean)) {
      let temp_customerdata = this.state.customerData;
      temp_customerdata.invoiceTemplateCode = invoiceTemplateCodeBean.code;

      this.setState({
        customerData: temp_customerdata,
        invoiceTemplateCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onCityCreditCardChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let temp_addressData = this.state.creditCardAddressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;

    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let temp_addressData = this.state.creditCardAddressData;
      temp_addressData.city = "";

      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        creditCardAddressData: temp_addressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readcityBySearchString(city);
    }
    if (e.target.name == "city") {
      temp_addressData["city"] = e.target.value;
      let city_List = this.state.cities;
      city_List.map((city) => {
        if (city.code == e.target.value) {
          temp_addressData["city"] = city.code;

          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ creditCardAddressData: temp_addressData });
  };
  cityCreditCardEnterKeyEvent = (e) => {
    let temp_addressData = this.state.creditCardAddressData;
    let city = e.target.value;

    temp_addressData["city"] = e.target.value;
    let city_List = this.state.cities;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.creditCardAddressData;
      temp_addressData.city = cityBean.code;

      this.setState({
        creditCardAddressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onCityBillToChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let temp_addressData = this.state.billToAddressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;

    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let temp_addressData = this.state.billToAddressData;
      temp_addressData.city = "";

      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        billToAddressData: temp_addressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readcityBySearchString(city);
    }
    if (e.target.name == "city") {
      temp_addressData["city"] = e.target.value;
      let city_List = this.state.cities;
      city_List.map((city) => {
        if (city.code == e.target.value) {
          temp_addressData["city"] = city.code;

          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ billToAddressData: temp_addressData });
  };
  cityBillToEnterKeyEvent = (e) => {
    let temp_addressData = this.state.billToAddressData;
    let city = e.target.value;
    temp_addressData["city"] = e.target.value;
    let city_List = this.state.cities;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.billToAddressData;
      temp_addressData.city = cityBean.code;

      this.setState({
        billToAddressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onCityShipToChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let temp_addressData = this.state.shipToAddressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;

    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let temp_addressData = this.state.shipToAddressData;
      temp_addressData.city = "";

      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        shipToAddressData: temp_addressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readcityBySearchString(city);
    }
    if (e.target.name == "city") {
      temp_addressData["city"] = e.target.value;
      let city_List = this.state.cities;
      city_List.map((city) => {
        if (city.code == e.target.value) {
          temp_addressData["city"] = city.code;

          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ shipToAddressData: temp_addressData });
  };
  cityShipToEnterKeyEvent = (e) => {
    let temp_addressData = this.state.shipToAddressData;
    let city = e.target.value;
    temp_addressData["city"] = e.target.value;
    let city_List = this.state.cities;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.shipToAddressData;
      temp_addressData.city = cityBean.code;

      this.setState({
        shipToAddressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onCityChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;
    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let temp_addressData = this.state.addressData;
      temp_addressData.city = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readcityBySearchString(city);
    }
    if (e.target.name == "city") {
      temp_addressData["city"] = e.target.value;
      let city_List = this.state.cities;
      city_List.map((city) => {
        if (city.code == e.target.value) {
          temp_addressData["city"] = city.code;

          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: temp_addressData });
  };
  readcityBySearchString(searchString) {
    let cityData = this.state.cities;
    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }
  cityEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    let city = e.target.value;

    temp_addressData["city"] = e.target.value;
    let city_List = this.state.cities;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.city = cityBean.code;

      this.setState({
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onCountryChange = (e) => {
    let shippingAccountCountryCode = e.target.value;
    this.state.showAutoCompleteCountryList = true;

    let temp_customerdata = this.state.customerData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryList;

    if (isEmpty(shippingAccountCountryCode)) {
      this.state.showAutoCompleteCountryList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryList;
      let temp_customerdata = this.state.customerData;
      temp_customerdata.shippingAccountCountryCode = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        customerData: temp_customerdata,
        countryPageListForAutoCompleteList: suggestion,
      });
    } else if (
      showAutoCompleteList === true &&
      shippingAccountCountryCode !== ""
    ) {
      this.readcountryBySearchString(shippingAccountCountryCode);
    }
    if (e.target.name == "shippingAccountCountryCode") {
      temp_customerdata["shippingAccountCountryCode"] = e.target.value;
      let country_List = this.state.countries;
      country_List.map((country) => {
        if (country.code == e.target.value) {
          temp_customerdata["shippingAccountCountryCode"] = country.code;

          this.state.showAutoCompleteCountryList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ customerData: temp_customerdata });
  };
  readcountryBySearchString(searchString) {
    let countryData = this.state.countries;
    let simpleAutoCompleteList = new Array();
    if (countryData.length > 0 && countryData != null) {
      countryData.map((countryDatas) => {
        let simpleItemBean = {
          code: countryDatas.code,
          description: countryDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecountryLists) =>
        simpleAutoCompletecountryLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ countryPageListForAutoCompleteList: filteredSuggestions });
  }
  countryEnterKeyEvent = (e) => {
    let temp_customerdata = this.state.customerData;
    let shippingAccountCountryCode = e.target.value;

    temp_customerdata["shippingAccountCountryCode"] = e.target.value;
    let country_List = this.state.countries;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let temp_customerdata = this.state.customerData;
      temp_customerdata.shippingAccountCountryCode = countryBean.code;

      this.setState({
        customerData: temp_customerdata,
        countryPageListForAutoCompleteList: new Array(),
        //showAutoCompleteList:showAutoCompleteList
      });
    }
  };
  onLocationShipToChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;

    let temp_customerdata = this.state.currentShipTo;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;

    if (isEmpty(locationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let temp_customerdata = this.state.currentShipTo;
      temp_customerdata.locationCode = "";

      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        currentShipTo: temp_customerdata,
        locationPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    if (e.target.name == "locationCode") {
      temp_customerdata["locationCode"] = e.target.value;
      let locationCode_List = this.state.warehouses;
      locationCode_List.map((locationCode) => {
        if (locationCode.code == e.target.value) {
          temp_customerdata["locationCode"] = locationCode.code;

          this.state.showAutoCompleteLocationList = false;
          let showAutoCompleteList = this.state.showAutoCompleteLocationList;
          this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
        }
      });
    }
    this.setState({ currentShipTo: temp_customerdata });
  };
  readLocationBySearchString(searchString) {
    let locationData = this.state.warehouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((locations) => {
        let simpleItemBean = {
          code: locations.code,
          description: locations.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ locationPageListForAutoCompleteList: filteredSuggestions });
  }
  locationShipToEnterKeyEventHandler = (e) => {
    let temp_customerdata = this.state.currentShipTo;
    let locationCode = e.target.value;
    temp_customerdata["locationCode"] = e.target.value;
    let locationCode_List = this.state.warehouses;
    let locationCodeBean = null;
    locationCode_List.map((locationCode) => {
      if (locationCode.code == e.target.value) {
        locationCodeBean = locationCode;
      }
    });
    if (!isEmpty(locationCodeBean)) {
      let temp_customerdata = this.state.currentShipTo;
      temp_customerdata.locationCode = locationCodeBean.code;

      this.setState({
        currentShipTo: temp_customerdata,
        locationPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteLocationList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
  };
  onCountryCodeCreditCardChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryCodeList = true;
    let temp_addressData = this.state.creditCardAddressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
      let temp_addressData = this.state.creditCardAddressData;
      temp_addressData.country = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        creditCardAddressData: temp_addressData,
        countryCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readcountryCodeBySearchString(country);
    }
    if (e.target.name == "country") {
      temp_addressData["country"] = e.target.value;
      let country_List = this.state.countries;
      country_List.map((country) => {
        if (country.code == e.target.value) {
          temp_addressData["country"] = country.code;

          this.state.showAutoCompleteCountryCodeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
          this.setState({
            showAutoCompleteCountryCodeList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ creditCardAddressData: temp_addressData });
  };
  countryCodeCreditCardEnterKeyEvent = (e) => {
    let temp_addressData = this.state.creditCardAddressData;
    let country = e.target.value;
    temp_addressData["country"] = e.target.value;
    let country_List = this.state.countries;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let temp_addressData = this.state.creditCardAddressData;
      temp_addressData.country = countryBean.code;

      this.setState({
        creditCardAddressData: temp_addressData,
        countryCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onCountryCodeBillToChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryCodeList = true;
    let temp_addressData = this.state.billToAddressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
      let temp_addressData = this.state.billToAddressData;
      temp_addressData.country = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        billToAddressData: temp_addressData,
        countryCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readcountryCodeBySearchString(country);
    }
    if (e.target.name == "country") {
      temp_addressData["country"] = e.target.value;
      let country_List = this.state.countries;
      country_List.map((country) => {
        if (country.code == e.target.value) {
          temp_addressData["country"] = country.code;

          this.state.showAutoCompleteCountryCodeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
          this.setState({
            showAutoCompleteCountryCodeList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ billToAddressData: temp_addressData });
  };
  countryCodeBillToEnterKeyEvent = (e) => {
    let temp_addressData = this.state.billToAddressData;
    let country = e.target.value;
    temp_addressData["country"] = e.target.value;
    let country_List = this.state.countries;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let temp_addressData = this.state.billToAddressData;
      temp_addressData.country = countryBean.code;
      this.setState({
        billToAddressData: temp_addressData,
        countryCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onCountryCodeShipToChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryCodeList = true;
    let temp_addressData = this.state.shipToAddressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
      let temp_addressData = this.state.shipToAddressData;
      temp_addressData.country = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        shipToAddressData: temp_addressData,
        countryCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readcountryCodeBySearchString(country);
    }
    if (e.target.name == "country") {
      temp_addressData["country"] = e.target.value;
      let country_List = this.state.countries;
      country_List.map((country) => {
        if (country.code == e.target.value) {
          temp_addressData["country"] = country.code;

          this.state.showAutoCompleteCountryCodeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
          this.setState({
            showAutoCompleteCountryCodeList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ shipToAddressData: temp_addressData });
  };
  countryCodeShipToEnterKeyEvent = (e) => {
    let temp_addressData = this.state.shipToAddressData;
    let country = e.target.value;

    temp_addressData["country"] = e.target.value;
    let country_List = this.state.countries;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let temp_addressData = this.state.shipToAddressData;
      temp_addressData.country = countryBean.code;

      this.setState({
        shipToAddressData: temp_addressData,
        countryCodePageListForAutoCompleteList: new Array(),
        //showAutoCompleteList:showAutoCompleteList
      });
    }
  };
  onCountryCodeChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryCodeList = true;

    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;

    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
      let temp_addressData = this.state.addressData;
      temp_addressData.country = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: temp_addressData,
        countryCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readcountryCodeBySearchString(country);
    }
    if (e.target.name == "country") {
      temp_addressData["country"] = e.target.value;
      let country_List = this.state.countries;
      country_List.map((country) => {
        if (country.code == e.target.value) {
          temp_addressData["country"] = country.code;

          this.state.showAutoCompleteCountryCodeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: temp_addressData });
  };
  readcountryCodeBySearchString(searchString) {
    let countryData = this.state.countries;
    let simpleAutoCompleteList = new Array();
    if (countryData.length > 0 && countryData != null) {
      countryData.map((countryDatas) => {
        let simpleItemBean = {
          code: countryDatas.code,
          description: countryDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecountryLists) =>
        simpleAutoCompletecountryLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      countryCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  countryCodeEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    let country = e.target.value;

    temp_addressData["country"] = e.target.value;
    let country_List = this.state.countries;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.country = countryBean.code;

      this.setState({
        addressData: temp_addressData,
        countryCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onStateCreditCardChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;

    let temp_addressData = this.state.creditCardAddressData;
    let showAutoCompleteList = this.state.showAutoCompleteStateList;

    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let temp_addressData = this.state.creditCardAddressData;
      temp_addressData.state = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        creditCardAddressData: temp_addressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readstateBySearchString(state);
    }
    if (e.target.name == "state") {
      temp_addressData["state"] = e.target.value;
      let state_List = this.state.states;
      state_List.map((state) => {
        if (state.code == e.target.value) {
          temp_addressData["state"] = state.code;

          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ creditCardAddressData: temp_addressData });
  };
  stateCreditCardEnterKeyEvent = (e) => {
    let temp_addressData = this.state.creditCardAddressData;
    let state = e.target.value;

    temp_addressData["state"] = e.target.value;
    let state_List = this.state.states;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.creditCardAddressData;
      temp_addressData.state = stateBean.code;

      this.setState({
        creditCardAddressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onStateBillToChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;

    let temp_addressData = this.state.billToAddressData;
    let showAutoCompleteList = this.state.showAutoCompleteStateList;

    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let temp_addressData = this.state.billToAddressData;
      temp_addressData.state = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        billToAddressData: temp_addressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readstateBySearchString(state);
    }
    if (e.target.name == "state") {
      temp_addressData["state"] = e.target.value;
      let state_List = this.state.states;
      state_List.map((state) => {
        if (state.code == e.target.value) {
          temp_addressData["state"] = state.code;

          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ billToAddressData: temp_addressData });
  };
  stateBillToEnterKeyEvent = (e) => {
    let temp_addressData = this.state.billToAddressData;
    let state = e.target.value;

    temp_addressData["state"] = e.target.value;
    let state_List = this.state.states;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.billToAddressData;
      temp_addressData.state = stateBean.code;

      this.setState({
        billToAddressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onStateShipToChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;

    let temp_addressData = this.state.shipToAddressData;
    let showAutoCompleteList = this.state.showAutoCompleteStateList;

    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let temp_addressData = this.state.shipToAddressData;
      temp_addressData.state = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        shipToAddressData: temp_addressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readstateBySearchString(state);
    }
    if (e.target.name == "state") {
      temp_addressData["state"] = e.target.value;
      let state_List = this.state.states;
      state_List.map((state) => {
        if (state.code == e.target.value) {
          temp_addressData["state"] = state.code;

          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ shipToAddressData: temp_addressData });
  };
  stateShipToEnterKeyEvent = (e) => {
    let temp_addressData = this.state.shipToAddressData;
    let state = e.target.value;

    temp_addressData["state"] = e.target.value;
    let state_List = this.state.states;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.shipToAddressData;
      temp_addressData.state = stateBean.code;

      this.setState({
        shipToAddressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
        //showAutoCompleteList:showAutoCompleteList
      });
    }
  };
  onStateChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;

    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteStateList;

    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let temp_addressData = this.state.addressData;
      temp_addressData.state = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: temp_addressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readstateBySearchString(state);
    }
    if (e.target.name == "state") {
      temp_addressData["state"] = e.target.value;
      let state_List = this.state.states;
      state_List.map((state) => {
        if (state.code == e.target.value) {
          temp_addressData["state"] = state.code;

          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: temp_addressData });
  };
  readstateBySearchString(searchString) {
    let stateData = this.state.states;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletestateLists) =>
        simpleAutoCompletestateLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ statePageListForAutoCompleteList: filteredSuggestions });
  }
  stateEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    let state = e.target.value;

    temp_addressData["state"] = e.target.value;
    let state_List = this.state.states;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.state = stateBean.code;

      this.setState({
        addressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onBillToChange = (e) => {
    let billToCode = e.target.value;
    this.state.showAutoCompleteBillToList = true;

    let temp_customerdata = this.state.currentShipTo;
    let showAutoCompleteList = this.state.showAutoCompleteBillToList;

    if (isEmpty(billToCode)) {
      this.state.showAutoCompleteBillToList = false;
      let showAutoCompleteList = this.state.showAutoCompleteBillToList;
      let temp_customerdata = this.state.currentShipTo;
      temp_customerdata.billToCode = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteBillToList: showAutoCompleteList,
        currentShipTo: temp_customerdata,
        billToPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "billToCode" &&
      showAutoCompleteList === true &&
      billToCode !== ""
    ) {
      //criteria["customerFirstNameStartsWith"] = e.target.value;
      this.readCustomerBillToBySearchString(e.target.value);
      //return;
    }
    if (e.target.name == "billToCode") {
      temp_customerdata["billToCode"] = e.target.value;
      let billToCode_List = this.state.billTos;
      billToCode_List.map((billToCode) => {
        if (billToCode.code == e.target.value) {
          temp_customerdata["billToCode"] = billToCode.code;

          this.state.showAutoCompleteBillToList = false;
          let showAutoCompleteList = this.state.showAutoCompleteBillToList;
          this.setState({ showAutoCompleteBillToList: showAutoCompleteList });
        }
      });
      this.setState({ currentShipTo: temp_customerdata });
    }
  };
  billToToEnterKeyEvent = (e) => {
    let temp_customerdata = this.state.currentShipTo;
    let billToCode = e.target.value;

    temp_customerdata["billToCode"] = e.target.value;
    let billToCodeList = this.state.billTos;
    let billToCodeBean = null;
    billToCodeList.map((billToCode) => {
      if (billToCodeList.code == e.target.value) {
        billToCodeBean = billToCode;
      }
    });
    if (!isEmpty(billToCodeBean)) {
      let temp_customerdata = this.state.currentShipTo;
      temp_customerdata.billToCode = billToCodeBean.code;
      this.setState({
        currentShipTo: temp_customerdata,
        billToPageListForAutoCompleteList: new Array(),
        //showAutoCompleteList:showAutoCompleteList
      });
    }
  };
  readCustomerBillToBySearchString(searchString) {
    let searchCriteria = new CustomerBillToSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCode = this.code;

    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;

    let cust_requestInput = new RestCustomerBillToListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    //readrestInput.code = vendorCode;
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      CustomerService.getCustomerBillToPageList(
        cust_requestInput,
        this.loadCustomerBillToListResponse,
        this.loadCustomerBillToListError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  }
  loadCustomerBillToListResponse = (response) => {
    let customerData = this.state.billTos;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      billToPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  loadCustomerBillToListError = (error) => {
    ShowError("Error : " + error);
  };
  displayAutoCompleteBillToList = (showAutoCompleteBillToList) => {
    this.setState({ showAutoCompleteBillToList: showAutoCompleteBillToList });
  };


  onShipToTypeChange = (e) => {
    let shipToType = e.target.value;
    this.state.showAutoCompleteShipToTypeList = true;
    let temp_Ship_To_Data = this.state.currentShipTo;
    let showAutoCompleteList = this.state.showAutoCompleteShipToTypeList;
    if (isEmpty(shipToType)) {
      this.state.showAutoCompleteShipToTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipToTypeList;
      let temp_Ship_To_Data = this.state.currentShipTo;
      temp_Ship_To_Data.shipToType = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        currentShipTo: temp_Ship_To_Data,
        shipToTypePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && shipToType !== "") {
      this.readShipToTypeBySearchString(shipToType);
    }
    if (e.target.name == "shipToType") {
      temp_Ship_To_Data["shipToType"] = e.target.value;
      let shipToType_List = this.state.shipToTypeList;
      shipToType_List.map((shipToType) => {
        if (shipToType.code == e.target.value) {
          temp_Ship_To_Data["shipToType"] = shipToType.code;

          this.state.showAutoCompleteShipToTypeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteShipToTypeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ currentShipTo: temp_Ship_To_Data });
  };
  readShipToTypeBySearchString(searchString) {
    let shipToTypeData = this.state.shipToTypeList;
    let simpleAutoCompleteList = new Array();
    if (shipToTypeData.length > 0 && shipToTypeData != null) {
      shipToTypeData.map((shipToTypeDatas) => {
        let simpleItemBean = {
          code: shipToTypeDatas.code,
          description: shipToTypeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteshipToTypeLists) =>
        simpleAutoCompleteshipToTypeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ shipToTypePageListForAutoCompleteList: filteredSuggestions });
  }
  shipToTypeEnterKeyEvent = (e) => {
    let temp_Ship_To_Data = this.state.currentShipTo;
    temp_Ship_To_Data["shipToType"] = e.target.value;
    let shipToType_List = this.state.shipToTypeList;
    let shipToTypeBean = null;
    shipToType_List.map((shipToType) => {
      if (shipToType.code == e.target.value) {
        shipToTypeBean = shipToType;
      }
    });
    if (!isEmpty(shipToTypeBean)) {
      let temp_Ship_To_Data = this.state.currentShipTo;
      temp_Ship_To_Data.shipToType = shipToTypeBean.code;
      this.setState({
        currentShipTo: temp_Ship_To_Data,
        shipToTypePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteShipToTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteShipToTypeList: showAutoCompleteList });
  };



  onShipViaBillToChange = (e) => {
    let shipViaCode = e.target.value;
    this.state.showAutoCompleteShipViaList = true;

    let temp_customerdata = this.state.currentBillTo;
    let showAutoCompleteList = this.state.showAutoCompleteShipViaList;

    if (isEmpty(shipViaCode)) {
      this.state.showAutoCompleteShipViaList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
      let temp_customerdata = this.state.currentBillTo;
      temp_customerdata.shipViaCode = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        currentBillTo: temp_customerdata,
        shipViaPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && shipViaCode !== "") {
      this.readShipViaBySearchString(shipViaCode);
    }
    if (e.target.name == "shipViaCode") {
      temp_customerdata["shipViaCode"] = e.target.value;
      let shipViaCode_List = this.state.shipViaCodes;
      shipViaCode_List.map((shipViaCode) => {
        if (shipViaCode.code == e.target.value) {
          temp_customerdata["shipViaCode"] = shipViaCode.code;

          this.state.showAutoCompleteShipViaList = false;
          let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
          this.setState({ showAutoCompleteShipViaList: showAutoCompleteList });
        }
      });
      this.setState({ currentBillTo: temp_customerdata });
    }
  };
  shipViaBillToEnterKeyEvent = (e) => {
    let temp_customerdata = this.state.currentBillTo;
    let shipViaCode = e.target.value;

    temp_customerdata["shipViaCode"] = e.target.value;
    let shipViaList = this.state.shipViaCodes;
    let shipViaBean = null;
    shipViaList.map((shipVia_List) => {
      if (shipVia_List.code == e.target.value) {
        shipViaBean = shipVia_List;
      }
    });
    if (!isEmpty(shipViaBean)) {
      let temp_customerdata = this.state.currentBillTo;
      temp_customerdata.shipViaCode = shipViaBean.code;
      this.setState({
        currentBillTo: temp_customerdata,
        shipViaPageListForAutoCompleteList: new Array(),
        //showAutoCompleteList:showAutoCompleteList
      });
    }
  };
  onShipViaShipToChange = (e) => {
    let shipViaCode = e.target.value;
    this.state.showAutoCompleteShipViaList = true;

    let temp_customerdata = this.state.currentShipTo;
    let showAutoCompleteList = this.state.showAutoCompleteShipViaList;

    if (isEmpty(shipViaCode)) {
      this.state.showAutoCompleteShipViaList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
      let temp_customerdata = this.state.currentShipTo;
      temp_customerdata.shipViaCode = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        currentShipTo: temp_customerdata,
        shipViaPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && shipViaCode !== "") {
      this.readShipViaBySearchString(shipViaCode);
    }
    if (e.target.name == "shipViaCode") {
      temp_customerdata["shipViaCode"] = e.target.value;
      let shipViaCode_List = this.state.shipViaCodes;
      shipViaCode_List.map((shipViaCode) => {
        if (shipViaCode.code == e.target.value) {
          temp_customerdata["shipViaCode"] = shipViaCode.code;

          this.state.showAutoCompleteShipViaList = false;
          let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
          this.setState({ showAutoCompleteShipViaList: showAutoCompleteList });
        }
      });
      this.setState({ currentShipTo: temp_customerdata });
    }
  };
  shipViaShipToEnterKeyEvent = (e) => {
    let temp_customerdata = this.state.currentShipTo;
    let shipViaCode = e.target.value;

    temp_customerdata["shipViaCode"] = e.target.value;
    let shipViaList = this.state.shipViaCodes;
    let shipViaBean = null;
    shipViaList.map((shipVia_List) => {
      if (shipVia_List.code == e.target.value) {
        shipViaBean = shipVia_List;
      }
    });
    if (!isEmpty(shipViaBean)) {
      let temp_customerdata = this.state.currentShipTo;
      temp_customerdata.shipViaCode = shipViaBean.code;
      this.setState({
        currentShipTo: temp_customerdata,
        shipViaPageListForAutoCompleteList: new Array(),
      });
    }
    this.setState({ currentShipTo: temp_customerdata });
  };

  onShipViaChange = (e) => {
    let shipViaCode = e.target.value;
    this.state.showAutoCompleteShipViaList = true;

    let temp_customerdata = this.state.customerData;
    let showAutoCompleteList = this.state.showAutoCompleteShipViaList;

    if (isEmpty(shipViaCode)) {
      this.state.showAutoCompleteShipViaList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
      let temp_customerdata = this.state.customerData;
      temp_customerdata.shipViaCode = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        customerData: temp_customerdata,
        shipViaPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && shipViaCode !== "") {
      this.readShipViaBySearchString(shipViaCode);
    }
    if (e.target.name == "shipViaCode") {
      temp_customerdata["shipViaCode"] = e.target.value;
      let shipViaCode_List = this.state.shipViaCodes;
      shipViaCode_List.map((shipViaCode) => {
        if (shipViaCode.code == e.target.value) {
          temp_customerdata["shipViaCode"] = shipViaCode.code;

          this.state.showAutoCompleteShipViaList = false;
          let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ customerData: temp_customerdata });
  };
  readShipViaBySearchString(searchString) {
    let shipViaCodeData = this.state.shipViaCodes;
    let simpleAutoCompleteList = new Array();
    if (shipViaCodeData.length > 0 && shipViaCodeData != null) {
      shipViaCodeData.map((shipViaCodeDatas) => {
        let simpleItemBean = {
          code: shipViaCodeDatas.code,
          description: shipViaCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteShipViaLists) =>
        simpleAutoCompleteShipViaLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ shipViaPageListForAutoCompleteList: filteredSuggestions });
  }
  shipViaEnterKeyEvent = (e) => {
    let temp_customerdata = this.state.customerData;
    let shipViaCode = e.target.value;

    temp_customerdata["shipViaCode"] = e.target.value;
    let shipViaList = this.state.shipViaCodes;
    let shipViaBean = null;
    shipViaList.map((shipVia_List) => {
      if (shipVia_List.code == e.target.value) {
        shipViaBean = shipVia_List;
      }
    });
    if (!isEmpty(shipViaBean)) {
      let temp_customerdata = this.state.customerData;
      temp_customerdata.shipViaCode = shipViaBean.code;

      this.setState({
        customerData: temp_customerdata,
        shipViaPageListForAutoCompleteList: new Array(),
        //showAutoCompleteList:showAutoCompleteList
      });
    }
  };
  displayAutoCompleteShipViaList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteShipViaList: showAutoCompleteList });
  };
  onCurrencyBillToChange = (e) => {
    let currencyCode = e.target.value;
    this.state.showAutoCompleteCurrencyCodeList = true;

    let temp_customerdata = this.state.currentBillTo;
    let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;

    if (isEmpty(currencyCode)) {
      this.state.showAutoCompleteCurrencyCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;
      let temp_customerdata = this.state.currentBillTo;
      temp_customerdata.currencyCode = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        currentBillTo: temp_customerdata,
        currencyCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && currencyCode !== "") {
      this.readCurrencyCodeBySearchString(currencyCode);
    }
    if (e.target.name == "currencyCode") {
      temp_customerdata["currencyCode"] = e.target.value;
      let currencyCode_List = this.state.currencies;
      currencyCode_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_customerdata["currencyCode"] = pdtType.code;

          this.state.showAutoCompleteCurrencyCodeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteCurrencyCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ currentBillTo: temp_customerdata });
  };
  currencyBillToEnterKeyEvent = (e) => {
    let temp_customerdata = this.state.currentBillTo;
    let currencyCode = e.target.value;

    temp_customerdata["currencyCode"] = e.target.value;
    let CurrencyCode_List = this.state.currencies;
    let CurrencyCodeBean = null;
    CurrencyCode_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        CurrencyCodeBean = pdtType;
      }
    });
    if (!isEmpty(CurrencyCodeBean)) {
      let temp_customerdata = this.state.currentBillTo;
      temp_customerdata.currencyCode = CurrencyCodeBean.code;

      this.setState({
        currentBillTo: temp_customerdata,
        currencyCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  validateCode = () => { };
  onCurrencyCodeChange = (e) => {
    let currencyCode = e.target.value;
    this.state.showAutoCompleteCurrencyCodeList = true;

    let temp_customerdata = this.state.customerData;
    let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;

    if (isEmpty(currencyCode)) {
      this.state.showAutoCompleteCurrencyCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;
      let temp_customerdata = this.state.customerData;
      temp_customerdata.currencyCode = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        customerData: temp_customerdata,
        currencyCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && currencyCode !== "") {
      this.readCurrencyCodeBySearchString(currencyCode);
    }
    if (e.target.name == "currencyCode") {
      temp_customerdata["currencyCode"] = e.target.value;
      let currencyCode_List = this.state.currencies;
      currencyCode_List.map((currencyCode) => {
        if (currencyCode.code == e.target.value) {
          temp_customerdata["currencyCode"] = currencyCode.code;

          this.state.showAutoCompleteCurrencyCodeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteCurrencyCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ customerData: temp_customerdata });
  };
  readCurrencyCodeBySearchString(searchString) {
    let currencyCodeData = this.state.currencies;
    let simpleAutoCompleteList = new Array();
    if (currencyCodeData.length > 0 && currencyCodeData != null) {
      currencyCodeData.map((currencyCodeDatas) => {
        let simpleItemBean = {
          code: currencyCodeDatas.code,
          description: currencyCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecurrencyCodeLists) =>
        simpleAutoCompletecurrencyCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      currencyCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  currencyCodeEnterKeyEvent = (e) => {
    let temp_customerdata = this.state.customerData;
    temp_customerdata["currencyCode"] = e.target.value;
    let CurrencyCode_List = this.state.currencies;
    let CurrencyCodeBean = null;
    CurrencyCode_List.map((currency) => {
      if (currency.code == e.target.value) {
        CurrencyCodeBean = currency;
      }
    });
    if (!isEmpty(CurrencyCodeBean)) {
      let temp_customerdata = this.state.customerData;
      temp_customerdata.currencyCode = CurrencyCodeBean.code;

      this.setState({
        customerData: temp_customerdata,
        currencyCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCurrencyList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCurrencyCodeList: showAutoCompleteList });
  };
  onCustomerTypeCodeChange = (e) => {
    let customerTypeCode = e.target.value;
    this.state.showAutoCompleteCustomerTypeCodeList = true;

    let temp_customerdata = this.state.customerData;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerTypeCodeList;

    if (isEmpty(customerTypeCode)) {
      this.state.showAutoCompleteCustomerTypeCodeList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteCustomerTypeCodeList;
      let temp_customerdata = this.state.customerData;
      temp_customerdata.customerTypeCode = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        customerData: temp_customerdata,
        customerTypeCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && customerTypeCode !== "") {
      this.readCustomerTypeCodeBySearchString(customerTypeCode);
    }
    if (e.target.name == "customerTypeCode") {
      temp_customerdata["customerTypeCode"] = e.target.value;
      let customerTypeCode_List = this.state.customerTypes;
      customerTypeCode_List.map((customerTypeCode) => {
        if (customerTypeCode.code == e.target.value) {
          temp_customerdata["customerTypeCode"] = customerTypeCode.code;

          this.state.showAutoCompleteCustomerTypeCodeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteCustomerTypeCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ customerData: temp_customerdata });
    //this.onShipToCodeChange(shipTo);
  };
  readCustomerTypeCodeBySearchString(searchString) {
    let customerTypeCodeData = this.state.customerTypes;
    let simpleAutoCompleteList = new Array();
    if (customerTypeCodeData.length > 0 && customerTypeCodeData != null) {
      customerTypeCodeData.map((customerTypeCodeDatas) => {
        let simpleItemBean = {
          code: customerTypeCodeDatas.code,
          description: customerTypeCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteCustomerTypeCodeLists) =>
        simpleAutoCompleteCustomerTypeCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      customerTypeCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  customerTypeCodeEnterKeyEvent = (e) => {
    let temp_customerdata = this.state.customerData;
    let customerTypeCode = e.target.value;

    temp_customerdata["customerTypeCode"] = e.target.value;
    let CustomerTypeCode_List = this.state.customerTypes;
    let CustomerTypeCodeBean = null;
    CustomerTypeCode_List.map((customerTypeCode) => {
      if (customerTypeCode.code == e.target.value) {
        CustomerTypeCodeBean = customerTypeCode;
      }
    });
    if (!isEmpty(CustomerTypeCodeBean)) {
      let temp_customerdata = this.state.customerData;
      temp_customerdata.customerTypeCode = CustomerTypeCodeBean.code;

      this.setState({
        customerData: temp_customerdata,
        customerTypeCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCustomerTypeCodeList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteCustomerTypeCodeList: showAutoCompleteList,
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteList: showAutoCompleteList });
  };
  displayAutoCompletePaymentTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompletePaymentTypeList: showAutoCompleteList });
  };
  displayAutoCompletePaymentTermList = (showAutoCompleteList) => {
    this.setState({ showAutoCompletePaymentTermList: showAutoCompleteList });
  };
  displayAutoCompleteDivisionCodeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteDivisionCodeList: showAutoCompleteList });
  };
  displayAutoCompleteInvoiceTemplateCodeList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteInvoiceTemplateCodeList: showAutoCompleteList,
    });
  };
  displayAutoCompleteCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };
  displayAutoCompleteCountryList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryList: showAutoCompleteList });
  };
  displayAutoCompleteCountryCodeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryCodeList: showAutoCompleteList });
  };
  displayAutoCompleteStateList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStateList: showAutoCompleteList });
  };
  onZoneCodeChange = (e) => {
    let zoneCode = e.target.value;
    this.state.showAutoCompleteZoneCodeList = true;
    let temp_customerdata = this.state.customerData;
    let showAutoCompleteList = this.state.showAutoCompleteZoneCodeList;
    if (isEmpty(zoneCode)) {
      this.state.showAutoCompleteZoneCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteZoneCodeList;
      let temp_customerdata = this.state.customerData;
      temp_customerdata.zoneCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteZoneCodeList: showAutoCompleteList,
        customerData: temp_customerdata,
        zoneCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && zoneCode !== "") {
      this.readZoneCodeBySearchString(zoneCode);
    }
    if (e.target.name == "zoneCode") {
      temp_customerdata["zoneCode"] = e.target.value;
      let zoneCode_List = this.state.zones;
      zoneCode_List.map((zones) => {
        if (zones.code == e.target.value) {
          temp_customerdata["zoneCode"] = zones.code;
          this.state.showAutoCompleteZoneCodeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteZoneCodeList;
          this.setState({
            showAutoCompleteZoneCodeList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ customerData: temp_customerdata });
  };
  readZoneCodeBySearchString(searchString) {
    let zones = this.state.zones;
    let simpleAutoCompleteList = new Array();
    if (zones.length > 0 && zones != null) {
      zones.map((zoneCode) => {
        let simpleItemBean = {
          code: zoneCode.code,
          description: zoneCode.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteZoneCodeLists) =>
        simpleAutoCompleteZoneCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      zoneCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  zoneCodeEnterKeyEvent = (e) => {
    let temp_customerdata = this.state.customerData;
    let zones = e.target.value;
    temp_customerdata.zoneCode = e.target.value;
    let zoneCodeList = this.state.zones;
    let zoneCodeBean = null;
    zoneCodeList.map((zoneCode_List) => {
      if (zoneCode_List.code == e.target.value) {
        zoneCodeBean = zoneCode_List;
      }
    });
    if (!isEmpty(zoneCodeBean)) {
      let temp_customerdata = this.state.customerData;
      temp_customerdata.zoneCode = zoneCodeBean.code;
      this.setState({
        customerData: temp_customerdata,
        zoneCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompletezoneCodeList = (showAutoCompleteZoneCodeList) => {
    this.setState({
      showAutoCompleteZoneCodeList: showAutoCompleteZoneCodeList,
    });
  };

  zoneOnChange = (e) => {
    let zoneCode = e.target.value;
    this.state.showAutoCompleteZoneList = true;
    let temp_currentShipToData = this.state.currentShipTo;
    let showAutoCompleteList = this.state.showAutoCompleteZoneList;
    if (isEmpty(zoneCode)) {
      this.state.showAutoCompleteZoneList = false;
      let showAutoCompleteList = this.state.showAutoCompleteZoneList;
      let temp_currentShipToData = this.state.currentShipTo;
      temp_currentShipToData.zoneCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteZoneList: showAutoCompleteList,
        currentShipTo: temp_currentShipToData,
        zonePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && zoneCode !== "") {
      this.readZoneBySearchString(zoneCode);
    }
    if (e.target.name == "zoneCode") {
      temp_currentShipToData["zoneCode"] = e.target.value;
      let zoneCode_List = this.state.zones;
      zoneCode_List.map((zones) => {
        if (zones.code == e.target.value) {
          temp_currentShipToData["zoneCode"] = zones.code;
          this.state.showAutoCompleteZoneList = false;
          let showAutoCompleteList = this.state.showAutoCompleteZoneList;
          this.setState({
            showAutoCompleteZoneList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ currentShipTo: temp_currentShipToData });
  };
  readZoneBySearchString(searchString) {
    let zones = this.state.zones;
    let simpleAutoCompleteList = new Array();
    if (zones.length > 0 && zones != null) {
      zones.map((zoneCode) => {
        let simpleItemBean = {
          code: zoneCode.code,
          description: zoneCode.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteZoneCodeLists) =>
        simpleAutoCompleteZoneCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      zonePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  zoneEnterKeyEvent = (e) => {
    let temp_currentShipToData = this.state.currentShipTo;
    let zones = e.target.value;
    temp_currentShipToData.zoneCode = e.target.value;
    let zoneCodeList = this.state.zones;
    let zoneCodeBean = null;
    zoneCodeList.map((zoneCode_List) => {
      if (zoneCode_List.code == e.target.value) {
        zoneCodeBean = zoneCode_List;
      }
    });
    if (!isEmpty(zoneCodeBean)) {
      let temp_currentShipToData = this.state.currentShipTo;
      temp_currentShipToData.zoneCode = zoneCodeBean.code;
      this.setState({
        currentShipTo: temp_currentShipToData,
        zonePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteZoneList = (showAutoCompleteZoneList) => {
    this.setState({
      showAutoCompleteZoneList: showAutoCompleteZoneList,
    });
  };

  /*********master customer lookup */

  onCustomerCodeChange = (e) => {
    let masterCustomerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempSalesOrderData = this.state.customerData;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(masterCustomerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let customerData = this.state.customerData;
      customerData.masterCustomerCode = "";
      customerData.masterCustomerName = "";

      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        customerData: customerData,
        customerPageListForAutoCompleteList: suggestion,
        isCustomerNotFound: false,
        isShowAlert: false,
        alertMessage: [],
      });
    } else if (
      e.target.name == "masterCustomerCode" &&
      showAutoCompleteList === true &&
      masterCustomerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempSalesOrderData[e.target.name] = e.target.value;
    this.setState({ customerData: tempSalesOrderData });
    // this.readCustomer(masterCustomerCode);
  };
  customerEnterKeyEventHandler = (e) => {
    let masterCustomerCode = e.target.value;
    this.readCustomer(masterCustomerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };

  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
      CustomerService.getCustomerPageList(
        cust_requestInput,
        this.readByCustomerCodeResponse,
        this.readByCustomerCodeError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  }
  readByCustomerCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.customerPageList != null &&
      !isEmptyArray(response.data.customerPageList.customers)
    ) {
      let customerData = response.data.customerPageList.customers;
      let simpleAutoCompleteList = new Array();
      if (customerData.length > 0 && customerData != null) {
        customerData.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        customerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  readByCustomerCodeError = (error) => {
    ShowError("Error : " + error);
  };
  foundCustomer = () => {
    let customerPageListForAutoCompleteList =
      this.state.customerPageListForAutoCompleteList;
    let customerData = this.state.customerData;

    let customerList = customerPageListForAutoCompleteList.filter(
      (ln) => ln.code == customerData.masterCustomerCode.toUpperCase()
    );
    let customerCode = "";
    customerList.map((ln) => {
      customerCode = ln.code;
    });

    if (customerData.masterCustomerCode.toUpperCase() != customerCode) {
      let errMsg = "InValid Customer";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isCustomerNotFound: true,
      });
    }
  };
  // customerOnKeydown = (e) => {
  //   let customerPageListForAutoCompleteList =
  //     this.state.customerPageListForAutoCompleteList;

  //   if (e.keyCode == 9) {
  //     let customerList = customerPageListForAutoCompleteList.filter(
  //       (ln) => ln.code == e.target.value.toUpperCase()
  //     );
  //     let customerCode = "";
  //     customerList.map((ln) => {
  //       customerCode = ln.code;
  //     });

  //     if (e.target.value.toUpperCase() != customerCode) {
  //       let errMsg = "InValid Customer";
  //       let errList = [];
  //       errList.push(errMsg);

  //       this.setState({
  //         alertMessage: errList,
  //         alertType: "danger",
  //         isShowAlert: true,
  //         isCustomerNotFound: true,
  //       });
  //     } else {
  //       this.readCustomer(customerCode);
  //     }
  //   }
  // };
  isFound = (data) => {
    var found = false;
    if (!data.isActive) {
      found = true;
    }

    return found;
  };
  readCustomerResponse = (response) => {
    if (response.data != null && response.data.customer != null) {
      let customers = response.data.customer;
      let customerData = this.state.customerData;
      if (customers != null) {
        customerData.masterCustomerCode = customers.code;
        customerData.masterCustomerName = customers.description;
        this.setState({ customerData: customerData });
        const isFound = this.isFound(customers);
        if (isFound) {
          this.setState({ isCustomerNotFound: true });
          // let errMsg = "Customer is InActive";
          // let errList = [];
          // errList.push(errMsg);

          // this.setState({
          //   alertMessage: errList,
          //   alertType: "danger",
          //   isShowAlert: true,
          // });
        } else {
          this.setState({
            isCustomerNotFound: false,
            isShowAlert: false,
            alertMessage: [],
          });
        }
      } else {
        this.setState({ isCustomerNotFound: true });
      }
    } else {
      this.foundCustomer();
    }
  };
  readCustomerError = (error) => {
    ShowError("Erro : " + error);
  };
  readCustomer = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    readrestInput.isLoadChildren = true;
    if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
      CustomerService.readCustomerWithChildren(
        readrestInput,
        this.readCustomerResponse,
        this.readCustomerError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  displayAutoCompleteCustomerList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  getHeaderView() {
    return (
      <CustomerEntryForm
        {...this.state}
        // customerOnKeydown={this.customerOnKeydown}
        onChange={this.onChange}
        onShipViaChange={this.onShipViaChange}
        shipViaEnterKeyEvent={this.shipViaEnterKeyEvent}
        displayAutoCompleteShipViaList={this.displayAutoCompleteShipViaList}
        onPaymentTypeChange={this.onPaymentTypeChange}
        paymentTypeEnterKeyEventHandler={this.paymentTypeEnterKeyEventHandler}
        displayAutoCompletePaymentTypeList={
          this.displayAutoCompletePaymentTypeList
        }
        onPaymentTermChange={this.onPaymentTermChange}
        paymentTermEnterKeyEventHandler={this.paymentTermEnterKeyEventHandler}
        displayAutoCompletePaymentTermList={
          this.displayAutoCompletePaymentTermList
        }
        onDivisionCodeChange={this.onDivisionCodeChange}
        divisionEnterKeyEvent={this.divisionEnterKeyEvent}
        displayAutoCompleteDivisionCodeList={
          this.displayAutoCompleteDivisionCodeList
        }
        onInvoiceTemplateCodeChange={this.onInvoiceTemplateCodeChange}
        invoiceTemplateCodeEnterKeyEvent={this.invoiceTemplateCodeEnterKeyEvent}
        displayAutoCompleteInvoiceTemplateCodeList={
          this.displayAutoCompleteInvoiceTemplateCodeList
        }
        onCityChange={this.onCityChange}
        cityEnterKeyEvent={this.cityEnterKeyEvent}
        displayAutoCompleteCityList={this.displayAutoCompleteCityList}
        onCountryChange={this.onCountryChange}
        countryEnterKeyEvent={this.countryEnterKeyEvent}
        displayAutoCompleteCountryList={this.displayAutoCompleteCountryList}
        displayAutoCompleteCountryCodeList={
          this.displayAutoCompleteCountryCodeList
        }
        onStateChange={this.onStateChange}
        onCountryCodeChange={this.onCountryCodeChange}
        countryCodeEnterKeyEvent={this.countryCodeEnterKeyEvent}
        stateEnterKeyEvent={this.stateEnterKeyEvent}
        displayAutoCompleteStateList={this.displayAutoCompleteStateList}
        onCurrencyCodeChange={this.onCurrencyCodeChange}
        currencyCodeEnterKeyEvent={this.currencyCodeEnterKeyEvent}
        displayAutoCompleteCurrencyList={this.displayAutoCompleteCurrencyList}
        onCustomerTypeCodeChange={this.onCustomerTypeCodeChange}
        customerTypeCodeEnterKeyEvent={this.customerTypeCodeEnterKeyEvent}
        displayAutoCompleteCustomerTypeCodeList={
          this.displayAutoCompleteCustomerTypeCodeList
        }
        showAutoCompleteCustomerTypeCodeList={
          this.state.showAutoCompleteCustomerTypeCodeList
        }
        showAutoCompleteCountryCodeList={
          this.state.showAutoCompleteCountryCodeList
        }
        customerTypeCodePageListForAutoCompleteList={
          this.state.customerTypeCodePageListForAutoCompleteList
        }
        showAutoCompleteCityList={this.state.showAutoCompleteCityList}
        displayAutoCompleteList={this.displayAutoCompleteList}
        showAutoCompleteCurrencyCodeList={
          this.state.showAutoCompleteCurrencyCodeList
        }
        currencyCodePageListForAutoCompleteList={
          this.state.currencyCodePageListForAutoCompleteList
        }
        showAutoCompleteShipViaList={this.state.showAutoCompleteShipViaList}
        shipViaPageListForAutoCompleteList={
          this.state.shipViaPageListForAutoCompleteList
        }
        showAutoCompletePaymentTypeList={
          this.state.showAutoCompletePaymentTypeList
        }
        paymentTypePageListForAutoCompleteList={
          this.state.paymentTypePageListForAutoCompleteList
        }
        showAutoCompletePaymentTermList={
          this.state.showAutoCompletePaymentTermList
        }
        paymentTermPageListForAutoCompleteList={
          this.state.paymentTermPageListForAutoCompleteList
        }
        showAutoCompleteDivisionCodeList={
          this.state.showAutoCompleteDivisionCodeList
        }
        divisionPageListForAutoCompleteList={
          this.state.divisionPageListForAutoCompleteList
        }
        showAutoCompleteInvoiceTemplateCodeList={
          this.state.showAutoCompleteInvoiceTemplateCodeList
        }
        invoiceTemplateCodePageListForAutoCompleteList={
          this.state.invoiceTemplateCodePageListForAutoCompleteList
        }
        isFocus={this.state.isFocus}
        setCustFocus={this.setCustFocus}
        customerData={this.state.customerData}
        addressData={this.state.addressData}
        warehouses={this.state.warehouses}
        customerTypes={this.state.customerTypes}
        currencies={this.state.currencies}
        paymentMethods={this.state.paymentMethods}
        paymentTerms={this.state.paymentTerms}
        countries={this.state.countries}
        states={this.state.states}
        cities={this.state.cities}
        closeEntryForm={this.closeEntryForm}
        saveCustomer={this.savecustomer}
        shipViaCodes={this.state.shipViaCodes}
        showCustomerList={this.showCustomerList}
        moduleCaption={this.moduleCaption}
        isReadOnlyOrDisabled={this.state.isReadOnlyOrDisabled}
        isfetched={this.state.isfetched}
        isResetModule={this.state.isResetModule}
        openCustomerOnOrderInq={this.openCustomerOnOrderInq}
        openCustomerTransactionsInq={this.openCustomerTransactionsInq}
        openCustomerStatisticsInq={this.openCustomerStatisticsInq}
        openCustomerSalesHistoryInq={this.openCustomerSalesHistoryInq}
        openCustomerMostRecentFabricsInq={this.openCustomerMostRecentFabricsInq}
        openCustomerCurrentAgingInq={this.openCustomerCurrentAgingInq}
        closeModalCallBack={this.closeModalCallBack}
        onArTypeCodeChange={this.onArTypeCodeChange}
        arTypeCodeEnterKeyEvent={this.arTypeCodeEnterKeyEvent}
        displayAutoCompleteArTypeCodeList={
          this.displayAutoCompleteArTypeCodeList
        }
        oncustomerDeliveryTypeCodeChange={this.oncustomerDeliveryTypeCodeChange}
        customerDeliveryTypeCodeEnterKeyEvent={
          this.customerDeliveryTypeCodeEnterKeyEvent
        }
        displayAutoCompletecustomerDeliveryTypeCodeList={
          this.displayAutoCompletecustomerDeliveryTypeCodeList
        }
        onfinancialTypeCodeChange={this.onfinancialTypeCodeChange}
        financialTypeCodeEnterKeyEvent={this.financialTypeCodeEnterKeyEvent}
        displayAutoCompletefinancialTypeCodeList={
          this.displayAutoCompletefinancialTypeCodeList
        }
        onLocationChange={this.onLocationChange}
        locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
        displayAutoCompleteLocationList={this.displayAutoCompleteLocationList}
        arTypes={this.state.arTypes}
        customerDeliveries={this.state.customerDeliveries}
        financialTypes={this.state.financialTypes}
        onZoneCodeChange={this.onZoneCodeChange}
        zoneCodeEnterKeyEvent={this.zoneCodeEnterKeyEvent}
        displayAutoCompletezoneCodeList={this.displayAutoCompletezoneCodeList}
        zones={this.state.zones}
        onCustomerCodeChange={this.onCustomerCodeChange}
        customerEnterKeyEventHandler={this.customerEnterKeyEventHandler}
        displayAutoCompleteCustomerList={this.displayAutoCompleteCustomerList}
        invoiceTemplates={this.state.invoiceTemplates}
        invoiceTemplate={this.state.invoiceTemplate}
      />
    );
  }
  unLockCustomer_withoutRead = (customerCode) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = customerCode;
    if (customerCode != NEW_ENTRY) {
      if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
        CustomerService.unLockCustomer(
          request,
          this.unlockCustomerWithoutReadResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };

  unlockCustomerWithoutReadResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
      } else {
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unLockCustomer = (customerCode) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = customerCode;
    if (customerCode != NEW_ENTRY) {
      if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
        CustomerService.unLockCustomer(
          request,
          this.unlockCustomerResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };

  unlockCustomerResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        this.editcustomer(this.code);
      } else {
        this.showErrorMessage(response.data);
      }
    }
  };

  editcustomer = (customerCode) => {
    let readrestInput = new RestCustomerModuleInitRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.customerCode = customerCode;
    readrestInput.isLoadChildren = true;
    let isLockRequired = false;
    if (this.props.isSpecialViewMode) {
      isLockRequired = false;
    } else {
      isLockRequired = NEW_ENTRY === customerCode ? false : true;
    }
    readrestInput.isLockRequired = isLockRequired;
    if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
      CustomerService.initCustomer(
        readrestInput,
        this.editCustomerResponse,
        this.editCustomerError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      disabled: true,
      isLoading: true,
    });
  };

  editCustomerResponse = (response) => {
    let errMsg = "";
    if (response.data != null) {
      if (response.data.lockResponse != null) {
        if (!isEmpty(response.data.lockResponse.errors)) {
          this.showErrorMessage(response.data.lockResponse);
          this.state.isViewMode = true;
        }
      }

      if (response.data.dependenciesResponse != null) {
        if (response.data.dependenciesResponse.dependenciesBean != null) {
          if (
            response.data.dependenciesResponse.dependenciesBean.billTos != null
          ) {
            let billTos =
              response.data.dependenciesResponse.dependenciesBean.billTos;
            this.setState({ billTos: billTos });
          }
          if (
            response.data.dependenciesResponse.dependenciesBean.shipTos != null
          ) {
            let shipTos =
              response.data.dependenciesResponse.dependenciesBean.shipTos;
            this.setState({ shipTos: shipTos });
          }
        }
      }
      if (response.data.customerResponse != null) {
        if (response.data.customerResponse.errors != null) {
          response.data.customerResponse.errors.map((err) => {
            errMsg = err.messageDescription;
          });
        }
        if (response.data.customerResponse.customer != null) {
          let customerData = response.data.customerResponse.customer;
          let moduleKeyCode = customerData.code;
          let addressData = customerData.address;
          let service_List = new Array();
          let pageTitle = this.moduleCaption + " - EDIT";
          this.state.customerData = customerData;
          if (response.data.success) this.clearError();
          if (
            !isEmptyArray(
              response.data.customerResponse.customer.customerServices
            )
          ) {
            service_List =
              response.data.customerResponse.customer.customerServices;
            this.setState({
              service_List: service_List,
            });
          }
          this.setState({
            customerData: customerData,
            // service_List : customerData.customerServices,
            addressData: addressData,
            pageTitle: pageTitle,
            moduleKeyCode: moduleKeyCode,
            service_List: service_List,
            selectedNodeKey: "headerView",
          });
          this.getNodeList();
          this.openEntryForm();
        } else {
          this.addNewEntry();
        }
      }
      if (response.data.customerResponse != null) {
        if (errMsg != "Customer [" + this.state.moduleKeyCode + "] Not read!") {
          this.showErrorMessage(response.data.customerResponse);
        }
      }
    }
    this.setState({ isLoading: false });
  };
  editCustomerError = (error) => {
    ShowError("Error : ", error);
  };

  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "headerView") {
      this.setCustomerHeaderView();
    } else if (selectedNode == "shipToView") {
      this.readandsetShiptoListView();
    } else if (selectedNode == "billToView") {
      this.readandsetBilltoListView();
    } else if (selectedNode == "salesPersonView") {
      this.readandsetSalesPersonListView();
    } else if (selectedNode == "creditCardView") {
      this.readandsetCreditCardListView();
    } else if (selectedNode == "fabricMappingView") {
      this.readandsetFabricMappingListView();
    } else if (selectedNode == "cutomerSalesDetails") {
      this.setCustomerSalesView();
    } else if (selectedNode == "userView") {
      this.setCustomerView();
    } else if (selectedNode == "customerServiceView") {
      this.setCustomerServiceView();
    }
  };
  setCustomerView = () => {
    this.closeAllNodeViews();
    this.getUserList();
    this.setState({
      isShowSaveButton: true,
      isCustomerEntryFormOpen: false,
      isCustomerListFormOpen: false,
      isShipToListOpened: false,
      isShipToEntryOpened: false,
      isBillToListOpened: false,
      isBillToEntryOpened: false,
      isSalesPersonListOpened: false,
      isSalesPersonEntryOpened: false,
      isUserEntryFormOpened: true,
      isCustomerServiceOpened: false,
      isCustomerSalesFormOpened: false,
    });
  };
  setCustomerSalesView = () => {
    this.closeAllNodeViews();
    this.getUserList();
    this.setState({
      isShowSaveButton: true,
      isCustomerEntryFormOpen: false,
      isCustomerListFormOpen: false,
      isShipToListOpened: false,
      isShipToEntryOpened: false,
      isBillToListOpened: false,
      isBillToEntryOpened: false,
      isSalesPersonListOpened: false,
      isSalesPersonEntryOpened: false,
      isUserEntryFormOpened: false,
      isCustomerServiceOpened: false,
      isCustomerSalesFormOpened: true,
    });
  };
  setCustomerServiceView = () => {
    this.closeAllNodeViews();
    this.getUserList();
    this.setState({
      isShowSaveButton: true,
      isCustomerEntryFormOpen: false,
      isCustomerListFormOpen: false,
      isShipToListOpened: false,
      isShipToEntryOpened: false,
      isBillToListOpened: false,
      isBillToEntryOpened: false,
      isSalesPersonListOpened: false,
      isSalesPersonEntryOpened: false,
      isUserEntryFormOpened: false,
      isCustomerServiceOpened: false,
      isCustomerSalesFormOpened: true,
    });
  };
  setCustomerServiceView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isCustomerEntryFormOpen: false,
      isCustomerListFormOpen: false,
      isShipToListOpened: false,
      isShipToEntryOpened: false,
      isBillToListOpened: false,
      isBillToEntryOpened: false,
      isSalesPersonListOpened: false,
      isSalesPersonEntryOpened: false,
      isUserEntryFormOpened: false,
      isCustomerSalesFormOpened: false,
      isCustomerServiceOpened: true,
    });
  };
  userOnChange = (e) => {
    let userData = this.state.userData;
    let userErrMsg = "";
    userData[e.target.name] = e.target.value;
    if (e.target.name == "confirmPassword") {
      if (userData.password.toLowerCase() != e.target.value.toLowerCase()) {
        userErrMsg = "confirmPassword must be same as Password";
      }
    }
    this.setState({
      userData: userData,
      userErrMsg: userErrMsg,
    });
  };
  onServiceChange = (e) => {
    let serviceData = this.state.serviceData;
    serviceData[e.target.name] = e.target.value;
    this.setState({
      serviceData: serviceData,
    });
  };
  // onServiceCodeChange = (e) => {
  //   let serviceData = this.state.serviceData;
  //   serviceData[e.target.name] = e.target.value;
  //   this.setState({
  //     serviceData: serviceData,
  //   });
  // };
  onServiceCodeChange = (e) => {
    let code = e.target.value;
    this.state.isShowAutoCompleteServiceList = true;
    let tempData = this.state.serviceData;
    let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
    if (isEmpty(code)) {
      this.state.isShowAutoCompleteServiceList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
      let tempData = this.state.serviceData;
      tempData.code = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteServiceList: showAutoCompleteList,
        serviceData: tempData,
        servicePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "code" &&
      showAutoCompleteList === true &&
      code !== ""
    ) {
      this.readServiceBySearchString(e.target.value);
      this.readService(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ serviceData: tempData });
  };
  serviceEnterKeyEventHandler = (e) => {
    this.readService(e.target.value);
    this.state.isShowAutoCompleteServiceList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
    this.setState({
      servicePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAutoCompleteServiceList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteServiceList: isShowAutoCompleteList,
    });
  };
  readServiceBySearchString = (searchString) => {
    let service_Data = this.state.services;
    let simpleAutoCompleteList = new Array();
    if (service_Data.length > 0 && service_Data != null) {
      service_Data.map((obj) => {
        let serviceBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(serviceBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      servicePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readService = (code) => {
    let tempData = this.state.serviceData;
    let serviceBean = null;
    let service_Data = null;
    this.state.services.map((ln) => {
      if (ln.code === code) {
        serviceBean = ln;
        service_Data = new BaseBean();
        service_Data.code = ln.code;
        service_Data.description = ln.description;
      }
    });
    if (!isEmpty(serviceBean)) {
      tempData.code = serviceBean.code;
      tempData.description = serviceBean.description;
      tempData.price = serviceBean.price;
      tempData.quantity = serviceBean.quantity;
      // tempData.amount  = serviceBean.quantity * serviceBean.quantity;
      tempData.uomCode = serviceBean.uomCode;
      tempData.companyCode = serviceBean.companyCode;
      tempData.isActive = serviceBean.isActive;
      tempData.customerCode = this.state.customerData.code;
      this.state.isShowAutoCompleteServiceList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
      this.setState({
        serviceData: tempData,
        isShowAutoCompleteServiceList: showAutoCompleteList,
      });
    }
  };
  editService = (e, val, rowData) => {
    if (e.detail === 1) this.setState({ serviceData: { ...rowData } });
  };
  deleteService = (e, val, rowData) => {
    if (e.detail === 1) {
      const customerData = { ...this.state.customerData };
      const service_List = [...this.state.service_List];
      var index = service_List.indexOf(rowData);
      if (index > -1) {
        service_List.splice(index, 1);
      }
      customerData.customerServices = service_List;
      this.setState({ customerData: customerData, service_List: service_List });
    }
  };
  clearService = (e) => {
    if (e.detail <= 1)
      this.setState({
        serviceData: new CustomerServiceBean(),
      });
  };
  validateServiceData = (data) => {
    let isValid = true;
    return isValid;
  };
  saveService = (e) => {
    if (e.detail <= 1) {
      const customerData = { ...this.state.customerData };
      const serviceData = { ...this.state.serviceData };
      const service_List = [...this.state.service_List];
      let isValid = false;
      isValid = this.validateServiceData(serviceData);
      if (isValid) {
        let isLineFound = false;
        if (!isEmptyArray(service_List)) {
          service_List.map((line, i) => {
            if (line.code == serviceData.code) {
              serviceData.isFetched = line.isFetched;
              service_List[i] = serviceData;
              isLineFound = true;
            }
          });
        }
        if (!isLineFound) {
          service_List.push(serviceData);
        }
        customerData.customerServices = service_List;
        this.setState({
          service_List: service_List,
          customerData: customerData,
        });
        this.clearService(e);
      }
    }
  };
  getUserView() {
    return (
      <UserEntryForm
        {...this.state}
        userOnChange={this.userOnChange}
        roleOnChange={this.roleOnChange}
        displayAutoCompleteRoleList={this.displayAutoCompleteRoleList}
        roleEnterKeyEventHandler={this.roleEnterKeyEventHandler}
      />
    );
  }
  getCustomerServiceView() {
    return (
      <CustomerServiceForm
        {...this.state}
        onServiceChange={this.onServiceChange}
        onServiceCodeChange={this.onServiceCodeChange}
        editService={this.editService}
        deleteService={this.deleteService}
        clearService={this.clearService}
        saveService={this.saveService}
        displayAutoCompleteServiceList={this.displayAutoCompleteServiceList}
        serviceEnterKeyEventHandler={this.serviceEnterKeyEventHandler}
      />
    );
  }
  getCustomerSalesView = () => {
    return (
      <div>
        <CustomerSalesDetails
          {...this.state}
          customerData={this.state.customerData}
        //saveVendorFactory={this.saveVendorFactory}
        />
      </div>
    );
  }
  readandsetShiptoListView = () => {
    this.closeAllNodeViews();
    let criteria = new CustomerShipToSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = this.state.customerData.code;
    let requestInput = new RestCustomerShipToListRequest();
    let pageList = new PageListBean();
    pageList.pageSize = 50;
    let currentPage = 1;
    if (currentPage == null || currentPage <= 0) {
      pageList.currentPage = 1;
    } else {
      pageList.currentPage = currentPage;
    }
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    CustomerService.getCustomerShipToPageList(
      requestInput,
      this.readandsetShiptoListViewResponse,
      this.errorCallBack
    );
  };
  readandsetShiptoListViewResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.customerShipToPageList != null) {
      let customer_list = new Array();
      customer_list = response.data.customerShipToPageList.customerShipTos;

      if (customer_list == null) {
        customer_list = new Array();
      }
      this.setState({ shipTos: customer_list });
      this.setShiptoListView();
    }
  };

  setShiptoListView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isCustomerEntryFormOpen: false,
      isCustomerListFormOpen: false,
      isShipToListOpened: true,
      isShipToEntryOpened: false,
      isBillToListOpened: false,
      isBillToEntryOpened: false,
      isSalesPersonListOpened: false,
      isSalesPersonEntryOpened: false,
      isUserEntryFormOpened: false,
      isCustomerServiceOpened: false,
      isCustomerSalesFormOpened: false,
    });
  };

  readandsetBilltoListView = () => {
    this.closeAllNodeViews();

    let criteria = new CustomerBillToSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = this.state.customerData.code;
    let requestInput = new RestCustomerBillToListRequest();
    let pageList = new PageListBean();
    pageList.pageSize = 50;
    let currentPage = 1;
    if (currentPage == null || currentPage <= 0) {
      pageList.currentPage = 1;
    } else {
      pageList.currentPage = currentPage;
    }
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    CustomerService.getCustomerBillToPageList(
      requestInput,
      this.readandsetBilltoListViewResponse,
      this.errorCallBack
    );
  };
  readandsetBilltoListViewResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.customerBillToPageList != null) {
      let customer_billTos_list = new Array();
      if (!isEmptyArray(response.data.customerBillToPageList.customerBillTos))
        customer_billTos_list =
          response.data.customerBillToPageList.customerBillTos;

      if (customer_billTos_list == null) {
        customer_billTos_list = new Array();
      }
      this.setState({ billTos: customer_billTos_list });
      this.setBilltoListView();
    }
  };

  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
    });
  };

  setBilltoListView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isCustomerEntryFormOpen: false,
      isCustomerListFormOpen: false,
      isShipToListOpened: false,
      isShipToEntryOpened: false,
      isBillToListOpened: true,
      isBillToEntryOpened: false,
      isSalesPersonListOpened: false,
      isSalesPersonEntryOpened: false,
      isUserEntryFormOpened: false,
      isCustomerServiceOpened: false,
      isCustomerSalesFormOpened: false,
    });
  };

  readandsetSalesPersonListView = () => {
    this.closeAllNodeViews();
    let criteria = new CustomerSalesPersonCommissionSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = this.state.customerData.code;
    let requestInput = new RestCustomerSalesPersonCommissionListRequest();
    let pageList = new PageListBean();
    pageList.pageSize = 50;
    let currentPage = 1;
    if (currentPage == null || currentPage <= 0) {
      pageList.currentPage = 1;
    } else {
      pageList.currentPage = currentPage;
    }
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
      CustomerService.getCustomerSalesPersonCommissionPageList(
        requestInput,
        this.getSalesPersonPageResponse,
        this.getSalesPersonPageError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getSalesPersonPageResponse = (response) => {
    let salesPerson_list = [];
    if (
      response.data.customerSalesPersonCommissionPageList != null &&
      response.data.customerSalesPersonCommissionPageList
        .customerSalesPersonCommissions != null
    ) {
      salesPerson_list =
        response.data.customerSalesPersonCommissionPageList
          .customerSalesPersonCommissions;
      this.setState({ salesPersonList: salesPerson_list });
      this.setSalesPersonListView();
    }
  };
  getSalesPersonPageError = (error) => {
    ShowError("error" + error);
  };
  setSalesPersonListView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isCustomerEntryFormOpen: false,
      isCustomerListFormOpen: false,
      isShipToListOpened: false,
      isShipToEntryOpened: false,
      isBillToListOpened: false,
      isBillToEntryOpened: false,
      isSalesPersonListOpened: true,
      isSalesPersonEntryOpened: false,
      isCreditCardListOpened: false,
      isCreditCardEntryOpened: false,
      isUserEntryFormOpened: false,
      isCustomerServiceOpened: false,
      isCustomerSalesFormOpened: false,
    });
  };
  readandsetCreditCardListView = () => {
    this.closeAllNodeViews();
    let criteria = new CustomerCreditCardSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = this.state.customerData.code;
    let requestInput = new RestCustomerCreditCardsListRequest();
    let pageList = new PageListBean();
    pageList.pageSize = 50;
    let currentPage = 1;
    if (currentPage == null || currentPage <= 0) {
      pageList.currentPage = 1;
    } else {
      pageList.currentPage = currentPage;
    }
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
      CustomerService.getCustomerCreditCardsPageList(
        requestInput,
        this.getCreditCardPageResponse,
        this.getCreditCardPageError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getCreditCardPageResponse = (response) => {
    let creditCard_list = [];
    if (
      response.data.creditCardPageList != null &&
      response.data.creditCardPageList.customerCreditCards != null
    ) {
      creditCard_list = response.data.creditCardPageList.customerCreditCards;
    }
    this.setState({ creditCardList: creditCard_list });

    this.setCreditCardListView();
  };
  getCreditCardPageError = (error) => {
    ShowError("error" + error);
  };
  setCreditCardListView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isCustomerEntryFormOpen: false,
      isCustomerListFormOpen: false,
      isShipToListOpened: false,
      isShipToEntryOpened: false,
      isBillToListOpened: false,
      isBillToEntryOpened: false,
      isSalesPersonListOpened: false,
      isSalesPersonEntryOpened: false,
      isCreditCardListOpened: true,
      isCreditCardEntryOpened: false,
      isUserEntryFormOpened: false,
      isCustomerServiceOpened: false,
      isCustomerSalesFormOpened: false,
    });
  };
  readandsetFabricMappingListView = () => {
    this.closeAllNodeViews();
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = this.state.customerData.code;

    if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
      CustomerService.readCustomerFabricStyleReferences(
        request,
        this.getFabricMappingPageResponse,
        this.getFabricMappingPageError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getFabricMappingPageResponse = (response) => {
    let fabricMapping_list = [];
    if (
      response.data.customerFabricStyleReferenceResult != null &&
      response.data.customerFabricStyleReferenceResult
        .customerFabricStyleReferences != null
    ) {
      fabricMapping_list =
        response.data.customerFabricStyleReferenceResult
          .customerFabricStyleReferences;

      this.setState({ fabricMappingList: fabricMapping_list });
    }
    this.setFabricMappingListView();
  };
  getFabricMappingPageError = (error) => {
    ShowError("error" + error);
  };
  setFabricMappingListView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isCustomerEntryFormOpen: false,
      isCustomerListFormOpen: false,
      isShipToListOpened: false,
      isShipToEntryOpened: false,
      isBillToListOpened: false,
      isBillToEntryOpened: false,
      isSalesPersonListOpened: false,
      isSalesPersonEntryOpened: false,
      isCreditCardListOpened: false,
      isCreditCardEntryOpened: false,
      isFabricMappingListOpened: true,
      isFabricMappingEntryOpened: false,
      isUserEntryFormOpened: false,
      isCustomerServiceOpened: false,
      isCustomerSalesFormOpened: false,
    });
  };
  addNewCustomerFabricStyle = (e) => {
    if (e.detail === 1) {
      let customerFabricStyleData = new CustomerFabricStyleReferenceBean();
      customerFabricStyleData.companyCode = this.companyCode;

      let customerCode = this.state.customerData.code;
      customerFabricStyleData.customerCode = customerCode;
      customerFabricStyleData.customerName =
        this.state.customerData.description;

      this.setState({
        fabricMappingData: customerFabricStyleData,
        isDisableNodeFields: false,
      });
      this.state.fabricMappingData = customerFabricStyleData;
      this.openCustomerFabricStyleEntryForm();
    }
  };
  openCustomerFabricStyleEntryForm = () => {
    this.setState({
      isShowSaveButton: true,
      isFabricMappingEntryOpened: true,
      isCustomerListFormOpen: false,
      isFabricMappingListOpened: false,
      isCustomerEntryFormOpen: false,
    });
  };
  editFabricStyle = (code) => {
    this.clearError();
    let isFabricMappingListOpened = false;
    let isFabricMappingEntryOpened = true;

    let selectedFabricMapping = null;
    this.state.fabricMappingList.map((sp) => {
      if (sp.fabricStyleCode == code) {
        selectedFabricMapping = sp;
      }
    });
    if (selectedFabricMapping != null) {
      this.setState({
        isFabricMappingListOpened: isFabricMappingListOpened,
        isFabricMappingEntryOpened: isFabricMappingEntryOpened,
        fabricMappingData: selectedFabricMapping,
        isShowSaveButton: true,
        isDisableNodeFields: true,
        isDisableCustomerFabricStyle: true,
        isDisableFields: true,
      });
    } else {
      let errList = [];
      errList.push("Invalid FabricStyle");
      this.setState({ error_list: errList });
    }
  };
  addNewCustomerCreditCard = (e) => {
    if (e.detail === 1) {
      let customerCreditData = new CustomerCreditCardBean();
      let creditCardAddressData = new AddressBean();
      customerCreditData.companyCode = this.companyCode;
      customerCreditData.cardID = NEW_ENTRY;

      let customerCode = this.state.customerData.code;
      customerCreditData.customerCode = customerCode;

      this.setState({
        creditCardData: customerCreditData,
        creditCardAddressData: creditCardAddressData,
        isDisableNodeFields: false,
      });
      this.state.creditCardData = customerCreditData;
      this.openCustomerCreditCardEntryForm();
    }
  };
  openCustomerCreditCardEntryForm = () => {
    this.setState({
      isShowSaveButton: true,
      isCreditCardEntryOpened: true,
      isCustomerListFormOpen: false,
      isCreditCardListOpened: false,
      isCustomerEntryFormOpen: false,
    });
  };
  deleteCreditCardButtonClick = (rowData) => {
    let request = new RestCustomerEntityRequest();
    request.companyCode = this.companyCode;
    request.code = rowData.customerCode;
    request.entityCode = rowData.cardID;

    if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
      CustomerService.removeCustomerCreditCard(
        request,
        this.removeCreditCardResponse,
        this.removeCreditCardError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  removeCreditCardResponse = (response) => {
    this.handleresponse(response.data);
    if (response.data != null) {
      if (response.data.success === true) {
        this.readandsetCreditCardListView();
      }
    }
  };
  removeCreditCardError = (error) => {
    ShowError("Error" + error);
  };
  editCreditCard = (code) => {
    this.clearError();
    let isCreditCardListOpened = false;
    let isCreditCardEntryOpened = true;

    let selectedCreditCard = null;
    this.state.creditCardList.map((sp) => {
      if (sp.cardID == code) {
        selectedCreditCard = sp;
      }
    });
    if (selectedCreditCard != null) {
      let addressData = new AddressBean();
      addressData = selectedCreditCard.address;

      this.setState({
        isCreditCardListOpened: isCreditCardListOpened,
        isCreditCardEntryOpened: isCreditCardEntryOpened,
        creditCardData: selectedCreditCard,
        creditCardAddressData: addressData,
        isShowSaveButton: true,
        isDisableNodeFields: true,
        isDisableCustomerCreditCard: true,
        isDisableFields: true,
      });
    } else {
      let errList = [];
      errList.push("Invalid creditCard");
      this.setState({ error_list: errList });
    }
  };
  addNewCustomerSalesPerson = (e) => {
    if (e.detail === 1) {
      let customerSalesPersonData = new CustomerSalesPersonCommissionBean();
      customerSalesPersonData.companyCode = this.companyCode;
      customerSalesPersonData.status = "A";
      customerSalesPersonData.isActive = true;
      let customerCode = this.state.customerData.code;
      customerSalesPersonData.customerCode = customerCode;

      this.setState({
        salesPersonData: customerSalesPersonData,
        isDisableNodeFields: false,
      });
      this.state.salesPersonData = customerSalesPersonData;
      this.openCustomerSalesPersonEntryForm();
    }
  };
  openCustomerSalesPersonEntryForm = () => {
    this.setState({
      isShowSaveButton: true,
      isSalesPersonEntryOpened: true,
      isCustomerListFormOpen: false,
      isSalesPersonListOpened: false,
      isCustomerEntryFormOpen: false,
      isUserEntryFormOpened: false,
      isCustomerSalesFormOpened: false,
    });
  };
  deleteSalesPersonButtonClick = (rowData) => {
    let request = new RestCustomerEntityRequest();
    request.companyCode = this.companyCode;
    request.code = rowData.customerCode;
    request.entityCode = rowData.code;
    if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
      CustomerService.removeCustomerSalesPersonCommission(
        request,
        this.removeSalesPersonResponse,
        this.removeSalesPersonError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  removeSalesPersonResponse = (response) => {
    this.handleresponse(response.data);
    if (response.data != null) {
      if (response.data.success === true) {
        this.readandsetSalesPersonListView();
      }
    }
  };
  removeSalesPersonError = (error) => {
    ShowError("Error" + error);
  };
  editSalesPerson = (code) => {
    this.clearError();
    let isSalesPersonListOpened = false;
    let isSalesPersonEntryOpened = true;

    let selectedSalesPerson = null;
    this.state.salesPersonList.map((sp) => {
      if (sp.salesPersonCode == code) {
        selectedSalesPerson = sp;
      }
    });
    if (selectedSalesPerson != null) {
      this.setState({
        isSalesPersonListOpened: isSalesPersonListOpened,
        isSalesPersonEntryOpened: isSalesPersonEntryOpened,
        salesPersonData: selectedSalesPerson,
        isShowSaveButton: true,
        isDisableNodeFields: true,
        isDisableCustomerSalesPerson: true,
        isDisableFields: true,
      });
    } else {
      let errList = [];
      errList.push("Invalid SalesPerson");
      this.setState({ error_list: errList });
    }
  };
  readCustomerSalesPersonResponse = (response) => {
    if (
      response.data != null &&
      response.data.customerSalesPersonCommission != null
    ) {
    }
  };
  readCustomerSalesPersonError = (error) => {
    ShowError("Error" + error);
  };
  setCustomerHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isCustomerEntryFormOpen: true,
      isCustomerListFormOpen: false,
      isShipToListOpened: false,
      isShipToEntryOpened: false,
      isBillToListOpened: false,
      isBillToEntryOpened: false,
      isSalesPersonListOpened: false,
      isSalesPersonEntryOpened: false,
      isUserEntryFormOpened: false,
      isCustomerSalesFormOpened: false,
    });
  };

  deleteShipToButtonClick = (val, rowData) => {
    let request = new RestCustomerEntityRequest();
    request.companyCode = this.companyCode;
    request.code = rowData.customerCode;
    request.entityCode = rowData.code;
    if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
      CustomerService.removeCustomerShipTo(
        request,
        this.removeCustomerShipToResponse,
        this.removeCustomerShipToError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  removeCustomerShipToResponse = (response) => {
    this.handleresponse(response.data);
    if (response.data != null) {
      if (response.data.success == true) {
        this.readandsetShiptoListView();
      }
    }
  };
  removeCustomerShipToError = (error) => {
    ShowError("Error" + error);
  };
  editShipTo = (shipToCode) => {
    this.clearError();
    let isShipToListOpened = false;
    let isShipToEntryOpened = true;

    let selectedShipTo = null;
    this.state.shipTos.map((ship) => {
      if (ship.code == shipToCode) {
        selectedShipTo = ship;
      }
    });
    if (selectedShipTo != null) {
      let addressData = new AddressBean();
      addressData = selectedShipTo.address;

      this.setState({
        isShipToListOpened: isShipToListOpened,
        isShipToEntryOpened: isShipToEntryOpened,
        currentShipTo: selectedShipTo,
        shipToAddressData: addressData,
        isShowSaveButton: true,
        isDisableCustomer: true,
        isDisableFields: true,
      });
    } else {
      let errList = [];
      errList.push("Invalid ShipTo");
      this.setState({ error_list: errList });
    }
  };

  addNewCustomerShipTo = (e) => {
    if (e.detail === 1) {
      let customerData = this.state.customerData;
      let customerShipToData = new CustomerShipToBean();
      customerShipToData.companyCode = this.companyCode;
      customerShipToData.code = NEW_ENTRY;
      customerShipToData.status = "A";
      let customerCode = this.state.customerData.code;
      customerShipToData.customerCode = customerCode;
      customerShipToData.shipViaCode = customerData.shipViaCode;
      customerShipToData.shipToType = "CUSTOMER"
      customerShipToData.billToCode = "B1001";
      customerShipToData.zoneCode = "US";
      customerShipToData.regionCode = "$STD$";
      customerShipToData.districtCode = "$STD$";
      customerShipToData.territoryCode = "$STD$";

      let addressData = new AddressBean();
      customerShipToData.address = addressData;
      let pageTitle = this.moduleCaption + " - " + NEW_ENTRY;
      this.setState({
        currentShipTo: customerShipToData,
        shipToAddressData: addressData,
        pageTitle: pageTitle,
        isDisableCustomer: false,
        isDisableFields: false,
      });
      this.state.currentShipTo = customerShipToData;
      this.openNewCustomerShipToEntryForm();
    }
  };
  openNewCustomerShipToEntryForm = () => {
    this.setState({
      isShowSaveButton: true,
      isShipToEntryOpened: true,
      isCustomerListFormOpen: false,
      isShipToListOpened: false,
      isCustomerEntryFormOpen: false,
      isDisableCustomer: false,
      isDisableFields: false,
    });
  };

  editBillTo = (billToCode) => {
    this.clearError();
    let isBillToListOpened = false;
    let isBillToEntryOpened = true;

    let selectedBillTo = null;
    this.state.billTos.map((bill) => {
      if (bill.code == billToCode) {
        selectedBillTo = bill;
      }
    });
    if (selectedBillTo != null) {
      let addressData = new AddressBean();
      addressData = selectedBillTo.address;

      this.setState({
        isBillToListOpened: isBillToListOpened,
        isBillToEntryOpened: isBillToEntryOpened,
        currentBillTo: selectedBillTo,
        billToAddressData: addressData,
        isShowSaveButton: true,
        isDisableCustomerBillTo: true,
        isDisableFields: true,
      });
    } else {
      let errList = [];
      errList.push("Invalid BillTo");
      this.setState({ error_list: errList });
    }
  };

  getBillToView() {
    return (
      <div>
        {this.state.isBillToListOpened && (
          <Button size="sm" onClick={(e) => this.addNewCustomerBillTo(e)}>
            {" "}
            Add BillTo{" "}
          </Button>
        )}
        {this.state.isBillToListOpened && (
          <CustomerBillToListForm
            customerBillToList={this.state.billTos}
            editBillTo={this.editBillTo}
          />
        )}

        {this.state.isBillToEntryOpened && (
          <CustomerBillToEntryForm
            customerBillToData={this.state.currentBillTo}
            billToAddressData={this.state.billToAddressData}
            warehouses={this.state.warehouses}
            shipViaCodes={this.state.shipViaCodes}
            invoiceTemplates={this.state.invoiceTemplates}
            saveCustomerBillTo={this.saveCustomerBillTo}
            isDisabledFields={this.state.isDisabledFields}
          />
        )}
      </div>
    );
  }
  addNewCustomerBillTo = (e) => {
    if (e.detail === 1) {
      let customerBillToData = new CustomerBillToBean();
      customerBillToData.companyCode = this.companyCode;
      customerBillToData.code = NEW_ENTRY;
      customerBillToData.status = "A";
      let customerCode = this.state.customerData.code;
      customerBillToData.customerCode = customerCode;
      let addressData = new AddressBean();
      customerBillToData.address = addressData;
      let pageTitle = this.moduleCaption + " - " + NEW_ENTRY;
      this.setState({
        currentBillTo: customerBillToData,
        billToAddressData: addressData,
        pageTitle: pageTitle,
      });
      this.openNewCustomerBillToEntryForm();
    }
  };
  openNewCustomerBillToEntryForm = () => {
    this.setState({
      isShowSaveButton: true,
      isBillToEntryOpened: true,
      isCustomerListFormOpen: false,
      isBillToListOpened: false,
      isCustomerEntryFormOpen: false,
      isDisableCustomerBillTo: false,
      isDisableFields: false,
    });
  };

  moduleExit = () => {
    let customerData = this.state.customerData;
    if (customerData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (!this.state.isViewMode)
        this.unLockCustomer_withoutRead(customerData.code);
      this.props.onModuleExit();
    }
  };
  getModuleListView = () => {
    let customerData = this.state.customerData;
    if (customerData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadCustomerList();
    } else {
      if (!this.state.isViewMode)
        this.unLockCustomer_withoutRead(customerData.code);
      this.closeEntryForm();
      this.loadCustomerList();
    }
    this.clearError();
    this.hideAlertCallBack();
  };
  resetView = () => {
    let customer_Data = this.state.customerData;
    this.state.isReseted = true;
    if (!this.state.isViewMode) {
      this.unLockCustomer_withoutRead(customer_Data.code);
    }
    let customerData = new CustomerBean();
    customerData.masterCustomerName = "";
    this.setState({
      customerData: customerData,
      isResetModule: true,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isFocus: false,
      isFocusLookup: true,
      showAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
      isViewMode: false,
      isDisabledFields: false,
      isDisableNodeFields: false,
      isCustomerNotFound: false,
      isShowAutoCompleteRoleList: false,
      rolePageListForAutoCompleteList: new Array(),
    });
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.state.customerData = customerData;
    this.addNewEntry();
    this.hideAlertCallBack(false);
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
    let customerData = this.state.customerData;
    //this.unLockCustomer_withoutRead(customerData.code);
  };

  selectButtonClick = (e) => {
    this.editcustomer(this.state.moduleKeyCode);
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  getCriteriaString = () => {
    let criteriaString = "";
    let moduleCaption = this.moduleCaption;
    if (this.state.criteria == null) {
      return <div />;
    } else {
      if (!isEmptyString(this.state.criteria.customerCode))
        criteriaString =
          criteriaString +
          moduleCaption +
          "CustomerCode# : " +
          this.state.criteria.customerCode +
          " ; ";
      if (!isEmptyString(this.state.criteria.customerCodeStartsWith))
        criteriaString =
          criteriaString +
          moduleCaption +
          "CustomerCodeStartsWith : " +
          this.state.criteria.customerCodeStartsWith +
          " ; ";
      if (!isEmptyString(this.state.criteria.customerCodeContains))
        criteriaString =
          criteriaString +
          moduleCaption +
          "CustomerCodeContains : " +
          this.state.criteria.customerCodeContains +
          " ; ";

      if (!isEmptyString(this.state.criteria.customerName))
        criteriaString =
          criteriaString +
          "CustomerName : " +
          this.state.criteria.customerName +
          " ; ";
      if (!isEmptyString(this.state.criteria.customerNameContains))
        criteriaString =
          criteriaString +
          "Customer Name Contains : " +
          this.state.criteria.customerNameContains +
          " ; ";
    }
    return <div>{criteriaString}</div>;
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerOnOrderInq: false,
      isShowCustomerTransactionsInq: false,
      isShowCustomerStatisticsInq: false,
      isShowCustomerSalesHistoryInq: false,
      isShowCustomerMostRecentFabricsInq: false,
      isCustomerCurrentAgingInq: false,
      moduleForPopup: [],
    });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  openCustomerOnOrderInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isShowCustomerOnOrderInq: true,
        moduleForPopup: (
          <PopupCustomerOnOrderInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerTransactionsInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isShowCustomerTransactionsInq: true,
        moduleForPopup: (
          <PopupCustomerTransactionsInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerStatisticsInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isShowCustomerStatisticsInq: true,
        moduleForPopup: (
          <PopupCustomerStatisticsInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerSalesHistoryInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isShowCustomerSalesHistoryInq: true,
        moduleForPopup: (
          <PopupCustomerSalesHistoryInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerMostRecentFabricsInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isShowCustomerMostRecentFabricsInq: true,
        moduleForPopup: (
          <PopupCustomerMostRecentFabricsInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerCurrentAgingInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isCustomerCurrentAgingInq: true,
        moduleForPopup: (
          <PopupCustomerCurrentAgingInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  onArTypeCodeChange = (e) => {
    let arTypeCode = e.target.value;
    this.state.showAutoCompleteArTypeCodeList = true;

    let temp_customerdata = this.state.customerData;
    let showAutoCompleteList = this.state.showAutoCompleteArTypeCodeList;

    if (isEmpty(arTypeCode)) {
      this.state.showAutoCompleteArTypeCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteArTypeCodeList;
      let temp_customerdata = this.state.customerData;
      temp_customerdata.arTypeCode = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteArTypeCodeList: showAutoCompleteList,
        customerData: temp_customerdata,
        arTypeCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && arTypeCode !== "") {
      this.readArTypeCodeBySearchString(arTypeCode);
    }
    if (e.target.name == "arTypeCode") {
      temp_customerdata["arTypeCode"] = e.target.value;
      let arTypeCode_List = this.state.arTypes;
      arTypeCode_List.map((arTypeCode) => {
        if (arTypeCode.code == e.target.value) {
          temp_customerdata["arTypeCode"] = arTypeCode.code;

          this.state.showAutoCompleteArTypeCodeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteArTypeCodeList;
          this.setState({
            showAutoCompleteArTypeCodeList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ customerData: temp_customerdata });
  };
  readArTypeCodeBySearchString(searchString) {
    let arTypeCodeData = this.state.arTypes;
    let simpleAutoCompleteList = new Array();
    if (arTypeCodeData.length > 0 && arTypeCodeData != null) {
      arTypeCodeData.map((arTypeCodeDatas) => {
        let simpleItemBean = {
          code: arTypeCodeDatas.code,
          description: arTypeCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletearTypeCodeLists) =>
        simpleAutoCompletearTypeCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      arTypeCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  arTypeCodeEnterKeyEvent = (e) => {
    let temp_customerdata = this.state.customerData;
    let arTypeCode = e.target.value;

    temp_customerdata["arTypeCode"] = e.target.value;
    let arTypeCodeList = this.state.arTypes;
    let arTypeCodeBean = null;
    arTypeCodeList.map((arTypeCode_List) => {
      if (arTypeCode_List.code == e.target.value) {
        arTypeCodeBean = arTypeCode_List;
      }
    });
    if (!isEmpty(arTypeCodeBean)) {
      let temp_customerdata = this.state.customerData;
      temp_customerdata.arTypeCode = arTypeCodeBean.code;

      this.setState({
        customerData: temp_customerdata,
        arTypeCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteArTypeCodeList = (showAutoCompleteArTypeCodeList) => {
    this.setState({
      showAutoCompleteArTypeCodeList: showAutoCompleteArTypeCodeList,
    });
  };
  oncustomerDeliveryTypeCodeChange = (e) => {
    let customerDeliveryTypeCode = e.target.value;
    this.state.showAutoCompleteArTypeCodeList = true;

    let temp_customerdata = this.state.customerData;
    let showAutoCompleteList =
      this.state.showAutoCompletecustomerDeliveryTypeCodeList;

    if (isEmpty(customerDeliveryTypeCode)) {
      this.state.showAutoCompleteShipViaList = false;
      let showAutoCompleteList =
        this.state.showAutoCompletecustomerDeliveryTypeCodeList;
      let temp_customerdata = this.state.customerData;
      temp_customerdata.customerDeliveryTypeCode = "";

      let suggestion = [];

      this.setState({
        showAutoCompletecustomerDeliveryTypeCodeList: showAutoCompleteList,
        customerData: temp_customerdata,
        customerDeliveryTypeCodePageListForAutoCompleteList: suggestion,
      });
    } else if (
      showAutoCompleteList === true &&
      customerDeliveryTypeCode !== ""
    ) {
      this.readcustomerDeliveryTypeCodeBySearchString(customerDeliveryTypeCode);
    }
    if (e.target.name == "customerDeliveryTypeCode") {
      temp_customerdata["customerDeliveryTypeCode"] = e.target.value;
      let customerDeliveryTypeCode_List = this.state.customerDeliveries;
      customerDeliveryTypeCode_List.map((customerDeliveryTypeCode) => {
        if (customerDeliveryTypeCode.code == e.target.value) {
          temp_customerdata["customerDeliveryTypeCode"] =
            customerDeliveryTypeCode.code;

          this.state.showAutoCompletecustomerDeliveryTypeCodeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompletecustomerDeliveryTypeCodeList;
          this.setState({
            showAutoCompletecustomerDeliveryTypeCodeList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ customerData: temp_customerdata });
  };
  readcustomerDeliveryTypeCodeBySearchString(searchString) {
    let customerDeliveryTypeCodeData = this.state.customerDeliveries;

    let simpleAutoCompleteList = new Array();
    if (
      customerDeliveryTypeCodeData.length > 0 &&
      customerDeliveryTypeCodeData != null
    ) {
      customerDeliveryTypeCodeData.map((customerDeliveryTypeCodeDatas) => {
        let simpleItemBean = {
          code: customerDeliveryTypeCodeDatas.code,
          description: customerDeliveryTypeCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecustomerDeliveryTypeCodeLists) =>
        simpleAutoCompletecustomerDeliveryTypeCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      customerDeliveryTypeCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  customerDeliveryTypeCodeEnterKeyEvent = (e) => {
    let temp_customerdata = this.state.customerData;
    let customerDeliveryTypeCode = e.target.value;

    temp_customerdata["customerDeliveryTypeCode"] = e.target.value;
    let customerDeliveryTypeCodeList = this.state.customerDeliveries;
    let customerDeliveryTypeCodeBean = null;
    customerDeliveryTypeCodeList.map((customerDeliveryTypeCode_List) => {
      if (customerDeliveryTypeCode.code == e.target.value) {
        customerDeliveryTypeCodeBean = customerDeliveryTypeCode_List;
      }
    });
    if (!isEmpty(customerDeliveryTypeCodeBean)) {
      let temp_customerdata = this.state.customerData;
      temp_customerdata.customerDeliveryTypeCode =
        customerDeliveryTypeCodeBean.code;

      this.setState({
        customerData: temp_customerdata,
        customerDeliveryTypeCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompletecustomerDeliveryTypeCodeList = (
    showAutoCompletecustomerDeliveryTypeCodeList
  ) => {
    this.setState({
      showAutoCompletecustomerDeliveryTypeCodeList:
        showAutoCompletecustomerDeliveryTypeCodeList,
    });
  };
  onfinancialTypeCodeChange = (e) => {
    let financialTypeCode = e.target.value;
    this.state.showAutoCompletefinancialTypeCodeList = true;

    let temp_customerdata = this.state.customerData;
    let showAutoCompleteList = this.state.showAutoCompletefinancialTypeCodeList;

    if (isEmpty(financialTypeCode)) {
      this.state.showAutoCompletefinancialTypeCodeList = false;
      let showAutoCompleteList =
        this.state.showAutoCompletefinancialTypeCodeList;
      let temp_customerdata = this.state.customerData;
      temp_customerdata.financialTypeCode = "";

      let suggestion = [];

      this.setState({
        showAutoCompletefinancialTypeCodeList: showAutoCompleteList,
        customerData: temp_customerdata,
        financialTypeCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && financialTypeCode !== "") {
      this.readfinancialTypeCodeBySearchString(financialTypeCode);
    }
    if (e.target.name == "financialTypeCode") {
      temp_customerdata["financialTypeCode"] = e.target.value;
      let financialTypeCode_List = this.state.financialTypes;
      financialTypeCode_List.map((financialTypeCode) => {
        if (financialTypeCode.code == e.target.value) {
          temp_customerdata["financialTypeCode"] = financialTypeCode.code;

          this.state.showAutoCompletefinancialTypeCodeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompletefinancialTypeCodeList;
          this.setState({
            showAutoCompletefinancialTypeCodeList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ customerData: temp_customerdata });
  };
  readfinancialTypeCodeBySearchString(searchString) {
    let financialTypeCodeData = this.state.financialTypes;
    let simpleAutoCompleteList = new Array();
    if (financialTypeCodeData.length > 0 && financialTypeCodeData != null) {
      financialTypeCodeData.map((financialTypeCodeDatas) => {
        let simpleItemBean = {
          code: financialTypeCodeDatas.code,
          description: financialTypeCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletefinancialTypeCodeLists) =>
        simpleAutoCompletefinancialTypeCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      financialTypeCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  financialTypeCodeEnterKeyEvent = (e) => {
    let temp_customerdata = this.state.customerData;
    let financialTypeCode = e.target.value;

    temp_customerdata["financialTypeCode"] = e.target.value;
    let financialTypeCodeList = this.state.financialTypes;
    let financialTypeCodeBean = null;
    financialTypeCodeList.map((financialTypeCode_List) => {
      if (financialTypeCode_List.code == e.target.value) {
        financialTypeCodeBean = financialTypeCode_List;
      }
    });
    if (!isEmpty(financialTypeCodeBean)) {
      let temp_customerdata = this.state.customerData;
      temp_customerdata.financialTypeCode = financialTypeCodeBean.code;

      this.setState({
        customerData: temp_customerdata,
        financialTypeCodePageListForAutoCompleteList: new Array(),
        //showAutoCompleteList:showAutoCompleteList
      });
    }
  };
  displayAutoCompletefinancialTypeCodeList = (
    showAutoCompletefinancialTypeCodeList
  ) => {
    this.setState({
      showAutoCompletefinancialTypeCodeList:
        showAutoCompletefinancialTypeCodeList,
    });
  };
  onLocationChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;

    let temp_customerdata = this.state.customerData;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;

    if (isEmpty(locationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let temp_customerdata = this.state.customerData;
      temp_customerdata.locationCode = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        customerData: temp_customerdata,
        locationPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    if (e.target.name == "locationCode") {
      temp_customerdata["locationCode"] = e.target.value;
      let locationCode_List = this.state.warehouses;
      locationCode_List.map((locationCode) => {
        if (locationCode.code == e.target.value) {
          temp_customerdata["locationCode"] = locationCode.code;

          this.state.showAutoCompleteLocationList = false;
          let showAutoCompleteList = this.state.showAutoCompleteLocationList;
          this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
        }
      });
    }
    this.setState({ customerData: temp_customerdata });
  };
  locationEnterKeyEventHandler = (e) => {
    let temp_customerdata = this.state.customerData;
    let locationCode = e.target.value;

    temp_customerdata["locationCode"] = e.target.value;
    let locationCode_List = this.state.warehouses;
    let locationCodeBean = null;
    locationCode_List.map((locationCode) => {
      if (locationCode.code == e.target.value) {
        locationCodeBean = locationCode;
      }
    });
    if (!isEmpty(locationCodeBean)) {
      let temp_customerdata = this.state.customerData;
      temp_customerdata.locationCode = locationCodeBean.code;

      this.setState({
        customerData: temp_customerdata,
        locationPageListForAutoCompleteList: new Array(),
      });
    }
  };
  roleOnChange = (e) => {
    let roleCode = e.target.value;
    this.state.isShowAutoCompleteRoleList = true;
    let userData = this.state.userData;
    let showAutoCompleteList = this.state.isShowAutoCompleteRoleList;
    if (isEmpty(roleCode)) {
      this.state.isShowAutoCompleteRoleList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteRoleList;
      let userData = this.state.userData;
      userData.roleCode = "";

      let suggestion = [];
      this.setState({
        isShowAutoCompleteRoleList: showAutoCompleteList,
        userData: userData,
        rolePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "roleCode" &&
      showAutoCompleteList === true &&
      roleCode !== ""
    ) {
      setTimeout(() => {
        this.readRoleCodeBySearchString(e.target.value);
      }, 200);
    }
    userData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ userData: userData });
  };
  readRoleCodeBySearchString(searchString) {
    let searchCriteria = new RoleSearchCriteria();

    searchCriteria.roleCode = searchString;
    searchCriteria.roleName = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 10;
    let requestInput = new RestRoleListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = searchCriteria;
    SecurityService.getRolePageList(
      requestInput,
      this.readRoleBySearchCodeResponse,
      this.errorCallBack
    );
  }
  readRoleBySearchCodeResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.rolePageList) &&
      !isEmptyArray(response.data.rolePageList.roles)
    ) {
      let roleData = response.data.rolePageList.roles;
      let simpleAutoCompleteList = new Array();
      if (roleData.length > 0 && roleData != null) {
        roleData.map((role) => {
          let simpleItemBean = {
            code: role.code,
            description: role.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        rolePageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  roleEnterKeyEventHandler = (e) => {
    this.readRole(e.target.value);
    this.state.isShowAutoCompleteRoleList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteRoleList;
    this.setState({
      rolePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteRoleList: showAutoCompleteList,
    });
  };
  displayAutoCompleteRoleList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteRoleList: showAutoCompleteList,
    });
  };
  readRoleResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.role)) {
      let roleData = response.data.role;
      let userData = this.state.userData;
      userData.roleCode = roleData.code;
      userData.roleName = roleData.description;
      this.setState({
        userData: userData,
      });
    }
  };
  readRole = (roleCode) => {
    // let readrestInput = new RestReadRequest();
    // readrestInput.companyCode = this.companyCode;
    // readrestInput.code = roleCode;
    SecurityService.readRole(
      roleCode,
      this.readRoleResponse,
      this.errorCallBack
    );
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let customer_list = this.state.customer_list;
    if (sortField && !isEmptyArray(customer_list)) {
      const sorted = [...customer_list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ customer_list: sorted });
    }
  };
  getFabricLinebyfabricStyleCode = (fabricStyleCode) => {
    let customerFabricMappingList = this.state.fabricMappingList;
    let fb = false;
    if (this.state.fabricMappingList === null) {
      fb = false;
    } else {
      this.state.fabricMappingList.map((line) => {
        if (line.fabricStyleCode === fabricStyleCode) {
          fb = true;
        }
      });
    }
    return fb;
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };

  loadUserResponse = (response) => {
    const userList = new Array();
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.userPageList) &&
      !isEmptyArray(response.data.userPageList.users)
    ) {
      userList.push(...response.data.userPageList.users);
    }
    this.setState({
      userList: userList,
      isLoading: false,
      loadingText: "",
    });
  };
  getUserList = () => {
    this.setState({
      isLoading: true,
      loadingText: "get users",
    });
    const code = this.state.customerData.code;
    const request = new RestUserListRequest();
    const criteria = new UserSearchCriteria();
    // criteria.loginType = LogicConstants.LOGIN_TYPE_DATA_PORTAL_USER;
    if (this.state.is3PL) {
      const loginTypes = new Array();
      loginTypes.push(LogicConstants.LOGIN_TYPE_DATA_PORTAL_USER);
      loginTypes.push(LogicConstants.LOGIN_TYPE_SPECIAL_DATA_PORTAL_USER);

      criteria.loginTypes = loginTypes;
    }
    criteria.entityCode = code;

    const pageInput = new PageListBean();

    request.searchCriteria = criteria;
    request.pageInput = pageInput;
    UserService.getUserPageList(
      request,
      this.loadUserResponse,
      this.errorCallBack
    );
  };
  closeAlertModalCallBackLvl5 = (isShowPopup) => {
    this.setState({
      isShowSpecialUserPopup: false,
      isShowAlertLvl5: false,
      specialUserData: new CustomerUserBean(),
    });
    this.hideAlertCallBackLvl5();
  };
  hideAlertCallBackLvl5 = (msgType, isDisplayed) => {
    this.setState({
      isShowAlertLvl5: false,
    });
  };
  specialUserOnChange = (e) => {
    const special_UserData = this.state.specialUserData;
    special_UserData[e.target.name] = e.target.value;
    this.setState({ specialUserData: special_UserData });
  };
  openSpecialUserPopup = (e) => {
    const special_UserData = this.state.specialUserData;
    if (this.state.is3PL) {
      special_UserData.isDataPortalUser = true;
    }
    this.setState({
      isShowSpecialUserPopup: true,
      specialUserData: special_UserData,
    });
  };
  clear_specialUser = () => {
    this.setState({ specialUserData: new CustomerUserBean() });
  };
  createCustomerSpecialUserResponse = (response) => {
    this.handleresponse(response.data);
    if (
      response != null &&
      response.data != null &&
      response.data.isSuccess === true
    ) {
      this.setState({
        selectedNodeKey: "headerView",
        userData: new UserBean(),
        isCustomerEntryFormOpen: true,
        isCustomerListFormOpen: false,
        isShipToListOpened: false,
        isShipToEntryOpened: false,
        isBillToListOpened: false,
        isBillToEntryOpened: false,
        isSalesPersonListOpened: false,
        isSalesPersonEntryOpened: false,
        isCreditCardListOpened: false,
        isCreditCardEntryOpened: false,
        isFabricMappingListOpened: false,
        isFabricMappingEntryOpened: false,
        isUserEntryFormOpened: false,
        isCustomerServiceOpened: false,
        isCustomerSalesFormOpened: false,
      });
    }
    this.closeAlertModalCallBackLvl5();
  };
  create_specialUser = () => {
    const customer_data = { ...this.state.customerData };
    const specialUserData = this.state.specialUserData;
    const isValid = this.validateUserData(specialUserData);
    if (isValid) {
      if (!isEmpty(specialUserData)) {
        specialUserData.companyCode = this.companyCode;
        specialUserData.customerCode = this.state.moduleKeyCode;
        specialUserData.loginType =
          LogicConstants.LOGIN_TYPE_SPECIAL_DATA_PORTAL_USER;
        CustomerService.createCustomerUser(
          specialUserData,
          this.createCustomerSpecialUserResponse,
          this.errorCallBack
        );
      }
    }
  };
  render() {
    const specialUser = this.state.specialUserData;
    return (
      <div>
        {!this.state.isSpecialViewMode ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <div>
          <ModuleToolBar
            isShowNewButton={false}
            onNewEntry={() => this.addNewEntry()}
            onModuleExit={() => this.moduleExit()}
            resetView={() => this.resetView()}
            pageTitle={this.state.pageTitle}
            loadingText={this.state.loadingText}
            isLoading={this.state.isLoading}
            isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
            isMaintenanceMode={this.state.isMaintenanceMode}
            onModuleKeyContainerButtonClick={this.editcustomer}
            moduleKeyCode={this.state.moduleKeyCode}
            onModuleKeyCodeChange={this.onModuleKeyCodeChange}
            getModuleListView={this.getModuleListView}
            lookupRequired={true} //for f2 lookup
            lookupHandler={this.state.customerLookupHandler} //for f2 lookup
            showCriteriaDialog={true} //for f2 lookup
            onModuleKeyCodeWithCriteriaOnChange={
              this.onModuleKeyCodeWithCriteriaOnChange
            }
            selectButtonClick={this.selectButtonClick}
            disabled={this.state.disabled}
            isSpecialViewMode={this.state.isSpecialViewMode}
            isResetView={this.state.isResetView}
            isFocusLookup={this.state.isFocusLookup}
          />
        </div>
        {!this.state.isCustomerListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              extend_toolbar={
                <>
                  {this.state.isShowSpecialUserButton &&
                    this.state.customerData.isFetched && (
                      <Button
                        className="header_buttons secondary"
                        size="sm"
                        onClick={(e) => this.openSpecialUserPopup(e)}
                      >
                          <UserRoundCog size={16} />
                        Special User
                      </Button>
                    )}
                </>
              }
              save={this.save}
              clearError={this.clearError}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              pageTitle={this.state.pageTitle}
              isSpecialViewMode={this.state.isSpecialViewMode}
            />
          )}
        <BaseNotification error_list={this.state.error_list} />
        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedModuleKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            style={{ "background-color": "#fff" }}
          />
        )}
        {!this.state.isShowNodes &&
          !this.state.isCustomerListFormOpen &&
          !this.state.isShipToListOpened &&
          !this.state.isShipToEntryOpened &&
          !this.state.isBillToEntryOpened &&
          !this.state.isBillToListOpened &&
          !this.state.isCustomerServiceOpened &&
          this.state.isCustomerEntryFormOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isCustomerListFormOpen &&
          !this.state.isShipToListOpened &&
          !this.state.isShipToEntryOpened &&
          !this.state.isBillToEntryOpened &&
          !this.state.isBillToListOpened &&
          !this.state.isCustomerServiceOpened &&
          this.state.isCustomerEntryFormOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isCustomerEntryFormOpen &&
          !this.state.isCustomerListFormOpen &&
          this.state.isShipToListOpened &&
          !this.state.isShipToEntryOpened &&
          !this.state.isCustomerServiceOpened && (
            <div>
              <div>
                <Button
                  className="addToButton"
                  size="sm"
                  onClick={(e) => this.addNewCustomerShipTo(e)}
                >
                  {" "}
                  Add ShipTo{" "}
                </Button>
              </div>
              <div className="custShipToBillToTable">
                <CustomerShipToListForm
                  {...this.state}
                  customerShipToList={this.state.shipTos}
                  editShipTo={this.editShipTo}
                  readandsetShiptoListView={this.readandsetShiptoListView}
                  deleteShipToButtonClick={this.deleteShipToButtonClick}
                />
              </div>
            </div>
          )}

        {this.state.isShowNodes &&
          !this.state.isCustomerListFormOpen &&
          !this.state.isCustomerEntryFormOpen &&
          this.state.isBillToListOpened &&
          !this.state.isBillToEntryOpened &&
          !this.state.isCustomerServiceOpened && (
            <div>
              <div>
                <Button
                  className="addToButton"
                  size="sm"
                  onClick={(e) => this.addNewCustomerBillTo(e)}
                >
                  {" "}
                  Add BillTo{" "}
                </Button>
              </div>
              <div className="custShipToBillToTable">
                <CustomerBillToListForm
                  {...this.state}
                  customerBillToList={this.state.billTos}
                  editBillTo={this.editBillTo}
                />
              </div>
            </div>
          )}
        {this.state.isShowNodes &&
          !this.state.isCustomerListFormOpen &&
          !this.state.isShipToListOpened &&
          this.state.isShipToEntryOpened &&
          !this.isCustomerEntryFormOpen &&
          !this.state.isCustomerServiceOpened && (
            <CustomerShipToEntryForm
              {...this.state}
              customerBillToList={this.state.billTos}
              customerShipToData={this.state.currentShipTo}
              shipToAddressData={this.state.shipToAddressData}
              warehouses={this.state.warehouses}
              shipViaCodes={this.state.shipViaCodes}
              isDisableFields={this.state.isDisableFields}
              isDisableCustomer={this.state.isDisableCustomer}
              countries={this.state.countries}
              states={this.state.states}
              cities={this.state.cities}
              saveCustomerShipTo={this.saveCustomerShipTo}
              closeCustomerShipToEntryForm={this.closeCustomerShipToEntryForm}
              onCityShipToChange={this.onCityShipToChange}
              cityShipToEnterKeyEvent={this.cityShipToEnterKeyEvent}
              displayAutoCompleteCityList={this.displayAutoCompleteCityList}
              onStateShipToChange={this.onStateShipToChange}
              stateShipToEnterKeyEvent={this.stateShipToEnterKeyEvent}
              displayAutoCompleteStateList={this.displayAutoCompleteStateList}
              countryCodeEnterKeyEvent={this.countryCodeEnterKeyEvent}
              displayAutoCompleteCountryCodeList={
                this.displayAutoCompleteCountryCodeList
              }
              onCountryCodeShipToChange={this.onCountryCodeShipToChange}
              countryCodeShipToEnterKeyEvent={
                this.countryCodeShipToEnterKeyEvent
              }
              onLocationShipToChange={this.onLocationShipToChange}
              locationShipToEnterKeyEventHandler={
                this.locationShipToEnterKeyEventHandler
              }
              displayAutoCompleteLocationList={
                this.displayAutoCompleteLocationList
              }
              onShipViaShipToChange={this.onShipViaShipToChange}
              shipViaShipToEnterKeyEvent={this.shipViaShipToEnterKeyEvent}
              displayAutoCompleteShipViaList={
                this.displayAutoCompleteShipViaList
              }
              onBillToChange={this.onBillToChange}
              billToToEnterKeyEvent={this.billToToEnterKeyEvent}
              displayAutoCompleteBillToList={this.displayAutoCompleteBillToList}
              zoneOnChange={this.zoneOnChange}
              zoneEnterKeyEvent={this.zoneEnterKeyEvent}
              displayAutoCompleteZoneList={this.displayAutoCompleteZoneList}




              onShipToTypeChange={this.onShipToTypeChange}
              shipToTypeEnterKeyEvent={this.shipToTypeEnterKeyEvent}
              displayAutoCompleteShipToTypeList={this.displayAutoCompleteShipToTypeList}
            />
          )}

        {this.state.isShowNodes &&
          !this.state.isCustomerListFormOpen &&
          !this.state.isBillToListOpened &&
          this.state.isBillToEntryOpened &&
          !this.isCustomerEntryFormOpen &&
          !this.state.isCustomerServiceOpened && (
            <CustomerBillToEntryForm
              {...this.state}
              customerBillToData={this.state.currentBillTo}
              billToAddressData={this.state.billToAddressData}
              paymentMethods={this.state.paymentMethods}
              paymentTerms={this.state.paymentTerms}
              shipViaCodes={this.state.shipViaCodes}
              countries={this.state.countries}
              states={this.state.states}
              cities={this.state.cities}
              isDisableFields={this.state.isDisableFields}
              isDisableCustomerBillTo={this.state.isDisableCustomerBillTo}
              saveCustomerBillTo={this.saveCustomerBillTo}
              closeCustomerBillToEntryForm={this.closeCustomerBillToEntryForm}
              onCurrencyBillToChange={this.onCurrencyBillToChange}
              currencyBillToEnterKeyEvent={this.currencyBillToEnterKeyEvent}
              displayAutoCompleteCurrencyList={
                this.displayAutoCompleteCurrencyList
              }
              onShipViaBillToChange={this.onShipViaBillToChange}
              shipViaBillToEnterKeyEvent={this.shipViaBillToEnterKeyEvent}
              displayAutoCompleteShipViaList={
                this.displayAutoCompleteShipViaList
              }
              onPaymentTermBillToChange={this.onPaymentTermBillToChange}
              paymentTermBillToEnterKeyEventHandler={
                this.paymentTermBillToEnterKeyEventHandler
              }
              displayAutoCompletePaymentTermList={
                this.displayAutoCompletePaymentTermList
              }
              onPaymentTypeBillToChange={this.onPaymentTypeBillToChange}
              paymentTypeBillToEnterKeyEventHandler={
                this.paymentTypeBillToEnterKeyEventHandler
              }
              displayAutoCompletePaymentTypeList={
                this.displayAutoCompletePaymentTypeList
              }
              onInvoiceTemplateBillToCodeChange={
                this.onInvoiceTemplateBillToCodeChange
              }
              invoiceTemplateBillToCodeEnterKeyEvent={
                this.invoiceTemplateBillToCodeEnterKeyEvent
              }
              displayAutoCompleteInvoiceTemplateCodeList={
                this.displayAutoCompleteInvoiceTemplateCodeList
              }
              onCityBillToChange={this.onCityBillToChange}
              cityBillToEnterKeyEvent={this.cityBillToEnterKeyEvent}
              displayAutoCompleteCityList={this.displayAutoCompleteCityList}
              onStateBillToChange={this.onStateBillToChange}
              stateBillToEnterKeyEvent={this.stateBillToEnterKeyEvent}
              displayAutoCompleteStateList={this.displayAutoCompleteStateList}
              countryCodeBillToEnterKeyEvent={
                this.countryCodeBillToEnterKeyEvent
              }
              displayAutoCompleteCountryCodeList={
                this.displayAutoCompleteCountryCodeList
              }
              onCountryCodeBillToChange={this.onCountryCodeBillToChange}
              invoiceTemplates={this.state.invoiceTemplates}
            />
          )}

        {this.state.isShowNodes &&
          !this.state.isCustomerEntryFormOpen &&
          !this.state.isCustomerListFormOpen &&
          this.state.isSalesPersonListOpened &&
          !this.state.isSalesPersonEntryOpened &&
          !this.state.isCustomerServiceOpened && (
            <div>
              <div>
                <Button
                  className="addToButton"
                  size="sm"
                  onClick={(e) => this.addNewCustomerSalesPerson(e)}
                >
                  {" "}
                  Add SalesPerson{" "}
                </Button>
              </div>
              <div className="custShipToBillToTable">
                <CustomerSalesPersonListForm
                  {...this.state}
                  customerSalesPersonList={this.state.salesPersonList}
                  editSalesPerson={this.editSalesPerson}
                  deleteSalesPersonButtonClick={
                    this.deleteSalesPersonButtonClick
                  }
                />
              </div>
            </div>
          )}

        {this.state.isShowNodes &&
          !this.state.isCustomerEntryFormOpen &&
          !this.state.isCustomerListFormOpen &&
          this.state.isCreditCardListOpened &&
          !this.state.isCreditCardEntryOpened &&
          !this.state.isCustomerServiceOpened && (
            <div>
              <div>
                <Button
                  className="addToButton"
                  size="sm"
                  onClick={(e) => this.addNewCustomerCreditCard(e)}
                >
                  {" "}
                  Add CreditCard{" "}
                </Button>
              </div>
              <div className="custShipToBillToTable">
                <CustomerCreditCardListForm
                  {...this.state}
                  customerCreditCardList={this.state.creditCardList}
                  creditCardAddressData={this.state.creditCardAddressData}
                  editCreditCard={this.editCreditCard}
                  deleteCreditCardButtonClick={this.deleteCreditCardButtonClick}
                />
              </div>
            </div>
          )}

        {this.state.isShowNodes &&
          !this.state.isCustomerEntryFormOpen &&
          !this.state.isCustomerListFormOpen &&
          this.state.isFabricMappingListOpened &&
          !this.state.isFabricMappingEntryOpened &&
          !this.state.isCustomerServiceOpened && (
            <div>
              <div>
                <Button
                  className="addToButton"
                  size="sm"
                  onClick={(e) => this.addNewCustomerFabricStyle(e)}
                >
                  {" "}
                  Add FabricStyle{" "}
                </Button>
              </div>
              <div className="custShipToBillToTable">
                <CustomerFabricMappingListForm
                  {...this.state}
                  customerFabricMappingList={this.state.fabricMappingList}
                  editFabricStyle={this.editFabricStyle}
                />
              </div>
            </div>
          )}

        {this.state.isShowNodes &&
          !this.state.isCustomerListFormOpen &&
          !this.state.isSalesPersonListOpened &&
          this.state.isSalesPersonEntryOpened &&
          !this.isCustomerEntryFormOpen &&
          !this.state.isCustomerServiceOpened && (
            <CustomerSalesPersonEntryForm
              {...this.state}
              customerSalesPersonData={this.state.salesPersonData}
              salesPersons={this.state.salesPersons}
              closeCustomerSalesPersonEntryForm={
                this.closeCustomerSalesPersonEntryForm
              }
              isDisableFields={this.state.isDisableFields}
              isDisableCustomerSalesPerson={
                this.state.isDisableCustomerSalesPerson
              }
              onSalesPersonCodeChange={this.onSalesPersonCodeChange}
              salesPersonEnterKeyEvent={this.salesPersonEnterKeyEvent}
              displayAutoCompleteSalesPersonList={
                this.displayAutoCompleteSalesPersonList
              }
            />
          )}

        {this.state.isShowNodes &&
          !this.state.isCustomerListFormOpen &&
          !this.state.isCreditCardListOpened &&
          this.state.isCreditCardEntryOpened &&
          !this.isCustomerEntryFormOpen &&
          !this.state.isCustomerServiceOpened && (
            <CustomerCreditCardEntryForm
              {...this.state}
              customerCreditCardData={this.state.creditCardData}
              creditCardAddressData={this.state.creditCardAddressData}
              countries={this.state.countries}
              states={this.state.states}
              cities={this.state.cities}
              isDisableFields={this.state.isDisableFields}
              isDisableCustomerCreditCard={
                this.state.isDisableCustomerCreditCard
              }
              onCityCreditCardChange={this.onCityCreditCardChange}
              cityCreditCardEnterKeyEvent={this.cityCreditCardEnterKeyEvent}
              displayAutoCompleteCityList={this.displayAutoCompleteCityList}
              onStateCreditCardChange={this.onStateCreditCardChange}
              stateCreditCardEnterKeyEvent={this.stateCreditCardEnterKeyEvent}
              displayAutoCompleteStateList={this.displayAutoCompleteStateList}
              countryCodeCreditCardEnterKeyEvent={
                this.countryCodeCreditCardEnterKeyEvent
              }
              displayAutoCompleteCountryCodeList={
                this.displayAutoCompleteCountryCodeList
              }
              onCountryCodeCreditCardChange={this.onCountryCodeCreditCardChange}
              closeCustomerCreditCardEntryForm={
                this.closeCustomerCreditCardEntryForm
              }
            />
          )}

        {this.state.isShowNodes &&
          !this.state.isCustomerListFormOpen &&
          !this.state.isFabricMappingListOpened &&
          this.state.isFabricMappingEntryOpened &&
          !this.isCustomerEntryFormOpen &&
          !this.state.isCustomerServiceOpened && (
            <CustomerFabricMappingEntryForm
              {...this.state}
              customerFabricMappingData={this.state.fabricMappingData}
              closeCustomerFabricMappingEntryForm={
                this.closeCustomerFabricMappingEntryForm
              }
            />
          )}
        {this.state.isShowNodes &&
          !this.state.isCustomerListFormOpen &&
          this.state.isUserEntryFormOpened &&
          !this.state.isCustomerEntryFormOpen &&
          !this.state.isCustomerServiceOpened &&
          this.getUserView()}
        {this.state.isShowNodes &&
          !this.state.isCustomerListFormOpen &&
          !this.state.isUserEntryFormOpened &&
          !this.state.isCustomerEntryFormOpen &&
          this.state.isCustomerServiceOpened &&
          this.getCustomerServiceView()}
        {this.state.isShowNodes &&
          !this.state.isCustomerListFormOpen &&
          !this.state.isUserEntryFormOpened &&
          !this.state.isCustomerEntryFormOpen &&
          !this.state.isCustomerServiceOpened &&  //isCustomerSalesFormOpened
          this.state.isCustomerSalesFormOpened &&
          this.getCustomerSalesView()}
        {this.state.isCustomerListFormOpen &&
          this.state.isSpecialViewMode == false && (
            <CustomerListForm
              {...this.state}
              disabled={this.state.disabled}
              customer_list={this.state.customer_list}
              pageList={this.state.pageList}
              criteria={this.state.criteria}
              editcustomer={this.editcustomer}
              filterCustomers={this.filterCustomers}
              resetFilterCustomers={this.resetFilterCustomers}
              loadFirst={this.loadFirst}
              loadNext={this.loadNext}
              loadPrevious={this.loadPrevious}
              loadLast={this.loadLast}
              handleSortingChange={this.handleSortingChange}
            />
          )}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowSpecialUserPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel5"}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl5}
          title={"User entry form"}
          lockScroll={false}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl5}
              hideAlertCallBack={this.hideAlertCallBackLvl5}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons"
                size="sm"
                onClick={(e) => this.create_specialUser(e)}
              >
                Create User
              </Button>

              <Button
                className="header_buttons"
                size="sm"
                onClick={(e) => this.clear_specialUser(e)}
              >
                clear
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                {/* <Col className="align-items-left" sm="2">
                  <FormLabel>User Code</FormLabel>
                </Col>
                <Col className="align-items-left" sm="4">
                  <InputTextbox
                    onChange={this.specialUserOnChange}
                    name="code"
                    value={specialUser.code}
                    disabled={true}
                    isMandatory={true}
                  />
                </Col> */}
                <Col className="align-items-left" sm="2">
                  <FormLabel>User Name</FormLabel>
                </Col>
                <Col className="align-items-left" sm="4">
                  <InputTextbox
                    onChange={this.specialUserOnChange}
                    name="description"
                    value={specialUser.description}
                    isMandatory={true}
                  />
                </Col>
                {/* <Col className="align-items-left" sm="2">
                  <FormLabel>Data Portal User</FormLabel>
                </Col>
                <Col className="align-items-left" sm="1">
                  <InputCheckbox
                    type="checkbox"
                    name="isDataPortalUser"
                    checked={specialUser.isDataPortalUser}
                    onChange={this.specialUserOnChange}
                  />
                </Col>
                <Col className="align-items-left" sm="2">
                  <FormLabel>Portal User</FormLabel>
                </Col>
                <Col className="align-items-left" sm="1">
                  <InputCheckbox
                    type="checkbox"
                    name="portalUserFlag"
                    checked={specialUser.portalUserFlag}
                    onChange={this.specialUserOnChange}
                  />
                </Col> */}
              </Row>
              <Row>
                <Col className="align-items-left" sm="2">
                  <FormLabel>First Name</FormLabel>
                </Col>
                <Col className="align-items-left" sm="4">
                  <InputTextbox
                    onChange={this.specialUserOnChange}
                    name="firstName"
                    value={specialUser.firstName}
                    isMandatory={true}
                  />
                </Col>

                <Col className="align-items-left" sm="2">
                  <FormLabel>Last Name</FormLabel>
                </Col>
                <Col className="align-items-left" sm="4">
                  <InputTextbox
                    onChange={this.specialUserOnChange}
                    name="lastName"
                    value={specialUser.lastName}
                    isMandatory={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="align-items-left" sm="2">
                  <FormLabel>Password</FormLabel>
                </Col>
                <Col className="align-items-left" sm="4">
                  <InputTextbox
                    onChange={this.specialUserOnChange}
                    type="password"
                    name="password"
                    value={specialUser.password}
                    isMandatory={true}
                  />
                </Col>
                <Col className="align-items-left" sm="2">
                  <FormLabel>Confirm Password</FormLabel>
                </Col>
                <Col className="align-items-left" sm="4">
                  <InputTextbox
                    type="password"
                    onChange={this.specialUserOnChange}
                    name="confirmPassword"
                    value={specialUser.confirmPassword}
                    isMandatory={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="align-items-left" sm="2">
                  <FormLabel>Data Portal User</FormLabel>
                </Col>
                <Col className="align-items-left" sm="2">
                  <InputCheckbox
                    type="checkbox"
                    name="isDataPortalUser"
                    checked={specialUser.isDataPortalUser}
                    onChange={this.specialUserOnChange}
                    className="lvl-5-popup-checkbox"
                  />
                </Col>
                <Col className="align-items-left" sm="2">
                  <FormLabel>Portal User</FormLabel>
                </Col>
                <Col className="align-items-left" sm="1">
                  <InputCheckbox
                    type="checkbox"
                    name="portalUserFlag"
                    checked={specialUser.portalUserFlag}
                    onChange={this.specialUserOnChange}
                    className="lvl-5-popup-checkbox"
                  />
                </Col>
              </Row>
            </div>
          }
        />
      </div>
    );
  }
}
class UserEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
      roleLookupHandler: null,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setDefault();
  }
  initLookupHandlers = () => {
    //
    let roleLookupHandler = new RoleLookupHandler(this.companyCode, "Role");
    this.setState({ roleLookupHandler: roleLookupHandler });
  };

  setDefault = () => {
    const user = this.props.userData;
    user.code = NEW_ENTRY;
    const is3PL = this.props.is3PL;
    if (is3PL) user.isDataPortalUser = true;
  };
  render() {
    const userList = new Array();
    if (!isEmptyArray(this.props.userList))
      userList.push(...this.props.userList);
    const user = this.props.userData;
    // user.code = NEW_ENTRY;
    const is3PL = this.props.is3PL;
    // if (is3PL) user.isDataPortalUser = true;

    const customerData = this.props.customerData;
    return (
      <div className="header_div">
        {/* {!customerData.isMasterCustomer ? ( */}
        {/* <> */}
        <Row>
          <FormLabel>{this.props.userErrMsg}</FormLabel>
        </Row>
        <Row>
          <Col className="align-items-left" sm="1">
            <FormLabel>User Code</FormLabel>
          </Col>
          <Col className="align-items-left" sm="3">
            <InputTextbox
              onChange={this.props.userOnChange}
              name="code"
              value={user.code}
              disabled={true}
              isMandatory={true}
            />
          </Col>
          <Col className="align-items-left" sm="1">
            <FormLabel>User Name</FormLabel>
          </Col>
          <Col className="align-items-left" sm="3">
            <InputTextbox
              onChange={this.props.userOnChange}
              name="description"
              value={user.description}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            />
          </Col>
          <Col className="align-items-left" sm="1">
            <FormLabel>First Name</FormLabel>
          </Col>
          <Col className="align-items-left" sm="3">
            <InputTextbox
              onChange={this.props.userOnChange}
              name="firstName"
              value={user.firstName}
              isMandatory={true}
              disabled={this.props.isDisabledFields}
            />
          </Col>
        </Row>
        <Row>
          <Col className="align-items-left" sm="1">
            <FormLabel>Last Name</FormLabel>
          </Col>
          <Col className="align-items-left" sm="3">
            <InputTextbox
              onChange={this.props.userOnChange}
              name="lastName"
              value={user.lastName}
              isMandatory={true}
              disabled={this.props.isDisabledFields}
            />
          </Col>
          <Col className="align-items-left" sm="1">
            <FormLabel>Password</FormLabel>
          </Col>
          <Col className="align-items-left" sm="3">
            <InputTextbox
              onChange={this.props.userOnChange}
              type="password"
              name="password"
              value={user.password}
              isMandatory={true}
              disabled={this.props.isDisabledFields}
            />
          </Col>
          <Col className="align-items-left" sm="1">
            <FormLabel>Confirm Password</FormLabel>
          </Col>
          <Col className="align-items-left" sm="3">
            <InputTextbox
              type="password"
              onChange={this.props.userOnChange}
              name="confirmPassword"
              value={user.confirmPassword}
              isMandatory={true}
              disabled={this.props.isDisabledFields}
            />
          </Col>
          {/* <Col className="align-items-left" sm="1">
            <FormLabel>Role</FormLabel>
          </Col>
          <Col className="align-items-left" sm="3">
            <InputTextbox
              onChange={this.props.roleOnChange}
              name="roleCode"
              placeholder="role"
              value={user.roleCode}
              lookupRequired={true}
              lookupHandler={this.state.roleLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.props.roleEnterKeyEventHandler}
              autoCompleteListData={this.props.rolePageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.props.displayAutoCompleteRoleList}
              showAutoCompleteList={this.props.isShowAutoCompleteRoleList}
              disabled={this.props.isDisabledFields}
            />
          </Col> */}
        </Row>
        <Row>
          <Col className="align-items-left" sm="1">
            <FormLabel>Data Portal User</FormLabel>
          </Col>
          <Col className="align-items-left" sm="1">
            <InputCheckbox
              type="checkbox"
              name="isDataPortalUser"
              checked={user.isDataPortalUser}
              onChange={this.props.userOnChange}
              disabled={this.props.isDisabledFields}
            />
          </Col>
          <Col className="align-items-left" sm="1">
            <FormLabel>Portal User</FormLabel>
          </Col>
          <Col className="align-items-left" sm="1">
            <InputCheckbox
              type="checkbox"
              name="portalUserFlag"
              checked={user.portalUserFlag}
              onChange={this.props.userOnChange}
              disabled={this.props.isDisabledFields}
            />
          </Col>
        </Row>
        {/* </>
        ) : null} */}
        {is3PL ? (
          <div>
            <Table id="fabrics_tables">
              <thead>
                <tr>
                  <th>UserCode#</th>
                  <th>Name</th>
                  <th>FirstName</th>
                  <th>Lastname</th>
                </tr>
              </thead>
              <tbody>
                {userList.map((ln, i) => (
                  <tr key={i}>
                    <td>{ln.code}</td>
                    <td>{ln.description}</td>
                    <td>{ln.firstName}</td>
                    <td>{ln.lastName}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : null}
      </div>
    );
  }
}

class CustomerShipToEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      customerShipToData: this.props.customerShipToData,
      shipToAddressData: this.props.shipToAddressData,
      warehouses: this.props.warehouses,
      shipViaCodes: this.props.shipViaCodes,
      countries: this.props.countries,
      states: this.props.states,
      cities: this.props.cities,
      isDisableCustomer: this.props.isDisableCustomer,
      isDisableFields: this.props.isDisableFields,
      shipToTypeList: this.props.shipToTypeList,
    };

    this.warehouseRef = React.createRef();
    this.shipViaRef = React.createRef();
    this.stateRef = React.createRef();
    this.cityRef = React.createRef();
    this.countryRef = React.createRef();
    this.shipToRef = React.createRef();
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setFocus();
  }
  setFocus = () => {
    this.shipToRef.current.focus();
  };
  initLookupHandlers = () => {
    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.state.warehouses,
      "Warehouse"
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });

    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.state.cities,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });

    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.state.states,
      "State"
    );
    this.setState({ stateLookupHandler: stateLookupHandler });

    let shipViaLookupHandler = new GenericAttributeLookupHandler(
      this.state.shipViaCodes,
      "Shipvia"
    );
    this.setState({ shipViaLookupHandler: shipViaLookupHandler });

    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.props.countries,
      "Country"
    );
    this.setState({ countryLookupHandler: countryLookupHandler });
    let customerBillToLookupHandler = new CustomerBillToLookupHandler(
      this.companyCode,
      this.state.customerShipToData.customerCode,
      "CustomerBillTo"
    );
    this.setState({ customerBillToLookupHandler: customerBillToLookupHandler });
    let zoneCodeLookupHandler = new GenericAttributeLookupHandler(
      this.props.zones,
      "Zone"
    );
    this.setState({ zoneCodeLookupHandler: zoneCodeLookupHandler });

    let shipToTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.shipToTypeList,
      "Customer ShipTo",
      "ShipToType"

    );
    this.setState({ shipToTypeLookupHandler: shipToTypeLookupHandler });
  };
  componentDidUpdate() {
    //
  }
  onBillToChange = (e) => {
    this.props.onBillToChange(e);
  };
  billToToEnterKeyEvent = (e) => {
    this.props.billToToEnterKeyEvent(e);
  };
  displayAutoCompleteBillToList = (e) => {
    this.props.displayAutoCompleteBillToList(e);
  };



  onShipToTypeChange = (e) => {
    this.props.onShipToTypeChange(e);
  };
  shipToTypeEnterKeyEvent = (e) => {
    this.props.shipToTypeEnterKeyEvent(e);
  };
  displayAutoCompleteShipToTypeList = (e) => {
    this.props.displayAutoCompleteShipToTypeList(e);
  };
  onChange = (e) => {
    let temp_customerdata = this.props.customerShipToData;
    temp_customerdata[e.target.name] = e.target.value;

    let temp_addressData = this.props.shipToAddressData;
    if (
      e.target.name == "address1" ||
      e.target.name == "address2" ||
      e.target.name == "city" ||
      e.target.name == "state" ||
      e.target.name == "country" ||
      e.target.name == "zip" ||
      e.target.name == "mobilePhone" ||
      e.target.name == "phone1" ||
      e.target.name == "phone2" ||
      e.target.name == "contactPerson" ||
      e.target.name == "fax" ||
      e.target.name == "email" ||
      e.target.name == "website"
    ) {
      //temp_addressData['address1'] = e.target.value;
      temp_addressData[e.target.name] = e.target.value;
    }
    this.setState({
      customerShipToData: temp_customerdata,
      shipToAddressData: temp_addressData,
    });
  };

  onAddressChange = (e) => {
    let temp_addressData = this.props.shipToAddressData;

    temp_addressData[e.target.name] = e.target.value;

    this.setState({ addressData: temp_addressData });
  };

  saveCustomerShipTo = (e) => {
    this.props.saveCustomerShipTo(
      this.props.customerShipToData,
      this.props.addressData
    );
  };

  closeCustomerShipToEntryForm = (e) => {
    if (e.detail === 1) this.props.closeCustomerShipToEntryForm();
  };
  showCustomerList = () => {
    this.props.showCustomerList();
  };

  handleChange = (e) => {
    let temp_customerdata = this.props.customerShipToData;
    temp_customerdata[e.target.name] = e.target.value;
    this.setState({ customerShipToData: temp_customerdata });
  };
  onShipViaShipToChange = (e) => {
    this.props.onShipViaShipToChange(e);
  };
  shipViaShipToEnterKeyEvent = (e) => {
    this.props.shipViaShipToEnterKeyEvent(e);
  };
  displayAutoCompleteShipViaList = (e) => {
    this.props.displayAutoCompleteShipViaList(e);
  };
  onLocationShipToChange = (e) => {
    this.props.onLocationShipToChange(e);
  };
  locationShipToEnterKeyEventHandler = (e) => {
    this.props.locationShipToEnterKeyEventHandler(e);
  };
  displayAutoCompleteLocationList = (showAutoCompleteLocationList) => {
    this.props.displayAutoCompleteLocationList(showAutoCompleteLocationList);
  };
  onCityShipToChange = (e) => {
    this.props.onCityShipToChange(e);
  };
  cityShipToEnterKeyEvent = (e) => {
    this.props.cityShipToEnterKeyEvent(e);
  };
  displayAutoCompleteCityList = (showAutoCompleteCityList) => {
    this.props.displayAutoCompleteCityList(showAutoCompleteCityList);
  };
  onStateShipToChange = (e) => {
    this.props.onStateShipToChange(e);
  };
  stateShipToEnterKeyEvent = (e) => {
    this.props.stateShipToEnterKeyEvent(e);
  };
  displayAutoCompleteStateList = (showAutoCompleteStateList) => {
    this.props.displayAutoCompleteStateList(showAutoCompleteStateList);
  };
  onCountryCodeShipToChange = (e) => {
    this.props.onCountryCodeShipToChange(e);
  };
  countryCodeShipToEnterKeyEvent = (e) => {
    this.props.countryCodeShipToEnterKeyEvent(e);
  };
  displayAutoCompleteCountryCodeList = (showAutoCompleteCountryCodeList) => {
    this.props.displayAutoCompleteCountryCodeList(
      showAutoCompleteCountryCodeList
    );
  };
  render() {
    let customerShipToData = this.props.customerShipToData;
    let addressData = this.props.shipToAddressData;
    let isDisableCustomer = this.props.isDisableCustomer;
    let disableCustomerOrderFormFields = this.state.isDisableFields;
    let warehouses = this.props.warehouses;
    let shipViaCodes = this.props.shipViaCodes;
    let billTos = this.props.customerBillToList;
    if (addressData == null) addressData = new AddressBean();
    let isDisabledFields = this.props.isDisabledFields;

    return (
      <div>
        <div className="header_div col-md-12 col-lg-12">
          <Row>
            <Col sm="1">
              <FormLabel>ShipTo</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.shipToRef}
                name="code"
                type="text"
                placeholder="Enter ShipTo"
                readOnly={isDisableCustomer}
                // disabled={disableCustomerOrderFormFields}
                onChange={this.onChange}
                value={customerShipToData.code}
                isMandatory={true}
                disabled={isDisabledFields}
              // disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>ShipToName</FormLabel>{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="description"
                type="text"
                placeholder="Enter ShipTo Name"
                onChange={this.onChange}
                value={customerShipToData.description}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>ShipToType</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="shipToType"
                //type="text"
                placeholder="Enter shipToType"
                onChange={this.onShipToTypeChange}
                value={customerShipToData.shipToType}
                lookupRequired={true}
                lookupHandler={this.state.shipToTypeLookupHandler}
                enterKeyEventHandler={this.shipToTypeEnterKeyEvent}
                autoCompleteListData={
                  this.props.shipToTypePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteShipToTypeList}
                showAutoCompleteList={this.props.showAutoCompleteShipToTypeList}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>

            <Col sm="1">
              <FormLabel>BillTo</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="billToCode"
                //type="text"
                placeholder="Enter BillToCode"
                onChange={this.onBillToChange}
                value={customerShipToData.billToCode}
                lookupRequired={true}
                lookupHandler={this.state.customerBillToLookupHandler}
                enterKeyEventHandler={this.billToToEnterKeyEvent}
                autoCompleteListData={
                  this.props.billToPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteBillToList}
                showAutoCompleteList={this.props.showAutoCompleteBillToList}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>

          </Row>

          <Row>

            <Col sm="1">
              <FormLabel>ShipVia</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onShipViaShipToChange}
                ref={this.shipViaRef}
                name="shipViaCode"
                placeholder="shipViaCode"
                value={customerShipToData.shipViaCode}
                lookupRequired={true}
                lookupHandler={this.state.shipViaLookupHandler}
                enterKeyEventHandler={this.shipViaShipToEnterKeyEvent}
                autoCompleteListData={
                  this.props.shipViaPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteShipViaList}
                showAutoCompleteList={this.props.showAutoCompleteShipViaList}
                disabled={isDisabledFields}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <FormLabel>Zone</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.props.zoneOnChange}
                name="zoneCode"
                placeholder="zoneCode"
                value={customerShipToData.zoneCode}
                lookupRequired={true}
                lookupHandler={this.state.zoneCodeLookupHandler}
                enterKeyEventHandler={this.props.zoneEnterKeyEvent}
                autoCompleteListData={
                  this.props.zonePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.props.displayAutoCompleteZoneList}
                showAutoCompleteList={this.props.showAutoCompleteZoneList}
                disabled={isDisabledFields}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>WareHouse</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onLocationShipToChange}
                ref={this.warehouseRef}
                name="locationCode"
                placeholder="locationCode"
                value={customerShipToData.locationCode}
                lookupRequired={true}
                lookupHandler={this.state.warehouseLookupHandler}
                enterKeyEventHandler={this.locationShipToEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.locationPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteLocationList}
                showAutoCompleteList={this.props.showAutoCompleteLocationList}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>Comments</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="comments"
                placeholder="Enter Comments"
                onChange={this.onChange}
                value={customerShipToData.comments}
                disabled={isDisabledFields}
              />{" "}
            </Col>

          </Row>

          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Instructions</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="instructions"
                type="text"
                placeholder="Enter Instructions"
                onChange={this.onChange}
                value={customerShipToData.instructions}
                disabled={isDisabledFields}
              />{" "}
            </Col>


            <Col sm="1">
              <FormLabel>StopShipDays</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <NumberFormatInputbox
                onChange={this.onChange}
                name="stopShipDays"
                value={customerShipToData.stopShipDays}
                disabled={isDisabledFields}
              ></NumberFormatInputbox>
              {""}
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>Active</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputCheckbox
                name="isActive"
                type="checkbox"
                checked={customerShipToData.isActive}
                onChange={this.onChange}
                disabled={isDisabledFields}
              />
            </Col>
          </Row>

          <Row>
            <Col sm="2">
              <FormLabel className="address">Address</FormLabel>
            </Col>
          </Row>
          <hr class="row_border"></hr>

          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Address1</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="address1"
                type="text"
                placeholder="Enter Address"
                onChange={this.onAddressChange}
                value={addressData.address1}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Address2</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="address2"
                type="text"
                placeholder="Enter Address2"
                onChange={this.onAddressChange}
                value={addressData.address2}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>City</FormLabel>{" "}
            </Col>
            <Col>
              <InputTextbox
                onChange={this.onCityShipToChange}
                ref={this.cityRef}
                name="city"
                placeholder="city"
                value={addressData.city}
                lookupRequired={true}
                lookupHandler={this.state.cityLookupHandler}
                enterKeyEventHandler={this.cityShipToEnterKeyEvent}
                autoCompleteListData={
                  this.props.cityPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCityList}
                showAutoCompleteList={this.props.showAutoCompleteCityList}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>State</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onStateShipToChange}
                ref={this.stateRef}
                name="state"
                placeholder="state"
                value={addressData.state}
                lookupRequired={true}
                lookupHandler={this.state.stateLookupHandler}
                enterKeyEventHandler={this.stateShipToEnterKeyEvent}
                autoCompleteListData={
                  this.props.statePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteStateList}
                showAutoCompleteList={this.props.showAutoCompleteStateList}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>

          </Row>
          <Row>

            <Col sm="1">
              {" "}
              <FormLabel>Country</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.onCountryCodeShipToChange}
                ref={this.countryRef}
                name="country"
                placeholder="country"
                value={addressData.country}
                lookupRequired={true}
                lookupHandler={this.state.countryLookupHandler}
                enterKeyEventHandler={this.countryCodeShipToEnterKeyEvent}
                autoCompleteListData={
                  this.props.countryCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteCountryCodeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteCountryCodeList
                }
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Zip</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="zip"
                type="text"
                placeholder="Enter Zip"
                onChange={this.onAddressChange}
                value={addressData.zip}
                disabled={isDisabledFields}
              />{" "}
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>ContactPerson</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="contactPerson"
                type="text"
                placeholder="Enter ContactPerson"
                onChange={this.onAddressChange}
                value={addressData.contactPerson}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Mobile</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="mobilePhone"
                type="text"
                placeholder="Enter Mobile#"
                onChange={this.onAddressChange}
                value={addressData.mobilePhone}
                disabled={isDisabledFields}
              />{" "}
            </Col>

          </Row>
          <Row>

            <Col sm="1">
              {" "}
              <FormLabel>Phone1#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="phone1"
                type="text"
                placeholder="Enter Phone#"
                onChange={this.onAddressChange}
                value={addressData.phone1}
                disabled={isDisabledFields}
              />{" "}
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>Phone2#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="phone2"
                type="text"
                onChange={this.onAddressChange}
                value={addressData.phone2}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Fax</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="fax"
                type="text"
                placeholder="Enter fax"
                onChange={this.onAddressChange}
                value={addressData.fax}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Email</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="email"
                type="text"
                placeholder="Enter Email"
                onChange={this.onAddressChange}
                value={addressData.email}
                disabled={isDisabledFields}
              />{" "}
            </Col>

          </Row>
          <Row>

            <Col sm="1">
              {" "}
              <FormLabel>Website</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="website"
                type="text"
                placeholder="Enter website"
                onChange={this.onAddressChange}
                value={addressData.website}
                disabled={isDisabledFields}
              />{" "}
            </Col>


          </Row>
          <Row className="d-flex justify-content-center">
            <Col sm="4">
              <Button
                className="addToButton"
                onClick={(e) => this.closeCustomerShipToEntryForm(e)}
              >
                {" "}
                Back{" "}
              </Button>
            </Col>
          </Row>
          <br />
        </div>
      </div>
    );
  }
}

class CustomerShipToListForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      customerShipToList: this.props.customerShipToList,
      pageList: new PageListBean(),
      criteria: new CustomerSearchCriteria(),
    };
  }
  componentDidMount() {
    //
  }
  componentDidUpdate() {
    //
  }
  onChange = (e) => {
    let criteria = this.props.criteria;

    if (e.target.name == "criteriakey") {
      criteria["customerNameContains"] = e.target.value;
      //criteria["customerCodeContains"] = e.target.value;
      criteria["customerCodeStartsWith"] = e.target.value;
    }
    this.setState({ criteria: criteria });
  };
  editShipTo = (val, rowData) => {
    this.props.editShipTo(val);
  };
  filterShipTo = () => {
    this.props.filterShipTo();
  };
  loadFirst = () => {
    this.props.loadFirst();
  };
  loadNext = () => {
    this.props.loadNext();
  };
  loadPrevious = () => {
    this.props.loadPrevious();
  };
  loadLast = () => {
    this.props.loadLast();
  };
  handleChange = (e) => { };
  deleteShipToButtonClick = (val, rowData) => {
    this.props.deleteShipToButtonClick(val, rowData);
  };

  // shipToListColumn = () => {
  //   const columns = new Array();
  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("ShipTo", "code", true)
  //       .setStyleDetails("left", "", "", "wt-2 ", "wt-2")
  //       .setClickDetails(true, false, this.editShipTo, null)
  //   );
  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("ShipToName", "description", true)
  //       .setStyleDetails("left", "", "", "wt-2", "wt-2")
  //   );
  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("ShipToType", "shipToType", true)
  //       .setStyleDetails("left", "", "", "wt-2", "wt-2")
  //   );
  //   columns.push(
  //     new ColumnDefinition()
  //       .setDetails("Address1", "address.address1", true)
  //       .setStyleDetails("left", "", "", "wt-2", "wt-2")
  //   );

  //   return columns;
  // }
columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "ShipTo",
        "code",
        0,
        true,
        this.editShipTo
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("ShipToName", "description")
    );
        columnList.push(
      new DataGridColumnDefinition().setDetails("Type", "shipToType")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Address1", "address1")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Address2", "address2")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("City", "city")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("State", "state")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Country", "country")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Zip", "zip")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Phone", "phone1")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Fax", "fax")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Email", "email")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Website", "website")
    );
 
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "Remove",
          <DeleteIcon />,
          1,
          false,
          null,
          false,
          null, //image link call back
          "1em", //min-width
          "3%", //max-width
          false,
          null
        )
        .setEditableDetails(
          false,
          "",
          null,
          true,
          this.deleteShipToButtonClick,
          false,
          null
        )
        .setDisabled(this.props.isDisabledFields)
    );
 
    return columnList;
  };

  render() {
    let shipToList = (this.props.customerShipToList || []).map((shipTo) => ({
      ...shipTo,
      address1: shipTo.address?.address1,
      address2: shipTo.address?.address2,
      city: shipTo.address?.city,
      state: shipTo.address?.state,
      country: shipTo.address?.country,
      zip: shipTo.address?.zip,
      phone1: shipTo.address?.phone1,
      fax: shipTo.address?.fax,
      email: shipTo.address?.email,
      website: shipTo.address?.website,
    }));
    return (
      <div className="header_div">
        <div className="div_default">
          {/* <CustomTable
            data={shipToList}
            columns={this.shipToListColumn()}
          // label={"Commission"}
          /> */}
          <EditableDataGrid
            columnsList={this.columnDefinitions()}
            dataList={shipToList}
          />
        </div>
      </div>
    );
  }
}

class CustomerBillToListForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      customerBillToList: this.props.customerBillToList,
      pageList: new PageListBean(),
      criteria: new CustomerSearchCriteria(),
    };
  }

  componentDidMount() {
    //
  }

  componentDidUpdate() {
    //
  }

  onChange = (e) => {
    let criteria = this.props.criteria;

    if (e.target.name == "criteriakey") {
      criteria["customerNameContains"] = e.target.value;
      criteria["customerCodeStartsWith"] = e.target.value;
    }

    this.setState({ criteria: criteria });
  };

  editBillTo = (billToCode) => {
    this.props.editBillTo(billToCode);
  };

  filterBillTo = () => {
    this.props.filterBillTo();
  };

  loadFirst = () => {
    this.props.loadFirst();
  };
  loadNext = () => {
    this.props.loadNext();
  };
  loadPrevious = () => {
    this.props.loadPrevious();
  };
  loadLast = () => {
    this.props.loadLast();
  };

  handleChange = (e) => { };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "BillTo",
        "code",
        0,
        true,
        this.editBillTo
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("BillToName", "description")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("ShipVia", "shipViaCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Address1", "address.address1")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Address2", "address.address2")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("City", "address.city")
    );
    // columnList.push(
    //   new DataGridColumnDefinition().setDetails("State", "address.state")
    // );
    // columnList.push(
    //   new DataGridColumnDefinition().setDetails("Country", "address.country")
    // );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Zip", "address.zip")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Phone", "address.phone1")
    );
    // columnList.push(
    //   new DataGridColumnDefinition().setDetails("Fax", "address.fax")
    // );
    // columnList.push(
    //   new DataGridColumnDefinition().setDetails("Email", "address.email")
    // );
    // columnList.push(
    //   new DataGridColumnDefinition().setDetails("Website", "address.website")
    // );
    return columnList;
  };

  render() {
    let billToList = this.props.customerBillToList;

    return (
      <div className="header_div">
        <div className="div_default">
          <EditableDataGrid
            columnsList={this.columnDefinitions()}
            dataList={billToList}
          />
        </div>
      </div>
    );
  }
}

class CustomerBillToEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      customerBillToData: this.props.customerBillToData,
      billToAddressData: this.props.billToAddressData,
      paymentTerms: this.props.paymentTerms,
      shipViaCodes: this.props.shipViaCodes,
      paymentMethods: this.props.paymentMethods,
      invoiceTemplates: this.props.invoiceTemplates,
      countries: this.props.countries,
      states: this.props.states,
      cities: this.props.cities,
      isDisableCustomerBillTo: this.props.isDisableCustomerBillTo,
      isDisableFields: this.props.isDisableFields,
    };
    this.countryRef = React.createRef();
    this.cityRef = React.createRef();
    this.paymentTermRef = React.createRef();
    this.paymentMethodRef = React.createRef();
    this.stateRef = React.createRef();
    this.invoiceTemplateRef = React.createRef();
    this.shipViaRef = React.createRef();
    this.billToRef = React.createRef();
  }

  componentDidMount() {
    //
    this.initLookupHandlers();
    this.setFocus();
  }
  setFocus = () => {
    this.billToRef.current.focus();
  };
  initLookupHandlers = () => {
    let paymentTermLookupHandler = new GenericAttributeLookupHandler(
      this.props.paymentTerms,
      "Payment Term"
    );
    this.setState({ paymentTermLookupHandler: paymentTermLookupHandler });

    let paymentMethodLookupHandler = new GenericAttributeLookupHandler(
      this.props.paymentMethods,
      "Payment Method"
    );
    this.setState({ paymentMethodLookupHandler: paymentMethodLookupHandler });

    let invoiceTemplateLookupHandler = new GenericAttributeLookupHandler(
      this.props.invoiceTemplates,
      "InvoiceTemplate"
    );


    this.setState({
      invoiceTemplateLookupHandler: invoiceTemplateLookupHandler,
    });

    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.props.states,
      "State"
    );
    this.setState({ stateLookupHandler: stateLookupHandler });

    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.props.cities,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });

    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.props.countries,
      "Country"
    );
    this.setState({ countryLookupHandler: countryLookupHandler });

    let shipViaLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipViaCodes,
      "ShipVia"
    );
    this.setState({ shipViaLookupHandler: shipViaLookupHandler });

    let currencyLookupHandler = new GenericAttributeLookupHandler(
      this.props.currencies,
      "Currency"
    );
    this.setState({ currencyLookupHandler: currencyLookupHandler });
  };

  componentDidUpdate() {
    //
  }
  getNodeList = () => {
    let nodeList = [];
    let emptyObject = this.getEmptyView();

    let optionNode = new NodeData("optionsView", "Options", emptyObject);

    nodeList["optionsView"] = optionNode;

    this.setState({ nodeList: nodeList });
  };

  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "optionsView") {
      this.setOptionsView();
    }
  };
  setOptionsView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowOptionAmount: true,
    });
  };
  closeAllNodeViews = () => {
    this.setState({
      isShowOptionAmount: false,
    });
  };
  onCityBillToChange = (e) => {
    this.props.onCityBillToChange(e);
  };
  cityBillToEnterKeyEvent = (e) => {
    this.props.cityBillToEnterKeyEvent(e);
  };
  displayAutoCompleteCityList = (showAutoCompleteCityList) => {
    this.props.displayAutoCompleteCityList(showAutoCompleteCityList);
  };
  onStateBillToChange = (e) => {
    this.props.onStateBillToChange(e);
  };
  stateBillToEnterKeyEvent = (e) => {
    this.props.stateBillToEnterKeyEvent(e);
  };
  displayAutoCompleteStateList = (showAutoCompleteStateList) => {
    this.props.displayAutoCompleteStateList(showAutoCompleteStateList);
  };
  onCountryCodeBillToChange = (e) => {
    this.props.onCountryCodeBillToChange(e);
  };
  countryCodeBillToEnterKeyEvent = (e) => {
    this.props.countryCodeBillToEnterKeyEvent(e);
  };
  displayAutoCompleteCountryCodeList = (showAutoCompleteCountryCodeList) => {
    this.props.displayAutoCompleteCountryCodeList(
      showAutoCompleteCountryCodeList
    );
  };
  onCurrencyBillToChange = (e) => {
    this.props.onCurrencyBillToChange(e);
  };
  currencyBillToEnterKeyEvent = (e) => {
    this.props.currencyBillToEnterKeyEvent(e);
  };
  displayAutoCompleteCurrencyList = (showAutoCompleteCurrencyCodeList) => {
    this.props.displayAutoCompleteCurrencyList(
      showAutoCompleteCurrencyCodeList
    );
  };
  onShipViaBillToChange = (e) => {
    this.props.onShipViaBillToChange(e);
  };
  shipViaBillToEnterKeyEvent = (e) => {
    this.props.shipViaBillToEnterKeyEvent(e);
  };
  displayAutoCompleteShipViaList = (showAutoCompleteShipViaList) => {
    this.props.displayAutoCompleteShipViaList(showAutoCompleteShipViaList);
  };

  onPaymentTypeBillToChange = (e) => {
    this.props.onPaymentTypeBillToChange(e);
  };
  paymentTypeBillToEnterKeyEventHandler = (e) => {
    this.props.paymentTypeBillToEnterKeyEventHandler(e);
  };
  displayAutoCompletePaymentTypeList = (e) => {
    this.props.displayAutoCompletePaymentTypeList(e);
  };
  onInvoiceTemplateBillToCodeChange = (e) => {
    this.props.onInvoiceTemplateBillToCodeChange(e);
  };
  invoiceTemplateBillToCodeEnterKeyEvent = (e) => {
    this.props.invoiceTemplateBillToCodeEnterKeyEvent(e);
  };
  displayAutoCompleteInvoiceTemplateCodeList = (e) => {
    this.props.displayAutoCompleteInvoiceTemplateCodeList(e);
  };
  onPaymentTermBillToChange = (e) => {
    this.props.onPaymentTermBillToChange(e);
  };
  paymentTermBillToEnterKeyEventHandler = (e) => {
    this.props.paymentTermBillToEnterKeyEventHandler(e);
  };
  displayAutoCompletePaymentTermList = (showAutoCompletePaymentTermList) => {
    this.props.displayAutoCompletePaymentTermList(
      showAutoCompletePaymentTermList
    );
  };

  onChange = (e) => {
    let temp_customerdata = this.props.customerBillToData;
    temp_customerdata[e.target.name] = e.target.value;

    let temp_addressData = this.props.billToAddressData;
    if (
      e.target.name == "address1" ||
      e.target.name == "address2" ||
      e.target.name == "city" ||
      e.target.name == "state" ||
      e.target.name == "country" ||
      e.target.name == "zip" ||
      e.target.name == "mobilePhone" ||
      e.target.name == "phone1" ||
      e.target.name == "phone2" ||
      e.target.name == "contactPerson" ||
      e.target.name == "fax" ||
      e.target.name == "email" ||
      e.target.name == "website"
    ) {
      //temp_addressData['address1'] = e.target.value;
      temp_addressData[e.target.name] = e.target.value;
    }
    this.setState({
      customerBillToData: temp_customerdata,
      billToAddressData: temp_addressData,
    });
  };

  onAddressChange = (e) => {
    let temp_addressData = this.props.billToAddressData;

    temp_addressData[e.target.name] = e.target.value;

    this.setState({ addressData: temp_addressData });
  };

  saveCustomerBillTo = (e) => {
    this.props.saveCustomerBillTo(
      this.props.customerBillToData,
      this.props.addressData
    );
  };

  closeCustomerBillToEntryForm = (e) => {
    if (e.detail === 1) this.props.closeCustomerBillToEntryForm();
  };
  showCustomerList = () => {
    this.props.showCustomerList();
  };

  handleChange = (e) => {
    let temp_customerdata = this.props.customerBillToData;
    temp_customerdata[e.target.name] = e.target.value;
    this.setState({ customerBillToData: temp_customerdata });
  };

  render() {
    let customerBillToData = this.props.customerBillToData;
    let addressData = this.props.billToAddressData;
    let paymentTerms = this.props.paymentTerms;
    let shipViaCodes = this.props.shipViaCodes;
    let invoiceTemplates = this.props.invoiceTemplates;
    let paymentMethods = this.props.paymentMethods;
    let isDisableCustomerBillTo = this.props.isDisableCustomerBillTo;
    let disableCustomerOrderFormFields = this.state.isDisableFields;
    if (paymentMethods == null) paymentMethods = [];
    if (invoiceTemplates == null) invoiceTemplates = [];
    if (paymentTerms == null) paymentTerms = [];

    if (addressData == null) addressData = new AddressBean();
    let isDisabledFields = this.props.isDisabledFields;
    return (
      <div>
        <div className="header_div col-md-12 col-lg-12">
          <Row>
            <Col sm="1">
              <FormLabel>BillTo</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.billToRef}
                name="code"
                type="text"
                placeholder="Enter BillTo"
                readOnly={isDisableCustomerBillTo}
                // disabled={disableCustomerOrderFormFields}
                onChange={this.onChange}
                value={customerBillToData.code}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>BillTo Name</FormLabel>{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="description"
                type="text"
                placeholder="Enter BillTo Name"
                onChange={this.onChange}
                value={customerBillToData.description}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>

            <Col sm="1">
              <FormLabel>Currency</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="currencyCode"
                type="text"
                placeholder="Enter Currency"
                onChange={this.onCurrencyBillToChange}
                value={customerBillToData.currencyCode}
                lookupRequired={true}
                lookupHandler={this.state.currencyLookupHandler}
                enterKeyEventHandler={this.currencyBillToEnterKeyEvent}
                autoCompleteListData={
                  this.props.currencyCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCurrencyList}
                showAutoCompleteList={
                  this.props.showAutoCompleteCurrencyCodeList
                }
                disabled={isDisabledFields}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>ShipVia</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onShipViaBillToChange}
                ref={this.shipViaRef}
                name="shipViaCode"
                placeholder="shipViaCode"
                value={customerBillToData.shipViaCode}
                lookupRequired={true}
                lookupHandler={this.state.shipViaLookupHandler}
                enterKeyEventHandler={this.shipViaBillToEnterKeyEvent}
                autoCompleteListData={
                  this.props.shipViaPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteShipViaList}
                showAutoCompleteList={this.props.showAutoCompleteShipViaList}
                disabled={isDisabledFields}
                isMandatory={true}
              ></InputTextbox>
            </Col>
          </Row>

          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>PaymentTerms</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onPaymentTermBillToChange}
                ref={this.paymentTermRef}
                name="paymentTermsCode"
                placeholder="paymentTermsCode"
                value={customerBillToData.paymentTermsCode}
                lookupRequired={true}
                lookupHandler={this.state.paymentTermLookupHandler}
                enterKeyEventHandler={
                  this.paymentTermBillToEnterKeyEventHandler
                }
                autoCompleteListData={
                  this.props.paymentTermPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompletePaymentTermList
                }
                showAutoCompleteList={
                  this.props.showAutoCompletePaymentTermList
                }
                disabled={isDisabledFields}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <FormLabel>PaymentMethods</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onPaymentTypeBillToChange}
                ref={this.paymentMethodRef}
                name="paymentMethodCode"
                placeholder="paymentMethodCode"
                value={customerBillToData.paymentMethodCode}
                lookupRequired={true}
                lookupHandler={this.state.paymentMethodLookupHandler}
                enterKeyEventHandler={
                  this.paymentTypeBillToEnterKeyEventHandler
                }
                autoCompleteListData={
                  this.props.paymentTypePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompletePaymentTypeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompletePaymentTypeList
                }
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>InvoiceTemplate</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onInvoiceTemplateBillToCodeChange}
                ref={this.invoiceTemplateRef}
                name="invoiceTemplateCode"
                placeholder="invoiceTemplateCode"
                value={customerBillToData.invoiceTemplateCode}
                lookupRequired={true}
                lookupHandler={this.state.invoiceTemplateLookupHandler}
                enterKeyEventHandler={
                  this.invoiceTemplateBillToCodeEnterKeyEvent
                }
                autoCompleteListData={
                  this.props.invoiceTemplateCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteInvoiceTemplateCodeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteInvoiceTemplateCodeList
                }
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>Comments</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="comments"
                type="text"
                placeholder="Enter Comments"
                onChange={this.onChange}
                value={customerBillToData.comments}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>

          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Address1</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="address1"
                type="text"
                placeholder="Enter Address"
                onChange={this.onAddressChange}
                value={addressData.address1}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Address2</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="address2"
                type="text"
                placeholder="Enter Address2"
                onChange={this.onAddressChange}
                value={addressData.address2}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>City</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onCityBillToChange}
                ref={this.cityRef}
                name="city"
                placeholder="city"
                value={addressData.city}
                lookupRequired={true}
                lookupHandler={this.state.cityLookupHandler}
                enterKeyEventHandler={this.cityBillToEnterKeyEvent}
                autoCompleteListData={
                  this.props.cityPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCityList}
                showAutoCompleteList={this.props.showAutoCompleteCityList}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>State</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.onStateBillToChange}
                ref={this.stateRef}
                name="state"
                placeholder="state"
                value={addressData.state}
                lookupRequired={true}
                lookupHandler={this.state.stateLookupHandler}
                enterKeyEventHandler={this.stateBillToEnterKeyEvent}
                autoCompleteListData={
                  this.props.statePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteStateList}
                showAutoCompleteList={this.props.showAutoCompleteStateList}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Country</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onCountryCodeBillToChange}
                ref={this.countryRef}
                name="country"
                placeholder="country"
                value={addressData.country}
                lookupRequired={true}
                lookupHandler={this.state.countryLookupHandler}
                enterKeyEventHandler={this.countryCodeBillToEnterKeyEvent}
                autoCompleteListData={
                  this.props.countryCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteCountryCodeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteCountryCodeList
                }
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Zip</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="zip"
                type="text"
                placeholder="Enter Zip"
                onChange={this.onAddressChange}
                value={addressData.zip}
                disabled={isDisabledFields}
              />{" "}
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>ContactPerson</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="contactPerson"
                type="text"
                placeholder="Enter ContactPerson"
                onChange={this.onAddressChange}
                value={addressData.contactPerson}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Mobile</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="mobilePhone"
                type="text"
                placeholder="Enter Mobile#"
                onChange={this.onAddressChange}
                value={addressData.mobilePhone}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Phone1</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="phone1"
                type="text"
                placeholder="Enter Phone#"
                onChange={this.onAddressChange}
                value={addressData.phone1}
                disabled={isDisabledFields}
              />{" "}
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>Email</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="email"
                type="text"
                placeholder="Enter Email"
                onChange={this.onAddressChange}
                value={addressData.email}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Instructions</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="instructions"
                type="text"
                placeholder="Enter Instructions"
                onChange={this.onChange}
                value={customerBillToData.instructions}
                disabled={isDisabledFields}
              />{" "}
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>Active</FormLabel>{" "}
            </Col>
            <Col sm="1">
              {" "}
              <InputCheckbox
                name="isActive"
                type="checkbox"
                checked={customerBillToData.isActive}
                onChange={this.onChange}
                disabled={isDisabledFields}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <FormLabel className="professional_details">Options</FormLabel>
            </Col>
          </Row>
          <hr class="row_border"></hr>

          <Row>
            <Col sm="2">
              {" "}
              <FormLabel>FreightChange </FormLabel>{" "}
            </Col>
            <Col sm="1">
              {" "}
              <InputCheckbox
                name="freightChageFlag"
                onChange={this.onChange}
                checked={customerBillToData.freightChageFlag}
                disabled={isDisabledFields}
              />{" "}
            </Col>

            <Col sm="2">
              {" "}
              <FormLabel>PackingSlip </FormLabel>{" "}
            </Col>
            <Col sm="1">
              {" "}
              <InputCheckbox
                name="packingSlipRequiredFlag"
                onChange={this.onChange}
                checked={customerBillToData.packingSlipRequiredFlag}
                disabled={isDisabledFields}
              />{" "}
            </Col>

            <Col sm="2">
              {" "}
              <FormLabel> CityTax </FormLabel>{" "}
            </Col>
            <Col sm="1">
              {" "}
              <InputCheckbox
                name="cityTaxRequiredFlag"
                onChange={this.onChange}
                checked={customerBillToData.cityTaxRequiredFlag}
                disabled={isDisabledFields}
              />{" "}
            </Col>

            <Col sm="2">
              {" "}
              <FormLabel>Bulk Invoice </FormLabel>{" "}
            </Col>
            <Col sm="1">
              {" "}
              <InputCheckbox
                name="bulkInvoiceFlag"
                onChange={this.onChange}
                checked={customerBillToData.bulkInvoiceFlag}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <br />
          <Row>
            <Col sm="2">
              {" "}
              <FormLabel>Invoice Edit</FormLabel>{" "}
            </Col>
            <Col sm="1">
              {" "}
              <InputCheckbox
                name="invoiceEditFlag"
                //type="text"
                onChange={this.onChange}
                checked={customerBillToData.invoiceEditFlag}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="2">
              {" "}
              <FormLabel> SalesTax </FormLabel>{" "}
            </Col>
            <Col sm="1">
              {" "}
              <InputCheckbox
                name="salesTaxRequiredFlag"
                onChange={this.onChange}
                checked={customerBillToData.salesTaxRequiredFlag}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>

          <Row className="d-flex justify-content-center">
            <Col sm="4">
              <Button
                className="addToButton"
                onClick={(e) => this.closeCustomerBillToEntryForm(e)}
              >
                {" "}
                Back{" "}
              </Button>
            </Col>
          </Row>
          <br />
        </div>
      </div>
    );
  }
}

class CustomerListForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showHide: this.props.showHide,
      customer_list: this.props.customer_list,
      editcustomer: this.props.editcustomer,
      pageList: new PageListBean(),
      criteria: new CustomerSearchCriteria(),
    };
    this.searchRef = React.createRef();
  }

  componentDidMount() {
    //
    if (this.searchRef.current != null) {
      this.searchRef.current.focus();
    }
  }

  componentDidUpdate() {
    //
  }

  onChange = (e) => {
    let criteria = this.props.criteria;
    // criteria["searchName"] = e.target.value;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };

  editcustomer = (e, customerCode) => {
    if (e.detail === 1) this.props.editcustomer(customerCode);
  };

  filterCustomers = (e) => {
    if (e.detail === 1) this.props.filterCustomers();
  };

  resetFilterCustomers = (e) => {
    if (e.detail === 1) this.props.resetFilterCustomers();
  };

  loadFirst = (e) => {
    if (e.detail === 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail === 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail === 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail === 1) this.props.loadLast();
  };
  // editcustomer = (e,val, rowData) => {
  //   if (e.detail === 1)
  //   this.props.editcustomer(val);
  // };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterCustomers();
    }
  };
  render() {
    let customer_list = new Array();
    if (!isEmptyArray(this.props.customer_list)) {
      customer_list = this.props.customer_list;
    }
    let isLoading = this.props.isLoading;
    let item_list = this.props.item_list;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    if (!isEmpty(pageList)) {
      let pageSize = pageList.pageSize;
      let totalCount = pageList.totalCount;
      totalPages = totalCount / pageSize;
      totalPages += totalCount % pageSize == 0 ? 0 : 1;
    }

    return (
      <div>
        <div className="secondary_module_header">
          <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="searchName"
                type="text"
                value={criteria.searchName}
                placeholder="Enter Value to Filter.."
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
            </span>
            <span className="px-2"></span>
            <Button onClick={(e) => this.filterCustomers(e)}>Filter</Button>
            <span className="px-2"></span>
            <Button onClick={(e) => this.resetFilterCustomers(e)}>Reset</Button>
          </div>

          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>

            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  CustomerCode
                  {this.props.order === "desc" &&
                    this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  CustomerName
                  {this.props.order === "desc" &&
                    this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "customerTypeCode")
                  }
                >
                  CustomerType
                  {this.props.order === "desc" &&
                    this.props.sortField === "customerTypeCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "currencyCode")}
                >
                  Currency
                  {this.props.order === "desc" &&
                    this.props.sortField === "currencyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "shipViaCode")}>
                  ShipVia
                  {this.props.order === "desc" &&
                    this.props.sortField === "shipViaCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "paymentMethodCode")
                  }
                >
                  PaymentMethod
                  {this.props.order === "desc" &&
                    this.props.sortField === "paymentMethodCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "paymentTermsCode")
                  }
                >
                  PaymentTerm
                  {this.props.order === "desc" &&
                    this.props.sortField === "paymentTermsCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "isMasterCustomer")
                  }
                >
                  Master Customer
                  {this.props.order === "desc" &&
                    this.props.sortField === "isMasterCustomer" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {customer_list != null ? (
              <tbody>
                {customer_list.map((customer, index) => (
                  <tr key={index}>
                    <td className="hyperLinkText">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.editcustomer(e, customer.code)}
                      >
                        {customer.code}
                      </Button>
                    </td>
                    <td>{customer.description}</td>
                    <td>{customer.customerTypeCode}</td>
                    <td>{customer.currencyCode}</td>
                    <td>{customer.shipViaCode}</td>
                    <td>{customer.paymentMethodCode}</td>
                    <td>{customer.paymentTermsCode}</td>
                    <td>{customer.isMasterCustomer.toString()}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {customer_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class CustomerEntryForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.paymentMethodRef = React.createRef();
    this.paymentTermRef = React.createRef();
    this.warehouseRef = React.createRef();
    this.customerTypeRef = React.createRef();
    this.currencyRef = React.createRef();
    this.countryRef = React.createRef();
    this.stateRef = React.createRef();
    this.cityRef = React.createRef();
    this.shipViaRef = React.createRef();
    this.custNameRef = React.createRef();
    this.divisionRef = React.createRef();
    this.accountRepresentativeRef = React.createRef();
    this.zoneCodeRef = React.createRef();
    this.invoiceTemplateRef = React.createRef();

    this.state = {
      showHide: this.props.showHide,
      customerData: this.props.customerData,
      addressData: this.props.addressData,
      warehouses: this.props.warehouses,
      customerTypes: this.props.customerTypes,
      currencies: this.props.currencies,
      paymentMethods: this.props.paymentMethods,
      paymentTerms: this.props.paymentTerms,
      countries: this.props.countries,
      states: this.props.states,
      cities: this.props.cities,
      division: this.props.division,
      zones: this.props.zones,
      invoiceTemplate: this.props.invoiceTemplate,
      isfetched: this.props.isfetched,
      customerTypeLookupHandler: null,
      isShowAdress: true,
      isShowShipmentAmount: false,
      isShowOtherDetailAmount: false,
      isShowOptionAmount: false,
      isShowComments: false,
      nodeList: [],
      isShowNodes: false,
      selectedNodeKey: "adressView",
      arTypes: this.props.arTypes,
      customerDeliveries: this.props.customerDeliveries,
      financialTypes: this.props.financialTypes,
      masterCusLookupHandler: null,
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setCustFocus();
    this.getNodeList();
  }

  componentDidUpdate() {

  }

  setCustFocus = () => {
    if (this.props.isFocus == true) this.custNameRef.current.focus();
  };
  initLookupHandlers = () => {
    let masterCusLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ masterCusLookupHandler: masterCusLookupHandler });

    let customerTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.customerTypes,
      "Customer Type"
    );
    this.setState({ customerTypeLookupHandler: customerTypeLookupHandler });

    let currencyLookupHandler = new GenericAttributeLookupHandler(
      this.state.currencies,
      "Currency"
    );
    this.setState({ currencyLookupHandler: currencyLookupHandler });

    let paymentMethodLookupHandler = new GenericAttributeLookupHandler(
      this.state.paymentMethods,
      "Payment Method"
    );
    this.setState({ paymentMethodLookupHandler: paymentMethodLookupHandler });

    let paymentTermLookupHandler = new GenericAttributeLookupHandler(
      this.state.paymentTerms,
      "Payment Term"
    );
    this.setState({ paymentTermLookupHandler: paymentTermLookupHandler });

    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.state.warehouses,
      "Warehouse"
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });

    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.state.cities,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });

    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.state.states,
      "State"
    );
    this.setState({ stateLookupHandler: stateLookupHandler });

    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.state.countries,
      "Country"
    );
    this.setState({ countryLookupHandler: countryLookupHandler });
    let shipViaLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipViaCodes,
      "ShipVia"
    );
    this.setState({ shipViaLookupHandler: shipViaLookupHandler });

    let zoneCodeLookupHandler = new GenericAttributeLookupHandler(
      this.state.zones,
      "Zone"
    );
    this.setState({ zoneCodeLookupHandler: zoneCodeLookupHandler });

    let divisionLookupHandler = new GenericAttributeLookupHandler(
      this.state.division,
      "Division"
    );
    this.setState({ divisionLookupHandler: divisionLookupHandler });

    let invoiceTemplateLookupHandler = new GenericAttributeLookupHandler(
      this.state.invoiceTemplate,
      "InvoiceTemplate"
    );
    this.setState({
      invoiceTemplateLookupHandler: invoiceTemplateLookupHandler,
    });
    let customerDeliveryTypeCodeLookupHandler =
      new GenericAttributeLookupHandler(
        this.state.customerDeliveries,
        "Delivery Type"
      );
    this.setState({
      customerDeliveryTypeCodeLookupHandler:
        customerDeliveryTypeCodeLookupHandler,
    });
    let arTypeCodeLookupHandler = new GenericAttributeLookupHandler(
      this.state.arTypes,
      "ArType"
    );
    this.setState({ arTypeCodeLookupHandler: arTypeCodeLookupHandler });
    let financialTypeCodeLookupHandler = new GenericAttributeLookupHandler(
      this.state.financialTypes,
      "Financial Type "
    );
    this.setState({
      financialTypeCodeLookupHandler: financialTypeCodeLookupHandler,
    });
  };
  onShipViaChange = (e) => {
    this.props.onShipViaChange(e);
  };
  shipViaEnterKeyEvent = (e) => {
    this.props.shipViaEnterKeyEvent(e);
  };
  displayAutoCompleteShipViaList = (e) => {
    this.props.displayAutoCompleteShipViaList(e);
  };
  onPaymentTypeChange = (e) => {
    this.props.onPaymentTypeChange(e);
  };
  paymentTypeEnterKeyEventHandler = (e) => {
    this.props.paymentTypeEnterKeyEventHandler(e);
  };
  displayAutoCompletePaymentTypeList = (e) => {
    this.props.displayAutoCompletePaymentTypeList(e);
  };
  onPaymentTermChange = (e) => {
    this.props.onPaymentTermChange(e);
  };
  paymentTermEnterKeyEventHandler = (e) => {
    this.props.paymentTermEnterKeyEventHandler(e);
  };
  displayAutoCompletePaymentTermList = (e) => {
    this.props.displayAutoCompletePaymentTermList(e);
  };
  onDivisionCodeChange = (e) => {
    this.props.onDivisionCodeChange(e);
  };
  divisionEnterKeyEvent = (e) => {
    this.props.divisionEnterKeyEvent(e);
  };
  displayAutoCompleteDivisionCodeList = (e) => {
    this.props.displayAutoCompleteDivisionCodeList(e);
  };
  onInvoiceTemplateCodeChange = (e) => {
    this.props.onInvoiceTemplateCodeChange(e);
  };
  invoiceTemplateCodeEnterKeyEvent = (e) => {
    this.props.invoiceTemplateCodeEnterKeyEvent(e);
  };
  displayAutoCompleteInvoiceTemplateCodeList = (e) => {
    this.props.displayAutoCompleteInvoiceTemplateCodeList(e);
  };
  onCityChange = (e) => {
    this.props.onCityChange(e);
  };
  cityEnterKeyEvent = (e) => {
    this.props.cityEnterKeyEvent(e);
  };
  displayAutoCompleteCityList = (e) => {
    this.props.displayAutoCompleteCityList(e);
  };
  onStateChange = (e) => {
    this.props.onStateChange(e);
  };
  stateEnterKeyEvent = (e) => {
    this.props.stateEnterKeyEvent(e);
  };
  displayAutoCompleteStateList = (e) => {
    this.props.displayAutoCompleteStateList(e);
  };

  onCountryCodeChange = (e) => {
    this.props.onCountryCodeChange(e);
  };
  countryCodeEnterKeyEvent = (e) => {
    this.props.countryCodeEnterKeyEvent(e);
  };
  displayAutoCompleteCountryCodeList = (e) => {
    this.props.displayAutoCompleteCountryCodeList(e);
  };
  onCountryChange = (e) => {
    this.props.onCountryChange(e);
  };
  countryEnterKeyEvent = (e) => {
    this.props.countryEnterKeyEvent(e);
  };
  displayAutoCompleteCountryList = (e) => {
    this.props.displayAutoCompleteCountryList(e);
  };

  onCurrencyCodeChange = (e) => {
    this.props.onCurrencyCodeChange(e);
  };
  currencyCodeEnterKeyEvent = (e) => {
    this.props.currencyCodeEnterKeyEvent(e);
  };
  displayAutoCompleteCurrencyList = (e) => {
    this.props.displayAutoCompleteCurrencyList(e);
  };
  onCustomerTypeCodeChange = (e) => {
    this.props.onCustomerTypeCodeChange(e);
  };
  customerTypeCodeEnterKeyEvent = (e) => {
    this.props.customerTypeCodeEnterKeyEvent(e);
  };
  displayAutoCompleteCustomerTypeCodeList = (e) => {
    this.props.displayAutoCompleteCustomerTypeCodeList(e);
  };
  displayAutoCompleteList = (e) => {
    this.props.displayAutoCompleteList(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  closeEntryForm() {
    this.props.closeEntryForm();
  }
  showCustomerList = () => {
    this.props.showCustomerList();
  };
  openCustomerOnOrderInq = (e, code) => {
    if (e.detail === 1) this.props.openCustomerOnOrderInq(code);
  };
  openCustomerTransactionsInq = (e, code) => {
    if (e.detail === 1) this.props.openCustomerTransactionsInq(code);
  };
  openCustomerStatisticsInq = (e, code) => {
    if (e.detail === 1) this.props.openCustomerStatisticsInq(code);
  };
  openCustomerSalesHistoryInq = (e, code) => {
    if (e.detail === 1) this.props.openCustomerSalesHistoryInq(code);
  };
  openCustomerMostRecentFabricsInq = (e, code) => {
    if (e.detail === 1) this.props.openCustomerMostRecentFabricsInq(code);
  };
  openCustomerCurrentAgingInq = (e, code) => {
    if (e.detail === 1) this.props.openCustomerCurrentAgingInq(code);
  };
  onArTypeCodeChange = (e) => {
    this.props.onArTypeCodeChange(e);
  };
  arTypeCodeEnterKeyEvent = (e) => {
    this.props.arTypeCodeEnterKeyEvent(e);
  };
  displayAutoCompleteArTypeCodeList = (list) => {
    this.props.displayAutoCompleteArTypeCodeList(list);
  };
  oncustomerDeliveryTypeCodeChange = (e) => {
    this.props.oncustomerDeliveryTypeCodeChange(e);
  };
  customerDeliveryTypeCodeEnterKeyEvent = (e) => {
    this.props.customerDeliveryTypeCodeEnterKeyEvent(e);
  };
  displayAutoCompletecustomerDeliveryTypeCodeList = (list) => {
    this.props.displayAutoCompletecustomerDeliveryTypeCodeList(list);
  };
  onfinancialTypeCodeChange = (e) => {
    this.props.onfinancialTypeCodeChange(e);
  };
  financialTypeCodeEnterKeyEvent = (e) => {
    this.props.financialTypeCodeEnterKeyEvent(e);
  };
  displayAutoCompletefinancialTypeCodeList = (list) => {
    this.props.displayAutoCompletefinancialTypeCodeList(list);
  };
  onLocationChange = (e) => {
    this.props.onLocationChange(e);
  };
  locationEnterKeyEventHandler = (e) => {
    this.props.locationEnterKeyEventHandler(e);
  };
  displayAutoCompleteLocationList = (showAutoCompleteLocationList) => {
    this.props.displayAutoCompleteLocationList(showAutoCompleteLocationList);
  };
  closeModalCallBack = (isOpen) => {
    this.props.closeModalCallBack(isOpen);
  };
  onZoneCodeChange = (e) => {
    this.props.onZoneCodeChange(e);
  };
  zoneCodeEnterKeyEvent = (e) => {
    this.props.zoneCodeEnterKeyEvent(e);
  };
  displayAutoCompletezoneCodeList = (list) => {
    this.props.displayAutoCompletezoneCodeList(list);
  };
  getEmptyView() {
    return <div></div>;
  }

  getNodeList = () => {
    let nodeList = [];
    let emptyObject = this.getEmptyView();
    let addressNode = new NodeData(
      "addressView",
      "Address Details",
      emptyObject
    );
    let shipNode = new NodeData("shipmentView", "Shipment Amount", emptyObject);
    let otherNode = new NodeData(
      "otherDetailsView",
      "Other Detail",
      emptyObject
    );
    let optionNode = new NodeData("optionsView", "Options", emptyObject);
    let commentNode = new NodeData("commentView", "Comments", emptyObject);
    nodeList["addressView"] = addressNode;
    nodeList["shipmentView"] = shipNode;
    if (!this.props.is3PL) {
      nodeList["otherDetailsView"] = otherNode;
      nodeList["optionsView"] = optionNode;
    }
    nodeList["commentView"] = commentNode;
    this.setState({ nodeList: nodeList });
  };

  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "addressView") {
      this.setAddressView();
    } else if (selectedNode == "shipmentView") {
      this.setShipmentView();
    } else if (selectedNode == "otherDetailsView") {
      this.setOtherDetailView();
    } else if (selectedNode == "optionsView") {
      this.setOptionsView();
    } else if (selectedNode == "commentView") {
      this.setCommentsView();
    }
  };

  setAddressView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowAdress: true,
      isShowShipmentAmount: false,
      isShowOtherDetailAmount: false,
      isShowOptionAmount: false,
      isShowComments: false,
    });
  };
  setShipmentView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowAdress: false,
      isShowShipmentAmount: true,
      isShowOtherDetailAmount: false,
      isShowOptionAmount: false,
      isShowComments: false,
    });
  };
  setOtherDetailView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowAdress: false,
      isShowShipmentAmount: false,
      isShowOtherDetailAmount: true,
      isShowOptionAmount: false,
      isShowComments: false,
    });
  };
  setOptionsView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowAdress: false,
      isShowShipmentAmount: false,
      isShowOtherDetailAmount: false,
      isShowOptionAmount: true,
      isShowComments: false,
    });
  };
  setCommentsView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowAdress: false,
      isShowShipmentAmount: false,
      isShowOtherDetailAmount: false,
      isShowOptionAmount: false,
      isShowComments: true,
    });
  };
  closeAllNodeViews = () => {
    this.setState({
      isShowAdress: false,
      isShowShipmentAmount: false,
      isShowOtherDetailAmount: false,
      isShowOptionAmount: false,
      isShowComments: false,
    });
  };

  render() {
    let customerData = new CustomerBean();
    customerData = this.props.customerData;
    if (customerData != null) {
      customerData = this.props.customerData;
    }
    let addressData = this.props.addressData;
    let warehouses = this.props.warehouses;
    let customerTypes = this.props.customerTypes;
    let currencies = this.props.currencies;
    let paymentMethods = this.props.paymentMethods;
    let paymentTerms = this.props.paymentTerms;
    let isDisabledFields = this.props.isDisabledFields;
    const is3PL = this.props.is3PL;
    return (
      <div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerOnOrderInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerTransactionsInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerStatisticsInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerSalesHistoryInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerMostRecentFabricsInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isCustomerCurrentAgingInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <div className="header_div col-md-12 col-lg-12">
          <Row>
            <Col className="so-align-items-left" sm="1">
              <FormLabel>Customer</FormLabel>
              <Col>
                {customerData.isFetched != false &&
                  customerData.code != "" &&
                  customerData.code != NEW_ENTRY &&
                  customerData.code != undefined ? (
                  <ShortCutMenuPopup
                    value={customerData.code}
                    menuItems={
                      <ul>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) =>
                            this.openCustomerOnOrderInq(e, customerData.code)
                          }
                        >
                          {" "}
                          Customer On-Order{" "}
                        </li>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) =>
                            this.openCustomerTransactionsInq(
                              e,
                              customerData.code
                            )
                          }
                        >
                          {" "}
                          Customer Transactions{" "}
                        </li>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) =>
                            this.openCustomerStatisticsInq(e, customerData.code)
                          }
                        >
                          {" "}
                          Customer Statistics{" "}
                        </li>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) =>
                            this.openCustomerSalesHistoryInq(
                              e,
                              customerData.code
                            )
                          }
                        >
                          {" "}
                          Customer Sales History{" "}
                        </li>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) =>
                            this.openCustomerMostRecentFabricsInq(
                              e,
                              customerData.code
                            )
                          }
                        >
                          {is3PL
                            ? "Customer Most Recent Items"
                            : "Customer Most Recent Fabrics"}
                        </li>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) =>
                            this.openCustomerCurrentAgingInq(
                              e,
                              customerData.code
                            )
                          }
                        >
                          {" "}
                          Customer Current Aging{" "}
                        </li>
                      </ul>
                    }
                  />
                ) : null}
              </Col>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onChange}
                name="code"
                value={customerData.code}
                disabled={true}
              ></InputTextbox>
            </Col>
            {/* <Col sm="1">
              <FormLabel>Name</FormLabel>
            </Col> */}
            <Col sm="3">
              <InputTextbox
                ref={this.custNameRef}
                name="description"
                type="text"
                placeholder="Enter CustomerShortName"
                onChange={this.onChange}
                value={customerData.description}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>DBA Name</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="dbaName"
                type="text"
                placeholder="Enter DbaName"
                onChange={this.onChange}
                value={customerData.dbaName}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Legal Name</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="legalName"
                type="text"
                placeholder="Enter legalName"
                onChange={this.onChange}
                value={customerData.legalName}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Customer Type</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onCustomerTypeCodeChange}
                ref={this.customerTypeRef}
                name="customerTypeCode"
                placeholder="customerTypeCode"
                value={customerData.customerTypeCode}
                lookupRequired={true}
                lookupHandler={this.state.customerTypeLookupHandler}
                enterKeyEventHandler={this.customerTypeCodeEnterKeyEvent}
                autoCompleteListData={
                  this.props.customerTypeCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteCustomerTypeCodeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteCustomerTypeCodeList
                }
                disabled={isDisabledFields}
                isMandatory={true}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>Currency</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onCurrencyCodeChange}
                ref={this.currencyRef}
                name="currencyCode"
                placeholder="currencyCode"
                value={customerData.currencyCode}
                lookupRequired={true}
                lookupHandler={this.state.currencyLookupHandler}
                enterKeyEventHandler={this.currencyCodeEnterKeyEvent}
                autoCompleteListData={
                  this.props.currencyCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCurrencyList}
                showAutoCompleteList={
                  this.props.showAutoCompleteCurrencyCodeList
                }
                disabled={isDisabledFields}
                isMandatory={true}
              ></InputTextbox>
            </Col>
            {is3PL && !customerData.isMasterCustomer ? (
              <>
                {" "}
                <Col sm="1">
                  <FormLabel>Master cust</FormLabel>
                </Col>
                <Col sm="2">
                  {/* <InputTextbox
                    name="masterCustomerCode"
                    placeholder="masterCustomerCode"
                    value={customerData.masterCustomerCode}
                    lookupRequired={true}
                    lookupHandler={this.state.masterCusLookupHandler}
                    disabled={isDisabledFields}
                    isMandatory={true}
                  ></InputTextbox> */}

                  <InputTextbox
                    onChange={this.props.onCustomerCodeChange}
                    // ref={this.customerCodeRef}
                    name="masterCustomerCode"
                    placeholder="MasterCustomerCode"
                    value={customerData.masterCustomerCode}
                    lookupRequired={true}
                    lookupHandler={this.state.masterCusLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={
                      this.props.customerEnterKeyEventHandler
                    }
                    autoCompleteListData={
                      this.props.customerPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.props.displayAutoCompleteCustomerList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteCustomerList
                    }
                    disabled={isDisabledFields}
                    isMandatory={true}
                    isNotFound={this.props.isCustomerNotFound}
                  // onKeyDown={this.props.customerOnKeydown}
                  />
                </Col>{" "}
                <Col sm="3">
                  <InputTextbox
                    value={customerData.masterCustomerName}
                    disabled={true}
                  ></InputTextbox>
                </Col>
              </>
            ) : null}
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Allocation Priority</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.onChange}
                name={"allocationPriority"}
                value={customerData.allocationPriority}
                disabled={isDisabledFields}
                isMandatory={true}
              ></InputTextbox>
              {""}
            </Col>
            {!is3PL && (
              <Col sm="1">
                <FormLabel>PaymentMethod</FormLabel>
              </Col>
            )}
            {!is3PL && (
              <Col sm="2">
                <InputTextbox
                  onChange={this.onPaymentTypeChange}
                  ref={this.paymentMethodRef}
                  name="paymentMethodCode"
                  placeholder="paymentMethodCode"
                  value={customerData.paymentMethodCode}
                  lookupRequired={true}
                  lookupHandler={this.state.paymentMethodLookupHandler}
                  enterKeyEventHandler={this.paymentTypeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.paymentTypePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompletePaymentTypeList
                  }
                  showAutoCompleteList={
                    this.props.showAutoCompletePaymentTypeList
                  }
                  disabled={isDisabledFields}
                ></InputTextbox>
              </Col>
            )}
            {/* {!is3PL && ( */}
            <Col sm="1">
              <FormLabel>PaymentTerms</FormLabel>
            </Col>
            {/* )}
            {!is3PL && ( */}
            <Col sm="2">
              <InputTextbox
                onChange={this.onPaymentTermChange}
                ref={this.paymentTermRef}
                name="paymentTermsCode"
                placeholder="paymentTermsCode"
                value={customerData.paymentTermsCode}
                lookupRequired={true}
                lookupHandler={this.state.paymentTermLookupHandler}
                enterKeyEventHandler={this.paymentTermEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.paymentTermPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompletePaymentTermList
                }
                showAutoCompleteList={
                  this.props.showAutoCompletePaymentTermList
                }
                disabled={isDisabledFields}
                isMandatory={true}
              ></InputTextbox>
            </Col>
            {/* )} */}
            <Col sm="1">
              <FormLabel>Invoice Template</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onInvoiceTemplateCodeChange}
                ref={this.invoiceTemplateRef}
                name="invoiceTemplateCode"
                placeholder="invoiceTemplateCode"
                value={customerData.invoiceTemplateCode}
                lookupRequired={true}
                lookupHandler={this.state.invoiceTemplateLookupHandler}
                enterKeyEventHandler={this.invoiceTemplateCodeEnterKeyEvent}
                autoCompleteListData={
                  this.props.invoiceTemplateCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteInvoiceTemplateCodeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteInvoiceTemplateCodeList
                }
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
            {is3PL && (
              <>
                <Col sm="1">
                  <FormLabel>Customer Company</FormLabel>
                </Col>
                <Col sm="2">
                  {" "}
                  <InputTextbox
                    onChange={this.onChange}
                    name={"customerCompanyName"}
                    value={customerData.customerCompanyName}
                    disabled={isDisabledFields}
                  ></InputTextbox>
                  {""}
                </Col>
              </>
            )}
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Ship Via</FormLabel>
            </Col>
            {is3PL ? (
              <Col sm="2">
                {" "}
                <InputTextbox
                  onChange={this.onShipViaChange}
                  ref={this.shipViaRef}
                  name="shipViaCode"
                  placeholder="shipViaCode"
                  value={customerData.shipViaCode}
                  lookupRequired={true}
                  lookupHandler={this.state.shipViaLookupHandler}
                  enterKeyEventHandler={this.shipViaEnterKeyEvent}
                  autoCompleteListData={
                    this.props.shipViaPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteShipViaList}
                  showAutoCompleteList={this.props.showAutoCompleteShipViaList}
                  disabled={isDisabledFields}
                ></InputTextbox>
                {""}
              </Col>
            ) : (
              <Col sm="2">
                {" "}
                <InputTextbox
                  onChange={this.onShipViaChange}
                  ref={this.shipViaRef}
                  name="shipViaCode"
                  placeholder="shipViaCode"
                  value={customerData.shipViaCode}
                  lookupRequired={true}
                  lookupHandler={this.state.shipViaLookupHandler}
                  enterKeyEventHandler={this.shipViaEnterKeyEvent}
                  autoCompleteListData={
                    this.props.shipViaPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteShipViaList}
                  showAutoCompleteList={this.props.showAutoCompleteShipViaList}
                  disabled={isDisabledFields}
                  isMandatory={true}
                ></InputTextbox>
                {""}
              </Col>
            )}

            <Col sm="1">
              <FormLabel>CreditLimit</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                onChange={this.onChange}
                name="creditLimit"
                placeholder="creditLimit"
                value={customerData.creditLimit}
                disabled={isDisabledFields}
                isMandatory={true}
              ></NumberFormatInputbox>
            </Col>
            <Col sm="1">
              <FormLabel>Account Representative</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onChange}
                name="accountRepresentative"
                placeholder="accountRepresentative"
                value={customerData.accountRepresentative}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
          </Row>
          {!is3PL && (
            <Row>
              <Col sm="1">
                <FormLabel>StopShipDays</FormLabel>
              </Col>
              <Col sm="2">
                {" "}
                <NumberFormatInputbox
                  onChange={this.onChange}
                  name={"stopShipDays"}
                  value={customerData.stopShipDays}
                  disabled={isDisabledFields}
                ></NumberFormatInputbox>
                {""}
              </Col>
              <Col sm="1">
                <FormLabel>Damage Allowance</FormLabel>
              </Col>
              <Col sm="2">
                <NumberFormatInputbox
                  onChange={this.onChange}
                  name="damageAllowancePercentage"
                  placeholder="damageAllowancePercentage"
                  value={customerData.damageAllowancePercentage}
                  disabled={isDisabledFields}
                ></NumberFormatInputbox>
              </Col>

              <Col sm="1">
                <FormLabel>ResaleNumber</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onChange}
                  name="resaleNumber"
                  placeholder="resaleNumber"
                  value={customerData.resaleNumber}
                  disabled={isDisabledFields}
                ></InputTextbox>
              </Col>
              <Col sm="1">
                <FormLabel>AccountNumber</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onChange}
                  name="accountNumber"
                  placeholder="accountNumber"
                  value={customerData.accountNumber}
                  disabled={isDisabledFields}
                ></InputTextbox>
              </Col>
            </Row>
          )}
          {!is3PL && (
            <Row>
              <Col sm="1">
                <FormLabel>Division</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onDivisionCodeChange}
                  ref={this.divisionRef}
                  name="divisionCode"
                  placeholder="divisionCode"
                  value={customerData.divisionCode}
                  lookupRequired={true}
                  lookupHandler={this.state.divisionLookupHandler}
                  enterKeyEventHandler={this.divisionEnterKeyEvent}
                  autoCompleteListData={
                    this.props.divisionPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompleteDivisionCodeList
                  }
                  showAutoCompleteList={
                    this.props.showAutoCompleteDivisionCodeList
                  }
                  disabled={isDisabledFields}
                  isMandatory={true}
                ></InputTextbox>
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>Ar Type</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onArTypeCodeChange}
                  ref={this.arTypeRef}
                  name="arTypeCode"
                  placeholder="arTypeCode"
                  value={customerData.arTypeCode}
                  lookupRequired={true}
                  lookupHandler={this.state.arTypeCodeLookupHandler}
                  enterKeyEventHandler={this.arTypeCodeEnterKeyEvent}
                  autoCompleteListData={
                    this.props.arTypeCodePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompleteArTypeCodeList
                  }
                  showAutoCompleteList={
                    this.props.showAutoCompleteArTypeCodeList
                  }
                  disabled={isDisabledFields}
                ></InputTextbox>
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>Delivery Type</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.oncustomerDeliveryTypeCodeChange}
                  ref={this.customerDeliveryTypeCodeRef}
                  name="customerDeliveryTypeCode"
                  placeholder="customerDeliveryTypeCode"
                  value={customerData.customerDeliveryTypeCode}
                  lookupRequired={true}
                  lookupHandler={
                    this.state.customerDeliveryTypeCodeLookupHandler
                  }
                  enterKeyEventHandler={
                    this.customerDeliveryTypeCodeEnterKeyEvent
                  }
                  autoCompleteListData={
                    this.props
                      .customerDeliveryTypeCodePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompletecustomerDeliveryTypeCodeList
                  }
                  showAutoCompleteList={
                    this.props.showAutoCompletecustomerDeliveryTypeCodeList
                  }
                  disabled={isDisabledFields}
                ></InputTextbox>
              </Col>

              <Col sm="1">
                {" "}
                <FormLabel>Financial Type</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onfinancialTypeCodeChange}
                  ref={this.financialTypeCodeRef}
                  name="financialTypeCode"
                  placeholder="financialTypeCode"
                  value={customerData.financialTypeCode}
                  lookupRequired={true}
                  lookupHandler={this.state.financialTypeCodeLookupHandler}
                  enterKeyEventHandler={this.financialTypeCodeEnterKeyEvent}
                  autoCompleteListData={
                    this.props.financialTypeCodePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompletefinancialTypeCodeList
                  }
                  showAutoCompleteList={
                    this.props.showAutoCompletefinancialTypeCodeList
                  }
                  disabled={isDisabledFields}
                ></InputTextbox>
              </Col>
            </Row>
          )}
          {!is3PL && (
            <Row>
              <Col sm="1">
                <FormLabel>MarkDown</FormLabel>
              </Col>
              <Col sm="2">
                <NumberFormatInputbox
                  onChange={this.onChange}
                  name="markUpDownPercentage"
                  value={customerData.markUpDownPercentage}
                  decimalScale={2}
                  disabled={isDisabledFields}
                ></NumberFormatInputbox>
              </Col>
              <Col sm="1">
                <FormLabel>LegalEntity</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onChange}
                  name="legalEntity"
                  placeholder="legalEntity"
                  value={customerData.legalEntity}
                  disabled={isDisabledFields}
                ></InputTextbox>
              </Col>
              {!is3PL ? (
                <>
                  <Col sm="1">
                    <FormLabel>PrivateLabel Prefix</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      onChange={this.onChange}
                      name="privateLabelPrefix"
                      placeholder="privateLabelPrefix"
                      value={customerData.privateLabelPrefix}
                      disabled={isDisabledFields}
                    ></InputTextbox>
                  </Col>
                  <Col sm="1">
                    <FormLabel>PrivateLabel Caption</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      onChange={this.onChange}
                      name="privateLabelCaption"
                      placeholder="privateLabelCaption"
                      value={customerData.privateLabelCaption}
                      disabled={isDisabledFields}
                    ></InputTextbox>
                  </Col>
                </>
              ) : null}
            </Row>
          )}
          <Row>
            <Col sm="1">
              <FormLabel>ForcePay</FormLabel>
            </Col>
            <Col sm="1">
              <InputCheckbox
                name="isForcePayRequired"
                type="checkbox"
                checked={customerData.isForcePayRequired}
                onChange={this.onChange}
                disabled={isDisabledFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel>IsActive</FormLabel>
            </Col>
            <Col sm="1">
              <InputCheckbox
                name="isActive"
                type="checkbox"
                checked={customerData.isActive}
                onChange={this.onChange}
                disabled={isDisabledFields}
              />
            </Col>
            {is3PL ? (
              <>
                {" "}
                <Col sm="1">
                  <FormLabel>is Master Customer</FormLabel>
                </Col>
                <Col sm="1">
                  <InputCheckbox
                    name="isMasterCustomer"
                    type="checkbox"
                    checked={customerData.isMasterCustomer}
                    onChange={this.onChange}
                    disabled={isDisabledFields}
                  />
                </Col>
              </>
            ) : null}

            {/* <Col sm="1">
              <FormLabel>is Special Customer</FormLabel>
            </Col>
            <Col sm="1">
              <InputCheckbox
                name="isSpecialCustomer"
                type="checkbox"
                checked={customerData.isSpecialCustomer}
                onChange={this.onChange}
                disabled={isDisabledFields}
              />
            </Col> */}
          </Row>
        </div>
        <BaseNodeBar
          nodeList={this.state.nodeList}
          selectedNodeKey={this.state.selectedNodeKey}
          nodeOnSelect={this.nodeOnSelect}
        />
        {this.state.isShowAdress && (
          <AddressDetailsEntryForm
            {...this.state}
            customerData={this.props.customerData}
            countries={this.props.countries}
            states={this.props.states}
            cities={this.props.cities}
            addressData={this.props.addressData}
            isDisabledFields={this.props.isDisabledFields}
            showAutoCompleteCityList={this.props.showAutoCompleteCityList}
            cityPageListForAutoCompleteList={
              this.props.cityPageListForAutoCompleteList
            }
            statePageListForAutoCompleteList={
              this.props.statePageListForAutoCompleteList
            }
            showAutoCompleteStateList={this.props.showAutoCompleteStateList}
            countryCodePageListForAutoCompleteList={
              this.props.countryCodePageListForAutoCompleteList
            }
            showAutoCompleteCountryCodeList={
              this.props.showAutoCompleteCountryCodeList
            }
            onChange={this.onChange}
            onCityChange={this.onCityChange}
            cityEnterKeyEvent={this.cityEnterKeyEvent}
            displayAutoCompleteCityList={this.displayAutoCompleteCityList}
            onStateChange={this.onStateChange}
            stateEnterKeyEvent={this.stateEnterKeyEvent}
            displayAutoCompleteStateList={this.displayAutoCompleteStateList}
            onCountryCodeChange={this.onCountryCodeChange}
            countryCodeEnterKeyEvent={this.countryCodeEnterKeyEvent}
            displayAutoCompleteCountryCodeList={
              this.displayAutoCompleteCountryCodeList
            }
          />
        )}
        {this.state.isShowShipmentAmount && (
          <div className="header_div">
            <Row>
              <Col sm="1">
                {" "}
                <FormLabel>FEDEXUserId#</FormLabel>
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  name="fedexShippingAccountUserId"
                  type="text"
                  onChange={this.onChange}
                  value={customerData.fedexShippingAccountUserId}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>FEDEXPasswrd#</FormLabel>
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  name="fedexShippingAccountPassword"
                  type="password"
                  onChange={this.onChange}
                  value={customerData.fedexShippingAccountPassword}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>USPSUserId#</FormLabel>
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  name="uspsShippingAccountUserId"
                  type="text"
                  onChange={this.onChange}
                  value={customerData.uspsShippingAccountUserId}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>USPSPasswrd#</FormLabel>
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  name="uspsShippingAccountPassword"
                  type="password"
                  onChange={this.onChange}
                  value={customerData.uspsShippingAccountPassword}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                {" "}
                <FormLabel>UPSUserId#</FormLabel>
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  name="upsShippingAccountUserId"
                  type="text"
                  onChange={this.onChange}
                  value={customerData.upsShippingAccountUserId}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>UPSPasswrd#</FormLabel>
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  name="upsShippingAccountPassword"
                  type="password"
                  onChange={this.onChange}
                  value={customerData.upsShippingAccountPassword}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>Country</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onCountryChange}
                  ref={this.countryRef}
                  name="shippingAccountCountryCode"
                  placeholder="country"
                  value={customerData.shippingAccountCountryCode}
                  lookupRequired={true}
                  lookupHandler={this.state.countryLookupHandler}
                  enterKeyEventHandler={this.countryEnterKeyEvent}
                  autoCompleteListData={
                    this.props.countryPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteCountryList}
                  showAutoCompleteList={this.props.showAutoCompleteCountryList}
                  disabled={isDisabledFields}
                ></InputTextbox>
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>Zip</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onChange}
                  name="shippingAccountPostalCode"
                  value={customerData.shippingAccountPostalCode}
                  disabled={isDisabledFields}
                ></InputTextbox>
              </Col>
            </Row>
          </div>
        )}
        {this.state.isShowOtherDetailAmount && (
          <div className="header_div">
            <Row>
              <Col sm="1">
                {" "}
                <FormLabel>Factor#</FormLabel>
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  name="factorCode"
                  type="text"
                  onChange={this.onChange}
                  value={customerData.factorCode}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>National Id</FormLabel>
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  name="nationalId"
                  type="text"
                  onChange={this.onChange}
                  value={customerData.nationalId}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>BuyingOffice</FormLabel>
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  name="buyingOffice"
                  type="text"
                  onChange={this.onChange}
                  value={customerData.buyingOffice}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>PriceLevel</FormLabel>
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  name="priceLevel"
                  type="text"
                  onChange={this.onChange}
                  value={customerData.priceLevel}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                {" "}
                <FormLabel>FederalId</FormLabel>
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  name="federalId"
                  type="text"
                  onChange={this.onChange}
                  value={customerData.federalId}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>EDI Id</FormLabel>
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  name="ediId"
                  type="text"
                  onChange={this.onChange}
                  value={customerData.ediId}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>WareHouse</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onLocationChange}
                  ref={this.warehouseRef}
                  name="locationCode"
                  placeholder="locationCode"
                  value={customerData.locationCode}
                  lookupRequired={true}
                  lookupHandler={this.state.warehouseLookupHandler}
                  enterKeyEventHandler={this.locationEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.locationPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteLocationList}
                  showAutoCompleteList={this.props.showAutoCompleteLocationList}
                  disabled={isDisabledFields}
                ></InputTextbox>
              </Col>
            </Row>
          </div>
        )}
        {this.state.isShowOptionAmount && (
          <OptionsAmountEntryForm
            customerData={this.props.customerData}
            onChange={this.onChange}
          />
        )}
        {this.state.isShowComments && (
          <CommentsEntryForm
            {...this.state}
            customerData={this.props.customerData}
            onChange={this.onChange}
            isDisabledFields={this.props.isDisabledFields}
          />
        )}
      </div>
    );
  }
}

class CustomerSalesPersonListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      customerSalesPersonList: this.props.customerSalesPersonList,
      pageList: new PageListBean(),
    };
  }

  componentDidMount() {
    //
  }

  componentDidUpdate() {
    //
  }

  editSalesPerson = (code) => {
    this.props.editSalesPerson(code);
  };
  deleteSalesPersonButtonClick = (val, rowData) => {
    this.props.deleteSalesPersonButtonClick(rowData);
  };
  handleChange = (e) => { };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "SalesPerson",
        "salesPersonCode",
        0,
        true,
        this.editSalesPerson
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "SalesPerson Name",
        "salesPersonName"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Commission%",
        "commissionPercentage"
      )
    );
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "Remove",
          <DeleteIcon />,
          // true,
          0,
          false,
          null,
          false,
          null, //image link call back
          "1em", //min-width
          "3%" //max-width
        )
        .setEditableDetails(
          false,
          "",
          null,
          true,
          this.deleteSalesPersonButtonClick,
          false,
          null
        )
        .setDisabled(this.props.isDisabledFields)
    );
    return columnList;
  };

  render() {
    let salesPersonList = this.props.customerSalesPersonList;
    return (
      <div>
        <EditableDataGrid
          columnsList={this.columnDefinitions()}
          dataList={salesPersonList}
        // isLoading={isLoading}
        />
      </div>
    );
  }
}
class CustomerSalesPersonEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      customerSalesPersonData: this.props.customerSalesPersonData,
    };

    this.salesPersonRef = React.createRef();
  }

  componentDidMount() {
    //
    this.initLookupHandlers();
    this.setFocus();
  }
  setFocus = () => {
    this.salesPersonRef.current.focus();
  };
  initLookupHandlers = () => {
    let salesPersonLookupHandler = new GenericAttributeLookupHandler(
      this.props.salesPersons,
      "SalesPerson"
    );
    this.setState({ salesPersonLookupHandler: salesPersonLookupHandler });
  };
  componentDidUpdate() {
    //
  }
  onSalesPersonCodeChange = (e) => {
    this.props.onSalesPersonCodeChange(e);
  };
  salesPersonEnterKeyEvent = (e) => {
    this.props.salesPersonEnterKeyEvent(e);
  };
  displayAutoCompleteSalesPersonList = (showAutoCompleteSalesPersonList) => {
    this.props.displayAutoCompleteSalesPersonList(
      showAutoCompleteSalesPersonList
    );
  };
  onChange = (e) => {
    let temp_salesPersondata = this.props.customerSalesPersonData;
    temp_salesPersondata[e.target.name] = e.target.value;
    if (e.target.name === "code") {
      this.props.salesPersons.map((list) => {
        if (list.code === e.target.value) {
          temp_salesPersondata["salesPersonName"] = list.description;
          temp_salesPersondata["salesPersonCode"] = list.code;
        }
      });
    }

    this.setState({
      customerSalesPersonData: temp_salesPersondata,
    });
  };
  closeCustomerSalesPersonEntryForm = (e) => {
    if (e.detail === 1) this.props.closeCustomerSalesPersonEntryForm();
  };
  render() {
    let customerSalesPersonData = this.props.customerSalesPersonData;
    let isDisabledFields = this.props.isDisabledFields;
    return (
      <div>
        <div className="header_div col-md-12 col-lg-12">
          <Row>
            <Col sm="1">
              <FormLabel>SalesPerson</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.salesPersonRef}
                name="salesPersonCode"
                type="text"
                onChange={this.onSalesPersonCodeChange}
                value={customerSalesPersonData.salesPersonCode}
                lookupRequired={true}
                lookupHandler={this.state.salesPersonLookupHandler}
                enterKeyEventHandler={this.salesPersonEnterKeyEvent}
                autoCompleteListData={
                  this.props.salesPersonPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteSalesPersonList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteSalesPersonList
                }
                // disabled={this.props.isDisableNodeFields}
                isMandatory={true}
                disabled={isDisabledFields}
              />{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="salesPersonName"
                type="text"
                onChange={this.onChange}
                value={customerSalesPersonData.salesPersonName}
                isMandatory={true}
                 disabled={true}
               // disabled={isDisabledFields}
              //disabled={this.props.isDisableNodeFields}
              />{" "}
            </Col>

            <Col sm="1">
              <FormLabel>Commission</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {/* <InputTextbox
                name="commissionPercentage"
                type="text"
                placeholder="Enter BillToCode"
                onChange={this.onChange}
                value={customerSalesPersonData.commissionPercentage}
                disabled={isDisabledFields}
              />{" "} */}
              <NumberFormatInputbox
                name={"commissionPercentage"}
                onChange={this.onChange}
                placeholder="Enter BillToCode"
                value={customerSalesPersonData.commissionPercentage}
                className="text-right"
                decimalScale={2}
                disabled={isDisabledFields}
              />
            </Col>

            <Col sm="1">
              <FormLabel>IsActive</FormLabel>{" "}
            </Col>
            <Col sm="1">
              <InputCheckbox
                type="checkbox"
                onChange={this.onChange}
                name="isActive"
                checked={customerSalesPersonData.isActive}
                disabled={isDisabledFields}
              />
            </Col>

            <Col sm="1">
              <FormLabel>IsPrimary</FormLabel>{" "}
            </Col>
            <Col sm="1">
              <InputCheckbox
                type="checkbox"
                onChange={this.onChange}
                name="primary"
                checked={customerSalesPersonData.primary}
                disabled={isDisabledFields}
              />
            </Col>
          </Row>

          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Comments</FormLabel>{" "}
            </Col>
            <Col sm="9">
              {" "}
              <textarea
                rows={10}
                cols={100}
                name="comments"
                type="text"
                placeholder="Enter Comments"
                onChange={this.onChange}
                value={customerSalesPersonData.comments}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row className="d-flex justify-content-center">
            <Col sm="4">
              <Button
                className="addToButton"
                onClick={(e) => this.closeCustomerSalesPersonEntryForm(e)}
              >
                {" "}
                Back{" "}
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

class CustomerCreditCardListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      customerCreditCardList: this.props.customerCreditCardList,
      pageList: new PageListBean(),
    };
  }

  componentDidMount() {
    //
  }

  componentDidUpdate() {
    //
  }

  editCreditCard = (code) => {
    this.props.editCreditCard(code);
  };
  deleteCreditCardButtonClick = (val, rowData) => {
    this.props.deleteCreditCardButtonClick(rowData);
  };
  handleChange = (e) => { };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "CardId",
        "cardID",
        0,
        true,
        this.editCreditCard
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("CardNumber", "cardNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "FirstName",
        "cardHolderFirstName"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "LastName",
        "cardHolderLastName"
      )
    );

    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "Remove",
          <DeleteIcon />,
          // true,
          0,
          false,
          null,
          false,
          null, //image link call back
          "1em", //min-width
          "3%" //max-width
        )
        .setEditableDetails(
          false,
          "",
          null,
          true,
          this.deleteCreditCardButtonClick,
          false,
          null
        )
        .setDisabled(this.props.isDisabledFields)
    );
    return columnList;
  };

  render() {
    let creditCardList = this.props.customerCreditCardList;
    return (
      <div>
        <EditableDataGrid
          columnsList={this.columnDefinitions()}
          dataList={creditCardList}
        // isLoading={isLoading}
        />
      </div>
    );
  }
}

class CustomerCreditCardEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      customerCreditCardData: this.props.customerCreditCardData,
      creditCardAddressData: this.props.creditCardAddressData,
      countries: this.props.countries,
      states: this.props.states,
      cities: this.props.cities,
      isDisableCustomerCreditCard: this.props.isDisableCustomerCreditCard,
      isDisableFields: this.props.isDisableFields,
    };

    this.stateRef = React.createRef();
    this.cityRef = React.createRef();
    this.countryRef = React.createRef();
    this.creditCardRef = React.createRef();
  }

  componentDidMount() {
    //
    this.initLookupHandlers();
    this.setFocus();
  }
  setFocus = () => {
    this.creditCardRef.current.focus();
  };
  initLookupHandlers = () => {
    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.state.cities,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });

    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.state.states,
      "State"
    );
    this.setState({ stateLookupHandler: stateLookupHandler });

    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.props.countries,
      "Country"
    );
    this.setState({ countryLookupHandler: countryLookupHandler });
  };
  componentDidUpdate() {
    //
  }
  onCityCreditCardChange = (e) => {
    this.props.onCityCreditCardChange(e);
  };
  cityCreditCardEnterKeyEvent = (e) => {
    this.props.cityCreditCardEnterKeyEvent(e);
  };
  displayAutoCompleteCityList = (showAutoCompleteCityList) => {
    this.props.displayAutoCompleteCityList(showAutoCompleteCityList);
  };
  onStateCreditCardChange = (e) => {
    this.props.onStateCreditCardChange(e);
  };
  stateCreditCardEnterKeyEvent = (e) => {
    this.props.stateCreditCardEnterKeyEvent(e);
  };
  displayAutoCompleteStateList = (showAutoCompleteStateList) => {
    this.props.displayAutoCompleteStateList(showAutoCompleteStateList);
  };
  onCountryCodeCreditCardChange = (e) => {
    this.props.onCountryCodeCreditCardChange(e);
  };
  countryCodeCreditCardEnterKeyEvent = (e) => {
    this.props.countryCodeCreditCardEnterKeyEvent(e);
  };
  displayAutoCompleteCountryCodeList = (showAutoCompleteCountryCodeList) => {
    this.props.displayAutoCompleteCountryCodeList(
      showAutoCompleteCountryCodeList
    );
  };
  onChange = (e) => {
    let temp_creditdata = this.props.customerCreditCardData;
    temp_creditdata[e.target.name] = e.target.value;

    let temp_addressData = this.props.creditCardAddressData;
    if (
      e.target.name == "address1" ||
      e.target.name == "address2" ||
      e.target.name == "city" ||
      e.target.name == "state" ||
      e.target.name == "country" ||
      e.target.name == "zip" ||
      e.target.name == "mobilePhone" ||
      e.target.name == "phone1" ||
      e.target.name == "phone2" ||
      e.target.name == "contactPerson" ||
      e.target.name == "fax" ||
      e.target.name == "email" ||
      e.target.name == "website"
    ) {
      //temp_addressData['address1'] = e.target.value;
      temp_addressData[e.target.name] = e.target.value;
    }
    this.setState({
      customerCreditCardData: temp_creditdata,
      creditCardAddressData: temp_addressData,
    });
  };

  onAddressChange = (e) => {
    let temp_addressData = this.props.creditCardAddressData;

    temp_addressData[e.target.name] = e.target.value;

    this.setState({ creditCardAddressData: temp_addressData });
  };

  /* saveCustomerShipTo = (e) => {
      this.props.saveCustomerShipTo(
        this.props.customerShipToData,
        this.props.addressData
      );
    };*/

  closeCustomerCreditCardEntryForm = (e) => {
    if (e.detail === 1) this.props.closeCustomerCreditCardEntryForm();
  };

  render() {
    let customerCreditCardData = this.props.customerCreditCardData;
    let addressData = this.props.creditCardAddressData;

    if (addressData == null) addressData = new AddressBean();
    let isDisabledFields = this.props.isDisabledFields;
    return (
      <div>
        <div className="header_div col-md-12 col-lg-12">
          <Row>
            <Col sm="1">
              <FormLabel>CardId</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.creditCardRef}
                name="cardID"
                type="text"
                placeholder="Enter CardId"
                onChange={this.onChange}
                value={customerCreditCardData.cardID}
                // disabled={this.props.isDisableNodeFields}
                isMandatory={true}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>CardNumber</FormLabel>{" "}
            </Col>

            <Col sm="2">
              <InputTextbox
                name="cardNumber"
                type="text"
                placeholder="Enter cardNumber"
                onChange={this.onChange}
                value={customerCreditCardData.cardNumber}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>

            <Col sm="1">
              <FormLabel>CardType</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="cardType"
                type="text"
                placeholder="Enter cardType"
                onChange={this.onChange}
                value={customerCreditCardData.cardType}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>FirstName</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onChange}
                name="cardHolderFirstName"
                placeholder="cardHolderFirstName"
                value={customerCreditCardData.cardHolderFirstName}
                disabled={isDisabledFields}
                isMandatory={true}
              ></InputTextbox>
            </Col>
          </Row>

          <Row>
            <Col sm="1">
              <FormLabel>LastName</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="cardHolderLastName"
                type="text"
                placeholder="Enter cardHolderLastName"
                onChange={this.onChange}
                value={customerCreditCardData.cardHolderLastName}
                disabled={isDisabledFields}
                isMandatory={true}
              />
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>CVV</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onChange}
                name="cvvNumber"
                placeholder="cvvNumber"
                value={customerCreditCardData.cvvNumber}
                disabled={isDisabledFields}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>ExpiryMonth</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="expiryMonth"
                type="text"
                placeholder="Enter expiryMonth"
                onChange={this.onChange}
                value={customerCreditCardData.expiryMonth}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>ExpiryYear</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="expiryYear"
                type="text"
                placeholder="Enter expiryYear"
                onChange={this.onChange}
                value={customerCreditCardData.expiryYear}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>
          </Row>

          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Address1</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="address1"
                type="text"
                placeholder="Enter Address"
                onChange={this.onAddressChange}
                value={addressData.address1}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Address2</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="address2"
                type="text"
                placeholder="Enter Address2"
                onChange={this.onAddressChange}
                value={addressData.address2}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>City</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onCityCreditCardChange}
                ref={this.cityRef}
                name="city"
                placeholder="city"
                value={addressData.city}
                lookupRequired={true}
                lookupHandler={this.state.cityLookupHandler}
                enterKeyEventHandler={this.cityCreditCardEnterKeyEvent}
                autoCompleteListData={
                  this.props.cityPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCityList}
                showAutoCompleteList={this.props.showAutoCompleteCityList}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>State</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onStateCreditCardChange}
                ref={this.stateRef}
                name="state"
                placeholder="state"
                value={addressData.state}
                lookupRequired={true}
                lookupHandler={this.state.stateLookupHandler}
                enterKeyEventHandler={this.stateCreditCardEnterKeyEvent}
                autoCompleteListData={
                  this.props.statePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteStateList}
                showAutoCompleteList={this.props.showAutoCompleteStateList}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Country</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.onCountryCodeCreditCardChange}
                ref={this.countryRef}
                name="country"
                placeholder="country"
                value={addressData.country}
                lookupRequired={true}
                lookupHandler={this.state.countryLookupHandler}
                enterKeyEventHandler={this.countryCodeCreditCardEnterKeyEvent}
                autoCompleteListData={
                  this.props.countryCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteCountryCodeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteCountryCodeList
                }
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Zip</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="zip"
                type="text"
                placeholder="Enter Zip"
                onChange={this.onAddressChange}
                value={addressData.zip}
                disabled={isDisabledFields}
              />{" "}
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>ContactPerson</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="contactPerson"
                type="text"
                placeholder="Enter ContactPerson"
                onChange={this.onAddressChange}
                value={addressData.contactPerson}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Mobile</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="mobilePhone"
                type="text"
                placeholder="Enter Mobile#"
                onChange={this.onAddressChange}
                value={addressData.mobilePhone}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Phone1</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="phone1"
                type="text"
                placeholder="Enter Phone#"
                onChange={this.onAddressChange}
                value={addressData.phone1}
                disabled={isDisabledFields}
              />{" "}
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>Email</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="email"
                type="text"
                placeholder="Enter Email"
                onChange={this.onAddressChange}
                value={addressData.email}
                disabled={isDisabledFields}
              />{" "}
            </Col>

            <Col sm="1">
              <FormLabel>Remarks</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <textarea
                cols={58}
                rows={3}
                name="remarks"
                onChange={this.onChange}
                value={customerCreditCardData.remarks}
                disabled={isDisabledFields}
              />
            </Col>
          </Row>
          <Row className="d-flex justify-content-center">
            <Col sm="4">
              <Button
                className="addToButton"
                onClick={(e) => this.closeCustomerCreditCardEntryForm(e)}
              >
                {" "}
                Back{" "}
              </Button>
            </Col>
          </Row>
          <br />
        </div>
      </div>
    );
  }
}

class CustomerFabricMappingListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      pageList: new PageListBean(),
    };
  }

  editFabricStyle = (code) => {
    this.props.editFabricStyle(code);
  };

  handleChange = (e) => { };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "FabricStyle",
        "fabricStyleCode",
        0,
        true,
        this.editFabricStyle
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "StyleRefCode",
        "customerStyleReferenceCode"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "StyleRefDesc",
        "customerStyleReferenceName"
      )
    );

    return columnList;
  };

  render() {
    let fabricMappingList = this.props.customerFabricMappingList;
    return (
      <div>
        <EditableDataGrid
          columnsList={this.columnDefinitions()}
          dataList={fabricMappingList}
        // isLoading={isLoading}
        />
      </div>
    );
  }
}

class CustomerFabricMappingEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      showAutoCompleteFabricCodeList: true,
      fabricPageListForAutoCompleteList: new Array(),
      showHide: this.props.showHide,
      customerFabricMappingData: this.props.customerFabricMappingData,
      customerFabricColorMappingData:
        new CustomerFabricStyleColorReferenceBean(),
      fabricMappingColorData: new CustomerFabricStyleColorReferenceBean(),
    };

    this.fabricRef = React.createRef();
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setFocus();
  }
  setFocus = () => {
    this.fabricRef.current.focus();
  };
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      "FabricStyle"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  componentDidUpdate() {
    //
  }
  onFabricCodeMappingChange = (e) => {
    this.setState({
      fabricStyleCode: "",
      isAllowRead: false,
    });
    let fabricStyleCode = e.target.value.toUpperCase();

    let tempFabricLineData = this.state.customerFabricMappingData;
    this.state.showAutoCompleteFabricCodeList = true;
    let showAutoCompleteFabricCodeList =
      this.state.showAutoCompleteFabricCodeList;

    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricCodeList = false;
      let showAutoCompleteFabricCodeList =
        this.state.showAutoCompleteFabricCodeList;
      let tempFabricLineData = this.state.customerFabricMappingData;
      tempFabricLineData.fabricStyleCode = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteFabricCodeList: showAutoCompleteFabricCodeList,
        customerFabricMappingData: tempFabricLineData,
        fabricPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteFabricCodeList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);

      //return;
    }
    tempFabricLineData[e.target.name] = e.target.value.toUpperCase();

    this.setState({
      customerFabricMappingData: tempFabricLineData,
      // fabricStyleCode: fabricStyleCode,
      // isAllowRead: false,
    });
    tempFabricLineData[e.target.name] = e.target.value;

    this.setState({ customerFabricMappingData: tempFabricLineData });

    this.readandsetFabricStyleDetail(fabricStyleCode);

    //this.readandsetFabricStyleDetail(fabricStyleCode);
    // this.initLookupHandlers();
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    // input.isLoadChildren = true;
    // this.setState({ isFabricStyleDataLoding: true });
    if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
      FabricStyleService.getActiveFabricStylesForAutoComplete(
        input,
        this.readByFabricCodeResponse,
        this.readByFabricCodeResponseError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }

    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readByFabricCodeResponseError = (error) => {
    ShowError("Error : ", error);
  };

  fabricenterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    let tempFabricLineData = this.state.customerFabricMappingData;
    tempFabricLineData[e.target.name] = e.target.value;

    this.setState({ customerFabricMappingData: tempFabricLineData });
    this.readandsetFabricStyleDetail(e.target.value);

    this.setState({
      // fabricStyleCode: fabricStyleCode,
      fabricPageListForAutoCompleteList: new Array(),
      // showAutoCompleteFabricCodeList: showAutoCompleteFabricCodeList,
    });
  };
  displayAutoCompleteFabricCodeList = (showAutoCompleteFabricCodeList) => {
    this.setState({
      showAutoCompleteFabricCodeList: showAutoCompleteFabricCodeList,
    });
  };
  showColorList = (colorList) => {
    let customerFabricMappingData = this.state.customerFabricMappingData;
    let fabricMappingColorList = new Array();
    for (let list of colorList) {
      let colorBean = new CustomerFabricStyleColorReferenceBean();
      colorBean.companyCode = this.companyCode;
      colorBean.customerCode = customerFabricMappingData.customerCode;
      colorBean.fabricStyleCode = list.fabricStyleCode;
      colorBean.fabricStyleColorCode = list.fabricStyleColorCode;
      colorBean.fabricStyleColorName = list.fabricStyleColorName;
      fabricMappingColorList.push(colorBean);
    }
    customerFabricMappingData.customerFabricStyleColorReferences =
      fabricMappingColorList;
    this.setState({ customerFabricMappingData: customerFabricMappingData });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let fabricStyle = response.data.fabricStyle;

    if (!isEmpty(fabricStyle) && fabricStyle != null) {
      this.showColorList(fabricStyle.colors);
    }
  };
  readandsetFabricStyleDetailError = (error) => {
    ShowError("Error : ", error);
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
      FabricStyleService.readFabricStyle(
        input,
        this.readandsetFabricStyleDetailResponse,
        this.readandsetFabricStyleDetailError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let temp_fabricdata = this.props.customerFabricMappingData;
    temp_fabricdata[e.target.name] = e.target.value;
    this.setState({
      customerFabricMappingData: temp_fabricdata,
    });
  };
  closeCustomerFabricMappingEntryForm = (e) => {
    if (e.detail === 1) this.props.closeCustomerFabricMappingEntryForm();
  };
  colorsOnChange = (e, rowData) => {
    let fabricData = this.state.customerFabricMappingData;
    fabricData.customerFabricStyleColorReferences.map((line) => {
      if (line.fabricStyleColorCode === rowData.fabricStyleColorCode) {
        line[e.target.name] = e.target.value;
      }
    });
    this.setState({ customerFabricMappingData: fabricData });
  };
  updateColorData = () => {
    let colorData = this.state.customerFabricColorMappingData;
    let customerFabricMappingData = this.state.customerFabricMappingData;
    let fabricData = this.state.customerFabricMappingData;
    fabricData.customerFabricStyleColorReferences.map((line) => {
      if (line.fabricStyleColorCode === colorData.fabricStyleColorCode) {
        line.customerStyleColorReferenceCode =
          colorData.customerStyleColorReferenceCode;
        line.customerStyleColorReferenceName =
          colorData.customerStyleColorReferenceName;
      }
    });
    this.setState({ customerFabricMappingData: fabricData });
  };
  colorOnClick = (val, rowData) => {
    this.setState({ customerFabricColorMappingData: rowData });
  };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "ColorCode",
        "fabricStyleColorCode",
        0,
        true,
        this.colorOnClick
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "ColorRefCode",
        "customerStyleColorReferenceCode"
      )
    );
    return columnList;
  };
  syncColor = (e) => {
    if (e.detail === 1) {
      let customerFabricMappingData = this.props.customerFabricMappingData;
      let mappingData = new RestCustomerEntityRequest();
      mappingData.companyCode = this.companyCode;
      mappingData.code = customerFabricMappingData.customerCode;
      mappingData.entityCode = customerFabricMappingData.fabricStyleCode;
      if (SecurityAccessManager.CustomerMaintenance_IsAccessible()) {
        CustomerService.syncCustomerFabricStyleReferenceBean(
          mappingData,
          this.syncCustomerResponse,
          this.syncCustomerError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  syncCustomerResponse = (response) => { };
  syncCustomerError = (error) => {
    ShowError("Error :" + error);
  };
  render() {
    let customerFabricMappingData = this.props.customerFabricMappingData;
    let customerFabricColorMappingData =
      this.state.customerFabricColorMappingData;
    let fabricColorList =
      customerFabricMappingData.customerFabricStyleColorReferences;
    let isDisabledFields = this.props.isDisabledFields;
    return (
      <div>
        <div className="header_div col-md-12 col-lg-12">
          <Row>
            <Col sm="1">
              <FormLabel>FabricStyle</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.fabricRef}
                name="fabricStyleCode"
                onChange={this.onFabricCodeMappingChange}
                value={customerFabricMappingData.fabricStyleCode}
                lookupRequired={true}
                lookupHandler={this.state.fabricLookupHandler}
                disabled={this.props.isDisableNodeFields}
                enterKeyEventHandler={this.fabricenterKeyEventHandler}
                autoCompleteListData={
                  this.state.fabricPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteFabricCodeList}
                showAutoCompleteList={this.state.showAutoCompleteFabricCodeList}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="2">
              <FormLabel>FabricStyle RefCode</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="customerStyleReferenceCode"
                type="text"
                onChange={this.onChange}
                value={customerFabricMappingData.customerStyleReferenceCode}
                disabled={isDisabledFields}
              />{" "}
            </Col>

            <Col sm="2">
              <FormLabel>FabricStyle RefName</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="customerStyleReferenceName"
                type="text"
                onChange={this.onChange}
                value={customerFabricMappingData.customerStyleReferenceName}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
        </div>
        <div className="header_div col-md-12 col-lg-12">
          <Row>
            <Col sm="3">
              <FormLabel>Customer FabricStyleColor Detail</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <Button size="sm" onClick={(e) => this.syncColor(e)}>
                {" "}
                Sync Color{" "}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col sm="7">
              <Table>
                <thead>
                  <th>Color</th>
                  <th>Color Ref Code</th>
                </thead>
                {fabricColorList != null && (
                  <tbody>
                    {fabricColorList.map((list, index) => (
                      <tr key={index}>
                        <td className="customer_color_width">
                          {list.fabricStyleColorCode}
                        </td>
                        <td className="customer_color_width">
                          <InputTextbox
                            type="text"
                            name="customerStyleColorReferenceCode"
                            onChange={(e) => this.colorsOnChange(e, list)}
                            value={list.customerStyleColorReferenceCode}
                            disabled={isDisabledFields}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </Table>
            </Col>
          </Row>
          <Row className="d-flex justify-content-center">
            <Col sm="4">
              <Button
                className="addToButton"
                onClick={(e) => this.closeCustomerFabricMappingEntryForm(e)}
              >
                {" "}
                Back{" "}
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
class AddressDetailsEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      countries: this.props.countries,
      states: this.props.states,
      cities: this.props.cities,
      cityLookupHandler: null,
      stateLookupHandler: null,
      countryLookupHandler: null,
    };
    this.countryRef = React.createRef();
    this.stateRef = React.createRef();
    this.cityRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.state.cities,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });
    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.state.states,
      "State"
    );
    this.setState({ stateLookupHandler: stateLookupHandler });
    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.state.countries,
      "Country"
    );
    this.setState({ countryLookupHandler: countryLookupHandler });
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  onCityChange = (e) => {
    this.props.onCityChange(e);
  };
  cityEnterKeyEvent = (e) => {
    this.props.cityEnterKeyEvent(e);
  };
  displayAutoCompleteCityList = (e) => {
    this.props.displayAutoCompleteCityList(e);
  };
  onStateChange = (e) => {
    this.props.onStateChange(e);
  };
  stateEnterKeyEvent = (e) => {
    this.props.stateEnterKeyEvent(e);
  };
  displayAutoCompleteStateList = (e) => {
    this.props.displayAutoCompleteStateList(e);
  };
  onCountryCodeChange = (e) => {
    this.props.onCountryCodeChange(e);
  };
  countryCodeEnterKeyEvent = (e) => {
    this.props.countryCodeEnterKeyEvent(e);
  };
  displayAutoCompleteCountryCodeList = (e) => {
    this.props.displayAutoCompleteCountryCodeList(e);
  };

  render() {
    let addressData = this.props.addressData;
    let customerData = this.props.customerData;
    let isDisabledFields = this.props.isDisabledFields;
    return (
      <div>
        <div className="header_div">
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Address</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="address1"
                type="text"
                placeholder="Enter Address"
                onChange={this.onChange}
                value={addressData.address1}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Address2</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="address2"
                type="text"
                placeholder="Enter Address"
                onChange={this.onChange}
                value={addressData.address2}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>City</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onCityChange}
                ref={this.cityRef}
                name="city"
                placeholder="city"
                value={addressData.city}
                lookupRequired={true}
                lookupHandler={this.state.cityLookupHandler}
                enterKeyEventHandler={this.cityEnterKeyEvent}
                autoCompleteListData={
                  this.props.cityPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCityList}
                showAutoCompleteList={this.props.showAutoCompleteCityList}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>State</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onStateChange}
                ref={this.stateRef}
                disabled={isDisabledFields}
                name="state"
                placeholder="state"
                value={addressData.state}
                lookupRequired={true}
                lookupHandler={this.state.stateLookupHandler}
                enterKeyEventHandler={this.stateEnterKeyEvent}
                autoCompleteListData={
                  this.props.statePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteStateList}
                showAutoCompleteList={this.props.showAutoCompleteStateList}
              ></InputTextbox>
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Country</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onCountryCodeChange}
                ref={this.countryRef}
                name="country"
                placeholder="country"
                value={addressData.country}
                lookupRequired={true}
                lookupHandler={this.state.countryLookupHandler}
                enterKeyEventHandler={this.countryCodeEnterKeyEvent}
                autoCompleteListData={
                  this.props.countryCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteCountryCodeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteCountryCodeList
                }
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Zip</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="zip"
                type="text"
                placeholder="Enter Zip"
                onChange={this.onChange}
                value={addressData.zip}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>ContactPerson</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="contactPerson"
                type="text"
                placeholder="Enter ContactPerson"
                onChange={this.onChange}
                value={addressData.contactPerson}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Mobile#</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="mobilePhone"
                type="text"
                placeholder="Enter Mobile#"
                onChange={this.onChange}
                value={addressData.mobilePhone}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Phone#</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="phone1"
                type="text"
                placeholder="Enter Phone#"
                onChange={this.onChange}
                value={addressData.phone1}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Phone2#</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="phone2"
                type="text"
                placeholder="Enter Phone#"
                onChange={this.onChange}
                value={addressData.phone2}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Website</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="website"
                type="text"
                placeholder="Enter Website"
                onChange={this.onChange}
                value={addressData.website}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Email#</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="email"
                type="text"
                placeholder="Enter Email"
                onChange={this.onChange}
                value={addressData.email}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Payable Email</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="payableEmail"
                type="text"
                placeholder="Enter payableEmail"
                onChange={this.onChange}
                value={customerData.payableEmail}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Purchasing Email</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="purchasingEmail"
                type="text"
                placeholder="Enter purchasingEmail"
                onChange={this.onChange}
                value={customerData.purchasingEmail}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Admin Email</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="adminEmail"
                type="text"
                placeholder="Enter adminEmail"
                onChange={this.onChange}
                value={customerData.adminEmail}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>General Email</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="generalEmail"
                type="text"
                placeholder="Enter generalEmail"
                onChange={this.onChange}
                value={customerData.generalEmail}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
class OptionsAmountEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }
  onChange = (e) => {
    this.props.onChange(e);
  };

  render() {
    let customerData = this.props.customerData;
    let isDisabledFields = this.props.isDisabledFields;
    return (
      <div className="header_div">
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>FreightChange </FormLabel>{" "}
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              name="freightChageFlag"
              onChange={this.onChange}
              checked={customerData.freightChageFlag}
              disabled={isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>PackingSlip </FormLabel>{" "}
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              name="packingSlipRequiredFlag"
              onChange={this.onChange}
              checked={customerData.packingSlipRequiredFlag}
              disabled={isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel> CityTax </FormLabel>{" "}
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              name="cityTaxRequiredFlag"
              onChange={this.onChange}
              checked={customerData.cityTaxRequiredFlag}
              disabled={isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Bulk Invoice </FormLabel>{" "}
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              name="bulkInvoiceFlag"
              onChange={this.onChange}
              checked={customerData.bulkInvoiceFlag}
              disabled={isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Invoice Edit</FormLabel>{" "}
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              name="invoiceEditFlag"
              onChange={this.onChange}
              checked={customerData.invoiceEditFlag}
              disabled={isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Inter Company </FormLabel>{" "}
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              name="interCompanyFlag"
              onChange={this.onChange}
              checked={customerData.interCompanyFlag}
              disabled={isDisabledFields}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Allocation Held</FormLabel>{" "}
          </Col>
          <Col sm="1">
            <InputCheckbox
              onChange={this.onChange}
              name="allocationHeldFlag"
              checked={customerData.allocationHeldFlag}
              disabled={isDisabledFields}
            ></InputCheckbox>
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Online Customer </FormLabel>{" "}
          </Col>
          <Col sm="1">
            <InputCheckbox
              onChange={this.onChange}
              name="onlineCustomerFlag"
              checked={customerData.onlineCustomerFlag}
              disabled={isDisabledFields}
            ></InputCheckbox>
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Sells Second </FormLabel>{" "}
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              name="sellSecondsFlag"
              onChange={this.onChange}
              checked={customerData.sellSecondsFlag}
              disabled={isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Cancel BackOrder</FormLabel>{" "}
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              name="cancelBackOrderFlag"
              onChange={this.onChange}
              checked={customerData.cancelBackOrderFlag}
              disabled={isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Price At Cost</FormLabel>{" "}
          </Col>
          <Col sm="1">
            <InputCheckbox
              onChange={this.onChange}
              name="priceAtCostFlag"
              checked={customerData.priceAtCostFlag}
              disabled={isDisabledFields}
            ></InputCheckbox>
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>EDI Customer</FormLabel>{" "}
          </Col>
          <Col sm="1">
            <InputCheckbox
              onChange={this.onChange}
              name="ediCustomerFlag"
              checked={customerData.ediCustomerFlag}
              disabled={isDisabledFields}
            ></InputCheckbox>
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Sample Sales </FormLabel>{" "}
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              name="sampleSalesFlag"
              onChange={this.onChange}
              checked={customerData.sampleSalesFlag}
              disabled={isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>International </FormLabel>{" "}
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              name="internationalFlag"
              onChange={this.onChange}
              checked={customerData.internationalFlag}
              disabled={isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Accept Returns </FormLabel>{" "}
          </Col>
          <Col sm="1">
            <InputCheckbox
              onChange={this.onChange}
              name="acceptReturnsFlag"
              checked={customerData.acceptReturnsFlag}
              disabled={isDisabledFields}
            ></InputCheckbox>
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Ship Complete </FormLabel>{" "}
          </Col>
          <Col sm="1">
            <InputCheckbox
              onChange={this.onChange}
              name="shipCompleteFlag"
              checked={customerData.shipCompleteFlag}
              disabled={isDisabledFields}
            ></InputCheckbox>
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Sales Tax </FormLabel>{" "}
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              name="salesTaxRequiredFlag"
              onChange={this.onChange}
              checked={customerData.salesTaxRequiredFlag}
              disabled={isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Sell Sold Out </FormLabel>{" "}
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              name="sellSoldOutFlag"
              onChange={this.onChange}
              checked={customerData.sellSoldOutFlag}
              disabled={isDisabledFields}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Coordination </FormLabel>{" "}
          </Col>
          <Col sm="1">
            <InputCheckbox
              onChange={this.onChange}
              name="coordinationFlag"
              checked={customerData.coordinationFlag}
              disabled={isDisabledFields}
            ></InputCheckbox>
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Po Required </FormLabel>{" "}
          </Col>
          <Col sm="1">
            <InputCheckbox
              onChange={this.onChange}
              name="poRequiredFlag"
              checked={customerData.poRequiredFlag}
              disabled={isDisabledFields}
            ></InputCheckbox>
          </Col>
        </Row>
      </div>
    );
  }
}
class CommentsEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  render() {
    let customerData = this.props.customerData;
    let isDisabledFields = this.props.isDisabledFields;
    return (
      <div className="header_div">
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Comments</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <textarea
              rows={3}
              cols={18}
              className="form-control"
              name="comments"
              type="text"
              placeholder="Enter Comments"
              onChange={this.onChange}
              value={customerData.comments}
              // disabled={isDisabledFields}
              readOnly={this.props.isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Instruction</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <textarea
              rows={3}
              cols={18}
              className="form-control"
              name="instructions"
              type="text"
              placeholder="Enter Instruction"
              onChange={this.onChange}
              value={customerData.instructions}
              // disabled={isDisabledFields}
              readOnly={this.props.isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Warning Notes</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <textarea
              rows={3}
              cols={18}
              className="form-control"
              name="warningNotes"
              type="text"
              placeholder="Enter WarningNotes"
              onChange={this.onChange}
              value={customerData.warningNotes}
              // disabled={isDisabledFields}
              readOnly={this.props.isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Customer Remarks</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <textarea
              rows={3}
              cols={18}
              className="form-control"
              name="customerRemarks"
              type="text"
              placeholder="Enter customerRemarks"
              onChange={this.onChange}
              value={customerData.customerRemarks}
              // disabled={isDisabledFields}
              readOnly={this.props.isDisabledFields}
            />{" "}
          </Col>
        </Row>
      </div>
    );
  }
}

class CustomerServiceForm extends React.Component {
  render() {
    const serviceData = this.props.serviceData;
    const service_List = this.props.service_List;
    return (
      <div className="header_div  col-md-12 col-lg-12">
        <div>
          <div className="div_Custom_2">
            <Table id="fabrics_tables_default">
              <thead>
                <tr>
                  <th>Service</th>
                  <th>Customer</th>
                  <th>UOMCode</th>
                  <th>Price</th>
                  <th>Quantity</th>
                  {/* <th>Amount</th> */}
                  <th></th>
                </tr>
              </thead>
              {service_List != null ? (
                <tbody>
                  {service_List.map((ln, index) => (
                    <tr key={index}>
                      <td className="hyperLinkText">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.props.editService(e, ln.code, ln)
                          }
                        >
                          {ln.code}
                        </Button>
                      </td>
                      <td>{ln.customerCode}</td>
                      <td>{ln.uomCode}</td>
                      <td className="text-right"> {ln.price}</td>
                      <td className="text-right">{ln.quantity}</td>
                      {/* <td className="text-right">{ln.amount}</td> */}
                      <td>
                        {!ln.isFetched ? (
                          <Button
                            size="sm"
                            onClick={(e) =>
                              this.props.deleteService(e, ln.code, ln)
                            }
                          >
                            <DeleteIcon />
                          </Button>
                        ) : null}
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : null}
            </Table>
            {service_List.length != 0 ? null : (
              <div className="no_Data">{"NO DATA"}</div>
            )}
          </div>
        </div>
        <Row>
          <Col sm="1">
            <FormLabel>CompanyCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={serviceData.companyCode}
              disabled={true}
            ></InputTextbox>
          </Col>
          <Col sm="1">
            <FormLabel>Service#</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.props.onServiceCodeChange}
              name="code"
              value={serviceData.code}
              placeholder="service"
              lookupRequired={true}
              lookupHandler={this.props.serviceLookupHandler}
              enterKeyEventHandler={this.props.serviceEnterKeyEventHandler}
              autoCompleteListData={
                this.props.servicePageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.props.displayAutoCompleteServiceList
              }
              showAutoCompleteList={this.props.isShowAutoCompleteServiceList}
              isMandatory={true}
              disabled={this.props.isDisabledFields}
            ></InputTextbox>
          </Col>
          <Col sm="1">
            <FormLabel>ServiceName</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={serviceData.description}
              disabled={true}
            ></InputTextbox>
          </Col>
          <Col sm="1">
            <FormLabel>Price</FormLabel>
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="price"
              value={serviceData.price}
              // isMandatory={true}
              onChange={this.props.onServiceChange}
              decimalScale={2}
              className="qty_input text-right summary_input"
              disabled={this.props.isDisabledFields}
            ></NumberFormatInputbox>
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Quantity</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="quantity"
              value={serviceData.quantity}
              // isMandatory={true}
              onChange={this.props.onServiceChange}
              disabled={true}
            ></InputTextbox>
          </Col>
          {/* <Col sm="1">
            <FormLabel>Amount</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="amount"
              value={serviceData.amount}
              // isMandatory={true}
              onChange={this.props.onServiceChange}
            ></InputTextbox>
          </Col> */}
          <Col sm="1">
            <FormLabel>UomCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={serviceData.uomCode}
              disabled={true}
            ></InputTextbox>
          </Col>
          <Col sm="1">
            <FormLabel>IsActive</FormLabel>
          </Col>
          <Col sm="2">
            <InputCheckbox
              checked={serviceData.isActive}
              disabled={true}
            ></InputCheckbox>
          </Col>
        </Row>
        <div className="button-flex">
          <Button
            id="fabric_Add_Button"
            className="enterFocus"
            size="sm1"
            bssize="large"
            onClick={(e) => this.props.saveService(e)}
            disabled={this.props.isDisabledFields}
          >
            Add / Update
          </Button>

          <Button
            id="fabric_Add_Button"
            className="enterFocus"
            size="sm1"
            bssize="large"
            onClick={(e) => this.props.clearService(e)}
            disabled={this.props.isDisabledFields}
          >
            Clear
          </Button>
        </div>
      </div>
    );
  }
}
class CustomerSalesDetails extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.colorCodeRef = React.createRef();
    this.state = {
      customerData: this.props.customerData,
      criteria: new SalesAndPurchaseInquiryCriteriaBean(),
      error_list: [],
      inquiryDataList: [],
      isShowAlert: false,
      alertMessage: "",
      success_list: [],
      moduleForPopup: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowFabricStyleModule: false,

      fabricLookupHandler: null,

      colorPageListForAutoCompleteList: new Array(),
      showAutoCompleteColorList: null,
      colorLookupHandler: null,
      colors: [],
      isShowPurchaseReceiptModule: false,
      isShowPurchaseModule: false,
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: false,
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    let colors = attribute_cache.colors;
    if (colors != null || colors != undefined) {
      colors.map((attr) => {
        this.state.colors.push(attr);
      });
    }

    this.initLookupHandlers();
    this.loadPage();
  }
  initLookupHandlers = () => {
    let colors = [];
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });

    const customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "customerCode"
    );
    this.setState({
      customerLookupHandler: customerLookupHandler,
    });
    let colorLookupHandler = new GenericAttributeLookupHandler(
      this.state.colors,
      "fabricStyleColorCode"
    );
    this.setState({ colorLookupHandler: colorLookupHandler });
    // let vendorLookupHandler = new VendorLookupHandler(
    //   this.companyCode,
    //   "Vendor"
    // );
    // this.setState({ vendorLookupHandler: vendorLookupHandler });
  };
  readFabricStyleResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      criteria.fabricStylesCode = fabricStyle.code;
      this.setState({ fabricStyleData: fabricStyle });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readFabricStyle = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readFabricStyleResponse,
      this.errorCallBack
    );
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        criteria: criteria,
        fabricPageListForAutoCompleteList: suggestion,
        // isShowColorLookup: false,
        // colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = [];
        if (!isEmptyArray(fabricStyle.colors)) {
          colors = fabricStyle.colors;
        }
        let finalColorList = [];

        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            criteria: criteria,
            colorLookupHandler: colorLookupHandler,

          });
        }

      }
    }
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readandsetFabricStyleDetail(fabricStyleCode);
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteFabricList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteFabricList });
  };
  onColorCodeChange = (e) => {
    let fabricStyleColorCode = e.target.value;
    this.state.showAutoCompleteColorList = true;
    let temp_fabricStyledata = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteColorList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.showAutoCompleteColorList = false;
      let showAutoCompleteList = this.state.showAutoCompleteColorList;
      let color_Data = this.state.criteria;
      color_Data.fabricStyleColorCode = "";
      // color_Data.fabricStyleColorName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteColorList: showAutoCompleteList,
        criteria: color_Data,
        colorPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fabricStyleColorCode !== "") {
      this.readColorCodeBySearchString(fabricStyleColorCode);
    }
    if (e.target.name == "fabricStyleColorCode") {
      temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
      let color_Data_List = this.state.colors;
      color_Data_List.map((color_Data) => {
        if (color_Data.code == e.target.value) {
          temp_fabricStyledata["fabricStyleColorCode"] = color_Data.code;
          this.state.showAutoCompleteColorList = false;
          let showAutoCompleteList = this.state.showAutoCompleteColorList;
          this.setState({
            showAutoCompleteColorList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ criteria: temp_fabricStyledata });
  };
  readColorCodeBySearchString(searchString) {
    let colorCodeData = this.state.colors;
    let simpleAutoCompleteList = new Array();
    if (colorCodeData.length > 0 && colorCodeData != null) {
      colorCodeData.map((colorCodeDatas) => {
        let simpleItemBean = {
          code: colorCodeDatas.code,
          description: colorCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteColorCodeLists) =>
        simpleAutoCompleteColorCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      colorPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  colorEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.criteria;
    let fabricStyleColorCode = e.target.value;
    temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
    let color_Data_List = this.state.colors;
    let colorCodeBean = null;
    color_Data_List.map((color_Data) => {
      if (color_Data.code == e.target.value) {
        colorCodeBean = color_Data;
      }
    });
    if (!isEmpty(colorCodeBean)) {
      let temp_fabricStyledata = this.state.criteria;
      temp_fabricStyledata.fabricStyleColorCode = colorCodeBean.code;
      // temp_fabricStyledata.fabricStyleColorName = colorCodeBean.description;
      this.setState({
        criteria: temp_fabricStyledata,
        colorPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteColorList = (showAutoCompleteColorList) => {
    this.setState({
      showAutoCompleteColorList: showAutoCompleteColorList,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = () => {
    let customerData = this.state.customerData;
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.customerCode = customerData.code;
    criteria.customerName = customerData.description;
    criteria.resultType = 0;
    // criteria.isSummary = true;
    // if (this.props.is3PL) {
    //   criteria.logisticCustomerCode = fabricStyleData.customerCode;
    // }
    this.loadSalesAndPurchaseDetailsInquiryList(criteria);
  };
  fetchPurchaseSales = () => {
    let criteria = this.state.criteria;
    let customerData = this.state.customerData;
    criteria.companyCode = this.companyCode;
    criteria.customerCode = customerData.code;
    criteria.customerName = customerData.description;
    criteria.resultType = 0;
    this.loadSalesAndPurchaseDetailsInquiryList(criteria);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
  }
  loadSalesAndPurchaseDetailsInquiryList = (criteria) => {
    // if (SecurityAccessManager.SkuBatchInventoryInquiry_IsAccessible()) {
    ReportService.inquireSalesAndPurchaseDetails(
      criteria,
      this.loadSalesAndPurchasePageResponse,
      this.errorCallBack
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  loadSalesAndPurchasePageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.resultBean != null) {
      let customerSalesDataList = [];
      let inquiryDataList = response.data.resultBean;
      if (!isEmptyArray(response.data.resultBean.infos)) {
        customerSalesDataList = response.data.resultBean.infos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: customerSalesDataList,
        isCollapsible_open: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        inquiryData: inquiryDataList,

      });
      //  this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });

  };

  inquiryInvoiceColumns = () => {
    const columns = new Array();
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails(
    //       "Customer",
    //       "customerCode",
    //       true
    //     )

    //     .setStyleDetails("left", "10", "", "wt-4", "wt-4")

    //   //.setClickDetails(true, false, this.viewFabricModule, null)
    // );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("CustomerName", "customerName", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyle", "fabricStyleCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyleName", "fabricStyleName", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceDate", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true,)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Quantity", "quantity", true, true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );


    return columns;

  };
  resetPurchaseSales = () => {
    let customerData = this.state.customerData;
    let criteria = new SalesAndPurchaseInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = customerData.code;
    criteria.resultType = 0;
    criteria.fabricStyleColorCode = "";
    criteria.vendorCode = "";
    this.setState({ criteria: criteria, isDisableFilterFields: false, });
    this.loadSalesAndPurchaseDetailsInquiryList(criteria);
  }
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,

      });

    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      moduleForPopup: [],
    });
  };

  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  render() {
    let customerData = this.state.customerData;
    let inquiryDataList = this.state.inquiryDataList;

    let criteria = this.state.criteria;
    return (
      <div>
        <Row>

          <Col className="align-items-left" sm="1">
            <FormLabel>Customer</FormLabel>

          </Col>
          <Col sm="2">
            <InputTextbox
              name="code"
              readOnly={true}
              value={customerData.code}
              disabled={true}
            />{" "}
          </Col>{" "}
          <Col sm="3">
            <InputTextbox
              name="description"
              readOnly={true}
              value={customerData.description}
              disabled={true}
            />{" "}
          </Col>

          <Col sm="1">


            <FormLabel>FabricStyle</FormLabel>

          </Col>
          <Col sm="2">
            <InputTextbox
              showCriteriaDialog={true}
              // ref={fabricCodeRef}
              name="fabricStyleCode"
              onChange={this.fabricCodeOnChange}
              value={criteria.fabricStyleCode}
              lookupRequired={true}
              lookupHandler={this.state.fabricLookupHandler}
              enterKeyEventHandler={this.fabricEnterKeyEventHandler}
              autoCompleteListData={this.state.fabricPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteFabricList}
              showAutoCompleteList={this.state.showAutoCompleteFabricList}
              isMandatory={true}
            />
          </Col>
          <Col sm="3">
            <InputTextbox
              name="fabricStyleName"
              onChange={this.onChange}
              value={criteria.fabricStyleName}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Color</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              showCriteriaDialog={true}
              // ref={fabricCodeRef}
              name="fabricStyleColorCode"
              onChange={this.onColorCodeChange}
              value={criteria.fabricStyleColorCode}
              lookupRequired={true}
              lookupHandler={this.state.colorLookupHandler}
              enterKeyEventHandler={this.colorEnterKeyEvent}
              autoCompleteListData={this.state.colorPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteColorList}
              showAutoCompleteList={this.state.showAutoCompleteColorList}

              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <Button
              id="fabric_Add_Button"
              className="enterFocus"
              size="sm1"
              bssize="large"
              onClick={(e) => this.fetchPurchaseSales(e)}
            //  disabled={isDisabledFields}
            >
              {" "}
              Fetch{" "}
            </Button>
          </Col>{" "}
          <Col sm="1">
            <Button
              id="fabric_Add_Button"
              className="enterFocus"
              size="sm1"
              bssize="large"
              onClick={(e) => this.resetPurchaseSales(e)}
            // disabled={this.state.isResetCriteria}
            >
              {" "}
              Reset{" "}
            </Button>
          </Col>{" "}
        </Row>
        <div>
          {this.state.isInquiryDatasFound && (

            <div className="mt-3">
              <CustomTable
                data={inquiryDataList}
                columns={this.inquiryInvoiceColumns()}
                // isEnableSpan={true}
                label={"Inquiry Data List"}
              />
            </div>
          )}


        </div>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
class CustomerMaintenanceModule extends React.Component {
  constructor(props) {
    super(props);

    this.moduleRef = React.createRef();
  }
  render() {
    return (
      <div id="moduleContainer" className="module_container">
        <div className="App">
          <CustomerList {...this.props} name="" ref={this.moduleRef} /> <br />
        </div>
      </div>
    );
  }
}

export default CustomerMaintenanceModule;
